
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c4yuT", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    var _$breadcrumbTypes_8 = [
        'navigation',
        'request',
        'process',
        'log',
        'user',
        'state',
        'error',
        'manual'
    ];
    // Array#reduce
    var _$reduce_17 = function(arr, fn, accum) {
        var val = accum;
        for(var i = 0, len = arr.length; i < len; i++)val = fn(val, arr[i], i, arr);
        return val;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#filter
    var _$filter_12 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return !fn(item, i, arr) ? accum : accum.concat(item);
        }, []);
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#includes
    var _$includes_13 = function(arr, x) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum === true || item === x;
        }, false);
    };
    // Array#isArray
    var _$isArray_14 = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    /* eslint-disable-next-line no-prototype-builtins */ var _hasDontEnumBug = !({
        toString: null
    }).propertyIsEnumerable('toString');
    var _dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    // Object#keys
    var _$keys_15 = function(obj) {
        // stripped down version of
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
        var result = [];
        var prop;
        for(prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
        if (!_hasDontEnumBug) return result;
        for(var i = 0, len = _dontEnums.length; i < len; i++)if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
        return result;
    };
    var _$intRange_24 = function(min, max) {
        if (min === void 0) min = 1;
        if (max === void 0) max = Infinity;
        return function(value) {
            return typeof value === 'number' && parseInt('' + value, 10) === value && value >= min && value <= max;
        };
    }; /* removed: var _$filter_12 = require('../es-utils/filter'); */ 
    var _$listOfFunctions_25 = function(value) {
        return typeof value === 'function' || _$isArray_14(value) && _$filter_12(value, function(f) {
            return typeof f === 'function';
        }).length === value.length;
    };
    var _$stringWithLength_26 = function(value) {
        return typeof value === 'string' && !!value.length;
    };
    var _$config_5 = {}; /* removed: var _$filter_12 = require('./lib/es-utils/filter'); */ 
    var defaultErrorTypes = function() {
        return {
            unhandledExceptions: true,
            unhandledRejections: true
        };
    };
    _$config_5.schema = {
        apiKey: {
            defaultValue: function() {
                return null;
            },
            message: 'is required',
            validate: _$stringWithLength_26
        },
        appVersion: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be a string',
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        appType: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be a string',
            validate: function(value) {
                return value === undefined || _$stringWithLength_26(value);
            }
        },
        autoDetectErrors: {
            defaultValue: function() {
                return true;
            },
            message: 'should be true|false',
            validate: function(value) {
                return value === true || value === false;
            }
        },
        enabledErrorTypes: {
            defaultValue: function() {
                return defaultErrorTypes();
            },
            message: 'should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }',
            allowPartialObject: true,
            validate: function(value) {
                // ensure we have an object
                if (typeof value !== 'object' || !value) return false;
                var providedKeys = _$keys_15(value);
                var defaultKeys = _$keys_15(defaultErrorTypes());
                // ensure it only has a subset of the allowed keys
                if (_$filter_12(providedKeys, function(k) {
                    return _$includes_13(defaultKeys, k);
                }).length < providedKeys.length) return false;
                // ensure all of the values are boolean
                if (_$filter_12(_$keys_15(value), function(k) {
                    return typeof value[k] !== 'boolean';
                }).length > 0) return false;
                return true;
            }
        },
        onError: {
            defaultValue: function() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_25
        },
        onSession: {
            defaultValue: function() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_25
        },
        onBreadcrumb: {
            defaultValue: function() {
                return [];
            },
            message: 'should be a function or array of functions',
            validate: _$listOfFunctions_25
        },
        endpoints: {
            defaultValue: function() {
                return {
                    notify: 'https://notify.bugsnag.com',
                    sessions: 'https://sessions.bugsnag.com'
                };
            },
            message: 'should be an object containing endpoint URLs { notify, sessions }',
            validate: function(val) {
                return(// first, ensure it's an object
                val && typeof val === 'object' && // notify and sessions must always be set
                _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) && // ensure no keys other than notify/session are set on endpoints object
                _$filter_12(_$keys_15(val), function(k) {
                    return !_$includes_13([
                        'notify',
                        'sessions'
                    ], k);
                }).length === 0);
            }
        },
        autoTrackSessions: {
            defaultValue: function(val) {
                return true;
            },
            message: 'should be true|false',
            validate: function(val) {
                return val === true || val === false;
            }
        },
        enabledReleaseStages: {
            defaultValue: function() {
                return null;
            },
            message: 'should be an array of strings',
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$filter_12(value, function(f) {
                    return typeof f === 'string';
                }).length === value.length;
            }
        },
        releaseStage: {
            defaultValue: function() {
                return 'production';
            },
            message: 'should be a string',
            validate: function(value) {
                return typeof value === 'string' && value.length;
            }
        },
        maxBreadcrumbs: {
            defaultValue: function() {
                return 25;
            },
            message: "should be a number \u2264100",
            validate: function(value) {
                return _$intRange_24(0, 100)(value);
            }
        },
        enabledBreadcrumbTypes: {
            defaultValue: function() {
                return _$breadcrumbTypes_8;
            },
            message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(',') + ")",
            validate: function(value) {
                return value === null || _$isArray_14(value) && _$reduce_17(value, function(accum, maybeType) {
                    if (accum === false) return accum;
                    return _$includes_13(_$breadcrumbTypes_8, maybeType);
                }, true);
            }
        },
        context: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be a string',
            validate: function(value) {
                return value === undefined || typeof value === 'string';
            }
        },
        user: {
            defaultValue: function() {
                return {};
            },
            message: 'should be an object with { id, email, name } properties',
            validate: function(value) {
                return value === null || value && _$reduce_17(_$keys_15(value), function(accum, key) {
                    return accum && _$includes_13([
                        'id',
                        'email',
                        'name'
                    ], key);
                }, true);
            }
        },
        metadata: {
            defaultValue: function() {
                return {};
            },
            message: 'should be an object',
            validate: function(value) {
                return typeof value === 'object' && value !== null;
            }
        },
        logger: {
            defaultValue: function() {
                return undefined;
            },
            message: 'should be null or an object with methods { debug, info, warn, error }',
            validate: function(value) {
                return !value || value && _$reduce_17([
                    'debug',
                    'info',
                    'warn',
                    'error'
                ], function(accum, method) {
                    return accum && typeof value[method] === 'function';
                }, true);
            }
        },
        redactedKeys: {
            defaultValue: function() {
                return [
                    'password'
                ];
            },
            message: 'should be an array of strings|regexes',
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(s) {
                    return typeof s === 'string' || s && typeof s.test === 'function';
                }).length;
            }
        },
        plugins: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of plugin objects',
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(p) {
                    return p && typeof p === 'object' && typeof p.load === 'function';
                }).length;
            }
        },
        featureFlags: {
            defaultValue: function() {
                return [];
            },
            message: 'should be an array of objects that have a "name" property',
            validate: function(value) {
                return _$isArray_14(value) && value.length === _$filter_12(value, function(feature) {
                    return feature && typeof feature === 'object' && typeof feature.name === 'string';
                }).length;
            }
        }
    };
    // extends helper from babel
    // https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
    var _$assign_11 = function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }; /* removed: var _$reduce_17 = require('./reduce'); */ 
    // Array#map
    var _$map_16 = function(arr, fn) {
        return _$reduce_17(arr, function(accum, item, i, arr) {
            return accum.concat(fn(item, i, arr));
        }, []);
    };
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    var schema = _$config_5.schema; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _$config_1 = {
        releaseStage: _$assign_11({}, schema.releaseStage, {
            defaultValue: function() {
                if (/^localhost(:\d+)?$/.test(window.location.host)) return 'development';
                return 'production';
            }
        }),
        appType: _extends({}, schema.appType, {
            defaultValue: function() {
                return 'browser';
            }
        }),
        logger: _$assign_11({}, schema.logger, {
            defaultValue: function() {
                return(// set logger based on browser capability
                typeof console !== 'undefined' && typeof console.debug === 'function' ? getPrefixedConsole() : undefined);
            }
        })
    };
    var getPrefixedConsole = function() {
        var logger = {};
        var consoleLog = console.log;
        _$map_16([
            'debug',
            'info',
            'warn',
            'error'
        ], function(method) {
            var consoleMethod = console[method];
            logger[method] = typeof consoleMethod === 'function' ? consoleMethod.bind(console, '[bugsnag]') : consoleLog.bind(console, '[bugsnag]');
        });
        return logger;
    };
    var Breadcrumb = /*#__PURE__*/ function() {
        function Breadcrumb(message, metadata, type, timestamp) {
            if (timestamp === void 0) timestamp = new Date();
            this.type = type;
            this.message = message;
            this.metadata = metadata;
            this.timestamp = timestamp;
        }
        var _proto = Breadcrumb.prototype;
        _proto.toJSON = function toJSON() {
            return {
                type: this.type,
                name: this.message,
                timestamp: this.timestamp,
                metaData: this.metadata
            };
        };
        return Breadcrumb;
    }();
    var _$Breadcrumb_3 = Breadcrumb;
    var _$stackframe_34 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stackframe', [], factory);
        else if (typeof _$stackframe_34 === 'object') _$stackframe_34 = factory();
        else root.StackFrame = factory();
    })(this, function() {
        'use strict';
        function _isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        function _capitalize(str) {
            return str.charAt(0).toUpperCase() + str.substring(1);
        }
        function _getter(p) {
            return function() {
                return this[p];
            };
        }
        var booleanProps = [
            'isConstructor',
            'isEval',
            'isNative',
            'isToplevel'
        ];
        var numericProps = [
            'columnNumber',
            'lineNumber'
        ];
        var stringProps = [
            'fileName',
            'functionName',
            'source'
        ];
        var arrayProps = [
            'args'
        ];
        var props = booleanProps.concat(numericProps, stringProps, arrayProps);
        function StackFrame(obj) {
            if (obj instanceof Object) {
                for(var i = 0; i < props.length; i++)if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) this['set' + _capitalize(props[i])](obj[props[i]]);
            }
        }
        StackFrame.prototype = {
            getArgs: function() {
                return this.args;
            },
            setArgs: function(v) {
                if (Object.prototype.toString.call(v) !== '[object Array]') throw new TypeError('Args must be an Array');
                this.args = v;
            },
            getEvalOrigin: function() {
                return this.evalOrigin;
            },
            setEvalOrigin: function(v) {
                if (v instanceof StackFrame) this.evalOrigin = v;
                else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
                else throw new TypeError('Eval Origin must be an Object or StackFrame');
            },
            toString: function() {
                var functionName = this.getFunctionName() || '{anonymous}';
                var args = '(' + (this.getArgs() || []).join(',') + ')';
                var fileName = this.getFileName() ? '@' + this.getFileName() : '';
                var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
                var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
                return functionName + args + fileName + lineNumber + columnNumber;
            }
        };
        for(var i = 0; i < booleanProps.length; i++){
            StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
            StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function(p) {
                return function(v) {
                    this[p] = Boolean(v);
                };
            }(booleanProps[i]);
        }
        for(var j = 0; j < numericProps.length; j++){
            StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
            StackFrame.prototype['set' + _capitalize(numericProps[j])] = function(p) {
                return function(v) {
                    if (!_isNumber(v)) throw new TypeError(p + ' must be a Number');
                    this[p] = Number(v);
                };
            }(numericProps[j]);
        }
        for(var k = 0; k < stringProps.length; k++){
            StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
            StackFrame.prototype['set' + _capitalize(stringProps[k])] = function(p) {
                return function(v) {
                    this[p] = String(v);
                };
            }(stringProps[k]);
        }
        return StackFrame;
    });
    var _$errorStackParser_31 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('error-stack-parser', [
            'stackframe'
        ], factory);
        else if (typeof _$errorStackParser_31 === 'object') _$errorStackParser_31 = factory(_$stackframe_34);
        else root.ErrorStackParser = factory(root.StackFrame);
    })(this, function ErrorStackParser(StackFrame) {
        'use strict';
        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
        return {
            /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */ parse: function ErrorStackParser$$parse(error) {
                if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') return this.parseOpera(error);
                else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
                else if (error.stack) return this.parseFFOrSafari(error);
                else throw new Error('Cannot parse given Error object');
            },
            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                // Fail-fast but return locations like "(native)"
                if (urlLike.indexOf(':') === -1) return [
                    urlLike
                ];
                var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
                return [
                    parts[1],
                    parts[2] || undefined,
                    parts[3] || undefined
                ];
            },
            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    if (line.indexOf('(eval ') > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
                    var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(');
                    // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                    // case it has spaces in it, as the string is split on \s+ later on
                    var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);
                    // remove the parenthesized location from the line, if it was matched
                    sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
                    var tokens = sanitizedLine.split(/\s+/).slice(1);
                    // if a location was matched, pass it to extractLocation() otherwise pop the last token
                    var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                    var functionName = tokens.join(' ') || undefined;
                    var fileName = [
                        'eval',
                        '<anonymous>'
                    ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },
            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);
                return filtered.map(function(line) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    if (line.indexOf(' > eval') > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
                    if (line.indexOf('@') === -1 && line.indexOf(':') === -1) // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                    else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches = line.match(functionNameRegex);
                        var functionName = matches && matches[1] ? matches[1] : undefined;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },
            parseOpera: function ErrorStackParser$$parseOpera(e) {
                if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) return this.parseOpera9(e);
                else if (!e.stack) return this.parseOpera10(e);
                else return this.parseOpera11(e);
            },
            parseOpera9: function ErrorStackParser$$parseOpera9(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e.message.split('\n');
                var result = [];
                for(var i = 2, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            parseOpera10: function ErrorStackParser$$parseOpera10(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e.stacktrace.split('\n');
                var result = [];
                for(var i = 0, len = lines.length; i < len; i += 2){
                    var match = lineRE.exec(lines[i]);
                    if (match) result.push(new StackFrame({
                        functionName: match[3] || undefined,
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
                return result;
            },
            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);
                return filtered.map(function(line) {
                    var tokens = line.split('@');
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = tokens.shift() || '';
                    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
                    var argsRaw;
                    if (functionCall.match(/\(([^\)]*)\)/)) argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
                    var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    });
    var _$errorStackParser_10 = _$errorStackParser_31;
    var _$safeJsonStringify_30 = function(data, replacer, space, opts) {
        var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
        var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
        return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
    };
    var MAX_DEPTH = 20;
    var MAX_EDGES = 25000;
    var MIN_PRESERVED_DEPTH = 8;
    var REPLACEMENT_NODE = '...';
    function isError(o) {
        return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
    }
    function throwsMessage(err) {
        return '[Throws: ' + (err ? err.message : '?') + ']';
    }
    function find(haystack, needle) {
        for(var i = 0, len = haystack.length; i < len; i++){
            if (haystack[i] === needle) return true;
        }
        return false;
    }
    // returns true if the string `path` starts with any of the provided `paths`
    function isDescendent(paths, path) {
        for(var i = 0, len = paths.length; i < len; i++){
            if (path.indexOf(paths[i]) === 0) return true;
        }
        return false;
    }
    function shouldRedact(patterns, key) {
        for(var i = 0, len = patterns.length; i < len; i++){
            if (typeof patterns[i] === 'string' && patterns[i].toLowerCase() === key.toLowerCase()) return true;
            if (patterns[i] && typeof patterns[i].test === 'function' && patterns[i].test(key)) return true;
        }
        return false;
    }
    function __isArray_30(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    }
    function safelyGetProp(obj, prop) {
        try {
            return obj[prop];
        } catch (err) {
            return throwsMessage(err);
        }
    }
    function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
        var seen = []; // store references to objects we have seen before
        var edges = 0;
        function visit(obj, path) {
            function edgesExceeded() {
                return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
            }
            edges++;
            if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
            if (edgesExceeded()) return REPLACEMENT_NODE;
            if (obj === null || typeof obj !== 'object') return obj;
            if (find(seen, obj)) return '[Circular]';
            seen.push(obj);
            if (typeof obj.toJSON === 'function') try {
                // we're not going to count this as an edge because it
                // replaces the value of the currently visited object
                edges--;
                var fResult = visit(obj.toJSON(), path);
                seen.pop();
                return fResult;
            } catch (err) {
                return throwsMessage(err);
            }
            var er = isError(obj);
            if (er) {
                edges--;
                var eResult = visit({
                    name: obj.name,
                    message: obj.message
                }, path);
                seen.pop();
                return eResult;
            }
            if (__isArray_30(obj)) {
                var aResult = [];
                for(var i = 0, len = obj.length; i < len; i++){
                    if (edgesExceeded()) {
                        aResult.push(REPLACEMENT_NODE);
                        break;
                    }
                    aResult.push(visit(obj[i], path.concat('[]')));
                }
                seen.pop();
                return aResult;
            }
            var result = {};
            try {
                for(var prop in obj){
                    if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
                    if (isDescendent(redactedPaths, path.join('.')) && shouldRedact(redactedKeys, prop)) {
                        result[prop] = '[REDACTED]';
                        continue;
                    }
                    if (edgesExceeded()) {
                        result[prop] = REPLACEMENT_NODE;
                        break;
                    }
                    result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
                }
            } catch (e) {}
            seen.pop();
            return result;
        }
        return visit(obj, []);
    } /* removed: var _$map_16 = require('./es-utils/map'); */ 
    function add(existingFeatures, existingFeatureKeys, name, variant) {
        if (typeof name !== 'string') return;
        if (variant === undefined) variant = null;
        else if (variant !== null && typeof variant !== 'string') variant = _$safeJsonStringify_30(variant);
        var existingIndex = existingFeatureKeys[name];
        if (typeof existingIndex === 'number') {
            existingFeatures[existingIndex] = {
                name: name,
                variant: variant
            };
            return;
        }
        existingFeatures.push({
            name: name,
            variant: variant
        });
        existingFeatureKeys[name] = existingFeatures.length - 1;
    }
    function merge(existingFeatures, newFeatures, existingFeatureKeys) {
        if (!_$isArray_14(newFeatures)) return;
        for(var i = 0; i < newFeatures.length; ++i){
            var feature = newFeatures[i];
            if (feature === null || typeof feature !== 'object') continue;
            // 'add' will handle if 'name' doesn't exist & 'variant' is optional
            add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
        }
        return existingFeatures;
    }
    // convert feature flags from a map of 'name -> variant' into the format required
    // by the Bugsnag Event API:
    //   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]
    function toEventApi(featureFlags) {
        return _$map_16(_$filter_12(featureFlags, Boolean), function(_ref) {
            var name = _ref.name, variant = _ref.variant;
            var flag = {
                featureFlag: name
            };
            // don't add a 'variant' property unless there's actually a value
            if (typeof variant === 'string') flag.variant = variant;
            return flag;
        });
    }
    function clear(features, featuresIndex, name) {
        var existingIndex = featuresIndex[name];
        if (typeof existingIndex === 'number') {
            features[existingIndex] = null;
            delete featuresIndex[name];
        }
    }
    var _$featureFlagDelegate_18 = {
        add: add,
        clear: clear,
        merge: merge,
        toEventApi: toEventApi
    };
    // Given `err` which may be an error, does it have a stack property which is a string?
    var _$hasStack_19 = function(err) {
        return !!err && (!!err.stack || !!err.stacktrace || !!err['opera#sourceloc']) && typeof (err.stack || err.stacktrace || err['opera#sourceloc']) === 'string' && err.stack !== err.name + ": " + err.message;
    };
    /**
 * Expose `isError`.
 */ var _$isError_32 = __isError_32;
    /**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */ function __isError_32(value) {
        switch(Object.prototype.toString.call(value)){
            case '[object Error]':
                return true;
            case '[object Exception]':
                return true;
            case '[object DOMException]':
                return true;
            default:
                return value instanceof Error;
        }
    }
    var _$iserror_20 = _$isError_32; /* removed: var _$assign_11 = require('./es-utils/assign'); */ 
    var __add_22 = function(state, section, keyOrObj, maybeVal) {
        var _updates;
        if (!section) return;
        var updates;
        // addMetadata("section", null) -> clears section
        if (keyOrObj === null) return __clear_22(state, section);
        // normalise the two supported input types into object form
        if (typeof keyOrObj === 'object') updates = keyOrObj;
        if (typeof keyOrObj === 'string') updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates);
        // exit if we don't have an updates object at this point
        if (!updates) return;
        // preventing the __proto__ property from being used as a key
        if (section === '__proto__' || section === 'constructor' || section === 'prototype') return;
        // ensure a section with this name exists
        if (!state[section]) state[section] = {};
        // merge the updates with the existing section
        state[section] = _$assign_11({}, state[section], updates);
    };
    var get = function(state, section, key) {
        if (typeof section !== 'string') return undefined;
        if (!key) return state[section];
        if (state[section]) return state[section][key];
        return undefined;
    };
    var __clear_22 = function(state, section, key) {
        if (typeof section !== 'string') return;
        // clear an entire section
        if (!key) {
            delete state[section];
            return;
        }
        // preventing the __proto__ property from being used as a key
        if (section === '__proto__' || section === 'constructor' || section === 'prototype') return;
        // clear a single value from a section
        if (state[section]) delete state[section][key];
    };
    var _$metadataDelegate_22 = {
        add: __add_22,
        get: get,
        clear: __clear_22
    };
    var _$stackGenerator_33 = {};
    (function(root, factory) {
        'use strict';
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
        /* istanbul ignore next */ if (typeof define === 'function' && define.amd) define('stack-generator', [
            'stackframe'
        ], factory);
        else if (typeof _$stackGenerator_33 === 'object') _$stackGenerator_33 = factory(_$stackframe_34);
        else root.StackGenerator = factory(root.StackFrame);
    })(this, function(StackFrame) {
        return {
            backtrace: function StackGenerator$$backtrace(opts) {
                var stack = [];
                var maxStackSize = 10;
                if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') maxStackSize = opts.maxStackSize;
                var curr = arguments.callee;
                while(curr && stack.length < maxStackSize && curr['arguments']){
                    // Allow V8 optimizations
                    var args = new Array(curr['arguments'].length);
                    for(var i = 0; i < args.length; ++i)args[i] = curr['arguments'][i];
                    if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                        functionName: RegExp.$1 || undefined,
                        args: args
                    }));
                    else stack.push(new StackFrame({
                        args: args
                    }));
                    try {
                        curr = curr.caller;
                    } catch (e) {
                        break;
                    }
                }
                return stack;
            }
        };
    });
    function ___extends_6() {
        ___extends_6 = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return ___extends_6.apply(this, arguments);
    } /* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */ 
    var Event = /*#__PURE__*/ function() {
        function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
            if (stacktrace === void 0) stacktrace = [];
            if (handledState === void 0) handledState = defaultHandledState();
            this.apiKey = undefined;
            this.context = undefined;
            this.groupingHash = undefined;
            this.originalError = originalError;
            this._handledState = handledState;
            this.severity = this._handledState.severity;
            this.unhandled = this._handledState.unhandled;
            this.app = {};
            this.device = {};
            this.request = {};
            this.breadcrumbs = [];
            this.threads = [];
            this._metadata = {};
            this._features = [];
            this._featuresIndex = {};
            this._user = {};
            this._session = undefined;
            this._correlation = undefined;
            this.errors = [
                createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)
            ];
        // Flags.
        // Note these are not initialised unless they are used
        // to save unnecessary bytes in the browser bundle
        /* this.attemptImmediateDelivery, default: true */ }
        var _proto = Event.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        } /**
     * Associate this event with a specific trace. This is usually done automatically when
     * using bugsnag-js-performance, but can also be set manually if required.
     *
     * @param traceId the ID of the trace the event occurred within
     * @param spanId the ID of the span that the event occurred within
     */ ;
        _proto.setTraceCorrelation = function setTraceCorrelation(traceId, spanId) {
            if (typeof traceId === 'string') this._correlation = ___extends_6({
                traceId: traceId
            }, typeof spanId === 'string' ? {
                spanId: spanId
            } : {});
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            _$featureFlagDelegate_18.add(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            _$featureFlagDelegate_18.merge(this._features, featureFlags, this._featuresIndex);
        };
        _proto.getFeatureFlags = function getFeatureFlags() {
            return _$featureFlagDelegate_18.toEventApi(this._features);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            _$featureFlagDelegate_18.clear(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                payloadVersion: '4',
                exceptions: _$map_16(this.errors, function(er) {
                    return _$assign_11({}, er, {
                        message: er.errorMessage
                    });
                }),
                severity: this.severity,
                unhandled: this._handledState.unhandled,
                severityReason: this._handledState.severityReason,
                app: this.app,
                device: this.device,
                request: this.request,
                breadcrumbs: this.breadcrumbs,
                context: this.context,
                groupingHash: this.groupingHash,
                metaData: this._metadata,
                user: this._user,
                session: this._session,
                featureFlags: this.getFeatureFlags(),
                correlation: this._correlation
            };
        };
        return Event;
    }(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
    // and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)
    var formatStackframe = function(frame) {
        var f = {
            file: frame.fileName,
            method: normaliseFunctionName(frame.functionName),
            lineNumber: frame.lineNumber,
            columnNumber: frame.columnNumber,
            code: undefined,
            inProject: undefined
        };
        // Some instances result in no file:
        // - calling notify() from chrome's terminal results in no file/method.
        // - non-error exception thrown from global code in FF
        // This adds one.
        if (f.lineNumber > -1 && !f.file && !f.method) f.file = 'global code';
        return f;
    };
    var normaliseFunctionName = function(name) {
        return /^global code$/i.test(name) ? 'global code' : name;
    };
    var defaultHandledState = function() {
        return {
            unhandled: false,
            severity: 'warning',
            severityReason: {
                type: 'handledException'
            }
        };
    };
    var ensureString = function(str) {
        return typeof str === 'string' ? str : '';
    };
    function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
        return {
            errorClass: ensureString(errorClass),
            errorMessage: ensureString(errorMessage),
            type: type,
            stacktrace: _$reduce_17(stacktrace, function(accum, frame) {
                var f = formatStackframe(frame);
                // don't include a stackframe if none of its properties are defined
                try {
                    if (JSON.stringify(f) === '{}') return accum;
                    return accum.concat(f);
                } catch (e) {
                    return accum;
                }
            }, [])
        };
    }
    function getCauseStack(error) {
        if (error.cause) return [
            error
        ].concat(getCauseStack(error.cause));
        else return [
            error
        ];
    }
    // Helpers
    Event.getStacktrace = function(error, errorFramesToSkip, backtraceFramesToSkip) {
        if (_$hasStack_19(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip);
        // error wasn't provided or didn't have a stacktrace so try to walk the callstack
        try {
            return _$filter_12(_$stackGenerator_33.backtrace(), function(frame) {
                return (frame.functionName || '').indexOf('StackGenerator$$') === -1;
            }).slice(1 + backtraceFramesToSkip);
        } catch (e) {
            return [];
        }
    };
    Event.create = function(maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
        if (errorFramesToSkip === void 0) errorFramesToSkip = 0;
        var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger), error = _normaliseError[0], internalFrames = _normaliseError[1];
        var event;
        try {
            var stacktrace = Event.getStacktrace(error, // if an error was created/throw in the normaliseError() function, we need to
            // tell the getStacktrace() function to skip the number of frames we know will
            // be from our own functions. This is added to the number of frames deep we
            // were told about
            internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0, // if there's no stacktrace, the callstack may be walked to generated one.
            // this is how many frames should be removed because they come from our library
            1 + errorFramesToSkip);
            event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
        } catch (e) {
            event = new Event(error.name, error.message, [], handledState, maybeError);
        }
        if (error.name === 'InvalidError') event.addMetadata("" + component, 'non-error parameter', makeSerialisable(maybeError));
        if (error.cause) {
            var _event$errors;
            var causes = getCauseStack(error).slice(1);
            var normalisedCauses = _$map_16(causes, function(cause) {
                // Only get stacktrace for error causes that are a valid JS Error and already have a stack
                var stacktrace = _$iserror_20(cause) && _$hasStack_19(cause) ? _$errorStackParser_10.parse(cause) : [];
                var _normaliseError2 = normaliseError(cause, true, 'error cause'), error = _normaliseError2[0];
                if (error.name === 'InvalidError') event.addMetadata('error cause', makeSerialisable(cause));
                return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
            });
            (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
        }
        return event;
    };
    var makeSerialisable = function(err) {
        if (err === null) return 'null';
        if (err === undefined) return 'undefined';
        return err;
    };
    var normaliseError = function(maybeError, tolerateNonErrors, component, logger) {
        var error;
        var internalFrames = 0;
        var createAndLogInputError = function(reason) {
            var verb = component === 'error cause' ? 'was' : 'received';
            if (logger) logger.warn(component + " " + verb + " a non-error: \"" + reason + "\"");
            var err = new Error(component + " " + verb + " a non-error. See \"" + component + "\" tab for more detail.");
            err.name = 'InvalidError';
            return err;
        };
        // In some cases:
        //
        //  - the promise rejection handler (both in the browser and node)
        //  - the node uncaughtException handler
        //
        // We are really limited in what we can do to get a stacktrace. So we use the
        // tolerateNonErrors option to ensure that the resulting error communicates as
        // such.
        if (!tolerateNonErrors) {
            if (_$iserror_20(maybeError)) error = maybeError;
            else {
                error = createAndLogInputError(typeof maybeError);
                internalFrames += 2;
            }
        } else switch(typeof maybeError){
            case 'string':
            case 'number':
            case 'boolean':
                error = new Error(String(maybeError));
                internalFrames += 1;
                break;
            case 'function':
                error = createAndLogInputError('function');
                internalFrames += 2;
                break;
            case 'object':
                if (maybeError !== null && _$iserror_20(maybeError)) error = maybeError;
                else if (maybeError !== null && hasNecessaryFields(maybeError)) {
                    error = new Error(maybeError.message || maybeError.errorMessage);
                    error.name = maybeError.name || maybeError.errorClass;
                    internalFrames += 1;
                } else {
                    error = createAndLogInputError(maybeError === null ? 'null' : 'unsupported object');
                    internalFrames += 2;
                }
                break;
            default:
                error = createAndLogInputError('nothing');
                internalFrames += 2;
        }
        if (!_$hasStack_19(error)) // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
        try {
            throw error;
        } catch (e) {
            if (_$hasStack_19(e)) {
                error = e;
                // if the error only got a stacktrace after we threw it here, we know it
                // will only have one extra internal frame from this function, regardless
                // of whether it went through createAndLogInputError() or not
                internalFrames = 1;
            }
        }
        return [
            error,
            internalFrames
        ];
    };
    // default value for stacktrace.type
    Event.__type = 'browserjs';
    var hasNecessaryFields = function(error) {
        return (typeof error.name === 'string' || typeof error.errorClass === 'string') && (typeof error.message === 'string' || typeof error.errorMessage === 'string');
    };
    var _$Event_6 = Event;
    // This is a heavily modified/simplified version of
    //   https://github.com/othiym23/async-some
    // with the logic flipped so that it is akin to the
    // synchronous "every" method instead of "some".
    // run the asynchronous test function (fn) over each item in the array (arr)
    // in series until:
    //   - fn(item, cb) => calls cb(null, false)
    //   - or the end of the array is reached
    // the callback (cb) will be passed (null, false) if any of the items in arr
    // caused fn to call back with false, otherwise it will be passed (null, true)
    var _$asyncEvery_7 = function(arr, fn, cb) {
        var index = 0;
        var next = function() {
            if (index >= arr.length) return cb(null, true);
            fn(arr[index], function(err, result) {
                if (err) return cb(err);
                if (result === false) return cb(null, false);
                index++;
                next();
            });
        };
        next();
    }; /* removed: var _$asyncEvery_7 = require('./async-every'); */ 
    var _$callbackRunner_9 = function(callbacks, event, onCallbackError, cb) {
        // This function is how we support different kinds of callback:
        //  - synchronous - return value
        //  - node-style async with callback - cb(err, value)
        //  - promise/thenable - resolve(value)
        // It normalises each of these into the lowest common denominator – a node-style callback
        var runMaybeAsyncCallback = function(fn, cb) {
            if (typeof fn !== 'function') return cb(null);
            try {
                // if function appears sync…
                if (fn.length !== 2) {
                    var ret = fn(event);
                    // check if it returned a "thenable" (promise)
                    if (ret && typeof ret.then === 'function') return ret.then(// resolve
                    function(val) {
                        return setTimeout(function() {
                            return cb(null, val);
                        });
                    }, // reject
                    function(err) {
                        setTimeout(function() {
                            onCallbackError(err);
                            return cb(null, true);
                        });
                    });
                    return cb(null, ret);
                }
                // if function is async…
                fn(event, function(err, result) {
                    if (err) {
                        onCallbackError(err);
                        return cb(null);
                    }
                    cb(null, result);
                });
            } catch (e) {
                onCallbackError(e);
                cb(null);
            }
        };
        _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
    };
    var _$syncCallbackRunner_23 = function(callbacks, callbackArg, callbackType, logger) {
        var ignore = false;
        var cbs = callbacks.slice();
        while(!ignore){
            if (!cbs.length) break;
            try {
                ignore = cbs.pop()(callbackArg) === false;
            } catch (e) {
                logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
                logger.error(e);
            }
        }
        return ignore;
    };
    var _$pad_29 = function pad(num, size) {
        var s = '000000000' + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_29 = require('./pad.js'); */ 
    var env = typeof window === 'object' ? window : self;
    var globalCount = 0;
    for(var prop in env)if (Object.hasOwnProperty.call(env, prop)) globalCount++;
    var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);
    var _$fingerprint_28 = function fingerprint() {
        return clientId;
    }; /* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */ 
    var c = 0, blockSize = 4, base = 36, discreteValues = Math.pow(base, blockSize);
    function randomBlock() {
        return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
    }
    function safeCounter() {
        c = c < discreteValues ? c : 0;
        c++; // this is not subliminal
        return c - 1;
    }
    function cuid() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = 'c', // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(base), // Prevent same-machine collisions.
        counter = _$pad_29(safeCounter().toString(base), blockSize), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_28(), // Grab some more chars from Math.random()
        random = randomBlock() + randomBlock();
        return letter + timestamp + counter + print + random;
    }
    cuid.fingerprint = _$fingerprint_28;
    var _$cuid_27 = cuid; /* removed: var _$cuid_27 = require('@bugsnag/cuid'); */ 
    var Session = /*#__PURE__*/ function() {
        function Session() {
            this.id = _$cuid_27();
            this.startedAt = new Date();
            this._handled = 0;
            this._unhandled = 0;
            this._user = {};
            this.app = {};
            this.device = {};
        }
        var _proto = Session.prototype;
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto.toJSON = function toJSON() {
            return {
                id: this.id,
                startedAt: this.startedAt,
                events: {
                    handled: this._handled,
                    unhandled: this._unhandled
                }
            };
        };
        _proto._track = function _track(event) {
            this[event._handledState.unhandled ? '_unhandled' : '_handled'] += 1;
        };
        return Session;
    }();
    var _$Session_35 = Session; /* removed: var _$config_5 = require('./config'); */ 
    var __add_4 = _$featureFlagDelegate_18.add, __clear_4 = _$featureFlagDelegate_18.clear, __merge_4 = _$featureFlagDelegate_18.merge;
    var noop = function() {};
    var Client = /*#__PURE__*/ function() {
        function Client(configuration, schema, internalPlugins, notifier) {
            var _this = this;
            if (schema === void 0) schema = _$config_5.schema;
            if (internalPlugins === void 0) internalPlugins = [];
            // notifier id
            this._notifier = notifier;
            // intialise opts and config
            this._config = {};
            this._schema = schema;
            // i/o
            this._delivery = {
                sendSession: noop,
                sendEvent: noop
            };
            this._logger = {
                debug: noop,
                info: noop,
                warn: noop,
                error: noop
            };
            // plugins
            this._plugins = {};
            // state
            this._breadcrumbs = [];
            this._session = null;
            this._metadata = {};
            this._featuresIndex = {};
            this._features = [];
            this._context = undefined;
            this._user = {};
            // callbacks:
            //  e: onError
            //  s: onSession
            //  sp: onSessionPayload
            //  b: onBreadcrumb
            // (note these names are minified by hand because object
            // properties are not safe to minify automatically)
            this._cbs = {
                e: [],
                s: [],
                sp: [],
                b: []
            };
            // expose internal constructors
            this.Client = Client;
            this.Event = _$Event_6;
            this.Breadcrumb = _$Breadcrumb_3;
            this.Session = _$Session_35;
            this._config = this._configure(configuration, internalPlugins);
            _$map_16(internalPlugins.concat(this._config.plugins), function(pl) {
                if (pl) _this._loadPlugin(pl);
            });
            // when notify() is called we need to know how many frames are from our own source
            // this inital value is 1 not 0 because we wrap notify() to ensure it is always
            // bound to have the client as its `this` value – see below.
            this._depth = 1;
            var self1 = this;
            var notify = this.notify;
            this.notify = function() {
                return notify.apply(self1, arguments);
            };
        }
        var _proto = Client.prototype;
        _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
            return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
        };
        _proto.getMetadata = function getMetadata(section, key) {
            return _$metadataDelegate_22.get(this._metadata, section, key);
        };
        _proto.clearMetadata = function clearMetadata(section, key) {
            return _$metadataDelegate_22.clear(this._metadata, section, key);
        };
        _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
            if (variant === void 0) variant = null;
            __add_4(this._features, this._featuresIndex, name, variant);
        };
        _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
            __merge_4(this._features, featureFlags, this._featuresIndex);
        };
        _proto.clearFeatureFlag = function clearFeatureFlag(name) {
            __clear_4(this._features, this._featuresIndex, name);
        };
        _proto.clearFeatureFlags = function clearFeatureFlags() {
            this._features = [];
            this._featuresIndex = {};
        };
        _proto.getContext = function getContext() {
            return this._context;
        };
        _proto.setContext = function setContext(c) {
            this._context = c;
        };
        _proto._configure = function _configure(opts, internalPlugins) {
            var schema = _$reduce_17(internalPlugins, function(schema, plugin) {
                if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
                return schema;
            }, this._schema);
            // accumulate configuration and error messages
            var _reduce = _$reduce_17(_$keys_15(schema), function(accum, key) {
                var defaultValue = schema[key].defaultValue(opts[key]);
                if (opts[key] !== undefined) {
                    var valid = schema[key].validate(opts[key]);
                    if (!valid) {
                        accum.errors[key] = schema[key].message;
                        accum.config[key] = defaultValue;
                    } else if (schema[key].allowPartialObject) accum.config[key] = _$assign_11(defaultValue, opts[key]);
                    else accum.config[key] = opts[key];
                } else accum.config[key] = defaultValue;
                return accum;
            }, {
                errors: {},
                config: {}
            }), errors = _reduce.errors, config = _reduce.config;
            if (schema.apiKey) {
                // missing api key is the only fatal error
                if (!config.apiKey) throw new Error('No Bugsnag API Key set');
                // warn about an apikey that is not of the expected format
                if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = 'should be a string of 32 hexadecimal characters';
            }
            // update and elevate some options
            this._metadata = _$assign_11({}, config.metadata);
            __merge_4(this._features, config.featureFlags, this._featuresIndex);
            this._user = _$assign_11({}, config.user);
            this._context = config.context;
            if (config.logger) this._logger = config.logger;
            // add callbacks
            if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
            if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
            if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession);
            // finally warn about any invalid config where we fell back to the default
            if (_$keys_15(errors).length) this._logger.warn(generateConfigErrorMessage(errors, opts));
            return config;
        };
        _proto.getUser = function getUser() {
            return this._user;
        };
        _proto.setUser = function setUser(id, email, name) {
            this._user = {
                id: id,
                email: email,
                name: name
            };
        };
        _proto._loadPlugin = function _loadPlugin(plugin) {
            var result = plugin.load(this);
            // JS objects are not the safest way to store arbitrarily keyed values,
            // so bookend the key with some characters that prevent tampering with
            // stuff like __proto__ etc. (only store the result if the plugin had a
            // name)
            if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
            return this;
        };
        _proto.getPlugin = function getPlugin(name) {
            return this._plugins["~" + name + "~"];
        };
        _proto._setDelivery = function _setDelivery(d) {
            this._delivery = d(this);
        };
        _proto.startSession = function startSession() {
            var session = new _$Session_35();
            session.app.releaseStage = this._config.releaseStage;
            session.app.version = this._config.appVersion;
            session.app.type = this._config.appType;
            session._user = _$assign_11({}, this._user);
            // run onSession callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.s, session, 'onSession', this._logger);
            if (ignore) {
                this._logger.debug('Session not started due to onSession callback');
                return this;
            }
            return this._sessionDelegate.startSession(this, session);
        };
        _proto.addOnError = function addOnError(fn, front) {
            if (front === void 0) front = false;
            this._cbs.e[front ? 'unshift' : 'push'](fn);
        };
        _proto.removeOnError = function removeOnError(fn) {
            this._cbs.e = _$filter_12(this._cbs.e, function(f) {
                return f !== fn;
            });
        };
        _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
            this._cbs.sp.push(fn);
        };
        _proto.addOnSession = function addOnSession(fn) {
            this._cbs.s.push(fn);
        };
        _proto.removeOnSession = function removeOnSession(fn) {
            this._cbs.s = _$filter_12(this._cbs.s, function(f) {
                return f !== fn;
            });
        };
        _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
            if (front === void 0) front = false;
            this._cbs.b[front ? 'unshift' : 'push'](fn);
        };
        _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
            this._cbs.b = _$filter_12(this._cbs.b, function(f) {
                return f !== fn;
            });
        };
        _proto.pauseSession = function pauseSession() {
            return this._sessionDelegate.pauseSession(this);
        };
        _proto.resumeSession = function resumeSession() {
            return this._sessionDelegate.resumeSession(this);
        };
        _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
            // coerce bad values so that the defaults get set
            message = typeof message === 'string' ? message : '';
            type = typeof type === 'string' && _$includes_13(_$breadcrumbTypes_8, type) ? type : 'manual';
            metadata = typeof metadata === 'object' && metadata !== null ? metadata : {};
            // if no message, discard
            if (!message) return;
            var crumb = new _$Breadcrumb_3(message, metadata, type);
            // run onBreadcrumb callbacks
            var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, 'onBreadcrumb', this._logger);
            if (ignore) {
                this._logger.debug('Breadcrumb not attached due to onBreadcrumb callback');
                return;
            }
            // push the valid crumb onto the queue and maintain the length
            this._breadcrumbs.push(crumb);
            if (this._breadcrumbs.length > this._config.maxBreadcrumbs) this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
        };
        _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
            var types = this._config.enabledBreadcrumbTypes;
            return types === null || _$includes_13(types, type);
        };
        _proto.notify = function notify(maybeError, onError, postReportCallback) {
            if (postReportCallback === void 0) postReportCallback = noop;
            var event = _$Event_6.create(maybeError, true, undefined, 'notify()', this._depth + 1, this._logger);
            this._notify(event, onError, postReportCallback);
        };
        _proto._notify = function _notify(event, onError, postReportCallback) {
            var _this2 = this;
            if (postReportCallback === void 0) postReportCallback = noop;
            event.app = _$assign_11({}, event.app, {
                releaseStage: this._config.releaseStage,
                version: this._config.appVersion,
                type: this._config.appType
            });
            event.context = event.context || this._context;
            event._metadata = _$assign_11({}, event._metadata, this._metadata);
            event._user = _$assign_11({}, event._user, this._user);
            event.breadcrumbs = this._breadcrumbs.slice();
            __merge_4(event._features, this._features, event._featuresIndex);
            // exit early if events should not be sent on the current releaseStage
            if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
                this._logger.warn('Event not sent due to releaseStage/enabledReleaseStages configuration');
                return postReportCallback(null, event);
            }
            var originalSeverity = event.severity;
            var onCallbackError = function(err) {
                // errors in callbacks are tolerated but we want to log them out
                _this2._logger.error("Error occurred in onError callback, continuing anyway\u2026");
                _this2._logger.error(err);
            };
            var callbacks = [].concat(this._cbs.e).concat(onError);
            _$callbackRunner_9(callbacks, event, onCallbackError, function(err, shouldSend) {
                if (err) onCallbackError(err);
                if (!shouldSend) {
                    _this2._logger.debug('Event not sent due to onError callback');
                    return postReportCallback(null, event);
                }
                if (_this2._isBreadcrumbTypeEnabled('error')) // only leave a crumb for the error if actually got sent
                Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
                    errorClass: event.errors[0].errorClass,
                    errorMessage: event.errors[0].errorMessage,
                    severity: event.severity
                }, 'error');
                if (originalSeverity !== event.severity) event._handledState.severityReason = {
                    type: 'userCallbackSetSeverity'
                };
                if (event.unhandled !== event._handledState.unhandled) {
                    event._handledState.severityReason.unhandledOverridden = true;
                    event._handledState.unhandled = event.unhandled;
                }
                if (_this2._session) {
                    _this2._session._track(event);
                    event._session = _this2._session;
                }
                _this2._delivery.sendEvent({
                    apiKey: event.apiKey || _this2._config.apiKey,
                    notifier: _this2._notifier,
                    events: [
                        event
                    ]
                }, function(err) {
                    return postReportCallback(err, event);
                });
            });
        };
        return Client;
    }();
    var generateConfigErrorMessage = function(errors, rawInput) {
        var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function(key) {
            return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
        }).join('\n\n'));
        return er;
    };
    var stringify = function(val) {
        switch(typeof val){
            case 'string':
            case 'number':
            case 'object':
                return JSON.stringify(val);
            default:
                return String(val);
        }
    };
    var _$Client_4 = Client;
    var _$jsonPayload_21 = {}; /* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */ 
    var EVENT_REDACTION_PATHS = [
        'events.[].metaData',
        'events.[].breadcrumbs.[].metaData',
        'events.[].request'
    ];
    _$jsonPayload_21.event = function(event, redactedKeys) {
        var payload = _$safeJsonStringify_30(event, null, null, {
            redactedPaths: EVENT_REDACTION_PATHS,
            redactedKeys: redactedKeys
        });
        if (payload.length > 10e5) {
            event.events[0]._metadata = {
                notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
            };
            payload = _$safeJsonStringify_30(event, null, null, {
                redactedPaths: EVENT_REDACTION_PATHS,
                redactedKeys: redactedKeys
            });
        }
        return payload;
    };
    _$jsonPayload_21.session = function(session, redactedKeys) {
        var payload = _$safeJsonStringify_30(session, null, null);
        return payload;
    };
    var _$delivery_36 = {}; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    _$delivery_36 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, 'notify', '4', win);
                var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.onerror = function() {
                    var err = new Error('Event failed to send');
                    client._logger.error("Event failed to send\u2026", err);
                    if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                    cb(err);
                };
                req.open('POST', url);
                setTimeout(function() {
                    try {
                        req.send(body);
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                var url = getApiUrl(client._config, 'sessions', '1', win);
                var req = new win.XDomainRequest();
                req.onload = function() {
                    cb(null);
                };
                req.open('POST', url);
                setTimeout(function() {
                    try {
                        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                    } catch (e) {
                        client._logger.error(e);
                        cb(e);
                    }
                }, 0);
            }
        };
    };
    var getApiUrl = function(config, endpoint, version, win) {
        // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
        // to an ISO string when you use JSON stringify. Simply parsing the result of
        // JSON.stringify is smaller than using a toISOstring() polyfill.
        var isoDate = JSON.parse(JSON.stringify(new Date()));
        var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
        return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
    };
    var matchPageProtocol = _$delivery_36._matchPageProtocol = function(endpoint, pageProtocol) {
        return pageProtocol === 'http:' ? endpoint.replace(/^https:/, 'http:') : endpoint;
    }; /* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */ 
    var _$delivery_37 = function(client, win) {
        if (win === void 0) win = window;
        return {
            sendEvent: function(event, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.notify;
                    var req = new win.XMLHttpRequest();
                    var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Event failed to send\u2026", err);
                                if (body.length > 10e5) client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open('POST', url);
                    req.setRequestHeader('Content-Type', 'application/json');
                    req.setRequestHeader('Bugsnag-Api-Key', event.apiKey || client._config.apiKey);
                    req.setRequestHeader('Bugsnag-Payload-Version', '4');
                    req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
                    req.send(body);
                } catch (e) {
                    client._logger.error(e);
                }
            },
            sendSession: function(session, cb) {
                if (cb === void 0) cb = function() {};
                try {
                    var url = client._config.endpoints.sessions;
                    var req = new win.XMLHttpRequest();
                    req.onreadystatechange = function() {
                        if (req.readyState === win.XMLHttpRequest.DONE) {
                            var status = req.status;
                            if (status === 0 || status >= 400) {
                                var err = new Error("Request failed with status " + status);
                                client._logger.error("Session failed to send\u2026", err);
                                cb(err);
                            } else cb(null);
                        }
                    };
                    req.open('POST', url);
                    req.setRequestHeader('Content-Type', 'application/json');
                    req.setRequestHeader('Bugsnag-Api-Key', client._config.apiKey);
                    req.setRequestHeader('Bugsnag-Payload-Version', '1');
                    req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
                    req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
                } catch (e) {
                    client._logger.error(e);
                }
            }
        };
    };
    var appStart = new Date();
    var reset = function() {
        appStart = new Date();
    };
    var _$app_38 = {
        name: 'appDuration',
        load: function(client) {
            client.addOnError(function(event) {
                var now = new Date();
                event.app.duration = now - appStart;
            }, true);
            return {
                reset: reset
            };
        }
    };
    /*
 * Sets the default context to be the current URL
 */ var _$context_39 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.context !== undefined) return;
                    event.context = win.location.pathname;
                }, true);
            }
        };
    };
    var _$pad_43 = function pad(num, size) {
        var s = '000000000' + num;
        return s.substr(s.length - size);
    }; /* removed: var _$pad_43 = require('./pad.js'); */ 
    var __env_42 = typeof window === 'object' ? window : self;
    var __globalCount_42 = 0;
    for(var __prop_42 in __env_42)if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
    var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
    var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);
    var _$fingerprint_42 = function fingerprint() {
        return __clientId_42;
    }; /* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */ 
    var __c_41 = 0, __blockSize_41 = 4, __base_41 = 36, __discreteValues_41 = Math.pow(__base_41, __blockSize_41);
    function __randomBlock_41() {
        return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
    }
    function __safeCounter_41() {
        __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
        __c_41++; // this is not subliminal
        return __c_41 - 1;
    }
    function __cuid_41() {
        // Starting with a lowercase letter makes
        // it HTML element ID friendly.
        var letter = 'c', // hard-coded allows for sequential access
        // timestamp
        // warning: this exposes the exact date and time
        // that the uid was created.
        timestamp = new Date().getTime().toString(__base_41), // Prevent same-machine collisions.
        counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41), // A few chars to generate distinct ids for different
        // clients (so different computers are far less
        // likely to generate the same id)
        print = _$fingerprint_42(), // Grab some more chars from Math.random()
        random = __randomBlock_41() + __randomBlock_41();
        return letter + timestamp + counter + print + random;
    }
    __cuid_41.fingerprint = _$fingerprint_42;
    var _$cuid_41 = __cuid_41; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    var BUGSNAG_ANONYMOUS_ID_KEY = 'bugsnag-anonymous-id';
    var getDeviceId = function(win) {
        try {
            var storage = win.localStorage;
            var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY);
            // If we get an ID, make sure it looks like a valid cuid. The length can
            // fluctuate slightly, so some leeway is built in
            if (id && /^c[a-z0-9]{20,32}$/.test(id)) return id;
             /* removed: var _$cuid_41 = require('@bugsnag/cuid'); */ 
            id = _$cuid_41();
            storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
            return id;
        } catch (err) {
        // If localStorage is not available (e.g. because it's disabled) then give up
        }
    };
    /*
 * Automatically detects browser device details
 */ var _$device_40 = function(nav, win) {
        if (nav === void 0) nav = navigator;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                var device = {
                    locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
                    userAgent: nav.userAgent
                };
                if (win && win.screen && win.screen.orientation && win.screen.orientation.type) device.orientation = win.screen.orientation.type;
                else if (win && win.document) device.orientation = win.document.documentElement.clientWidth > win.document.documentElement.clientHeight ? 'landscape' : 'portrait';
                if (client._config.generateAnonymousId) device.id = getDeviceId(win);
                client.addOnSession(function(session) {
                    session.device = _$assign_11({}, session.device, device);
                    // only set device id if collectUserIp is false
                    if (!client._config.collectUserIp) setDefaultUserId(session);
                });
                // add time just as the event is sent
                client.addOnError(function(event) {
                    event.device = _$assign_11({}, event.device, device, {
                        time: new Date()
                    });
                    if (!client._config.collectUserIp) setDefaultUserId(event);
                }, true);
            },
            configSchema: {
                generateAnonymousId: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: 'should be true|false'
                }
            }
        };
    };
    var setDefaultUserId = function(eventOrSession) {
        // device id is also used to populate the user id field, if it's not already set
        var user = eventOrSession.getUser();
        if (!user || !user.id) eventOrSession.setUser(eventOrSession.device.id);
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Sets the event request: { url } to be the current href
 */ var _$request_44 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                client.addOnError(function(event) {
                    if (event.request && event.request.url) return;
                    event.request = _$assign_11({}, event.request, {
                        url: win.location.href
                    });
                }, true);
            }
        };
    }; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    var _$session_45 = {
        load: function(client) {
            client._sessionDelegate = sessionDelegate;
        }
    };
    var sessionDelegate = {
        startSession: function(client, session) {
            var sessionClient = client;
            sessionClient._session = session;
            sessionClient._pausedSession = null;
            // exit early if the current releaseStage is not enabled
            if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
                sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');
                return sessionClient;
            }
            sessionClient._delivery.sendSession({
                notifier: sessionClient._notifier,
                device: session.device,
                app: session.app,
                sessions: [
                    {
                        id: session.id,
                        startedAt: session.startedAt,
                        user: session._user
                    }
                ]
            });
            return sessionClient;
        },
        resumeSession: function(client) {
            // Do nothing if there's already an active session
            if (client._session) return client;
            // If we have a paused session then make it the active session
            if (client._pausedSession) {
                client._session = client._pausedSession;
                client._pausedSession = null;
                return client;
            }
            // Otherwise start a new session
            return client.startSession();
        },
        pauseSession: function(client) {
            client._pausedSession = client._session;
            client._session = null;
        }
    }; /* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */ 
    /*
 * Prevent collection of user IPs
 */ var _$clientIp_46 = {
        load: function(client) {
            if (client._config.collectUserIp) return;
            client.addOnError(function(event) {
                // If user.id is explicitly undefined, it will be missing from the payload. It needs
                // removing so that the following line replaces it
                if (event._user && typeof event._user.id === 'undefined') delete event._user.id;
                event._user = _$assign_11({
                    id: '[REDACTED]'
                }, event._user);
                event.request = _$assign_11({
                    clientIp: '[REDACTED]'
                }, event.request);
            });
        },
        configSchema: {
            collectUserIp: {
                defaultValue: function() {
                    return true;
                },
                message: 'should be true|false',
                validate: function(value) {
                    return value === true || value === false;
                }
            }
        }
    };
    var _$consoleBreadcrumbs_47 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    /*
 * Leaves breadcrumbs when console log methods are called
 */ _$consoleBreadcrumbs_47.load = function(client) {
        var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
        if (isDev || !client._isBreadcrumbTypeEnabled('log')) return;
        _$map_16(CONSOLE_LOG_METHODS, function(method) {
            var original = console[method];
            console[method] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                client.leaveBreadcrumb('Console output', _$reduce_17(args, function(accum, arg, i) {
                    // do the best/simplest stringification of each argument
                    var stringified = '[Unknown value]';
                    // this may fail if the input is:
                    // - an object whose [[Prototype]] is null (no toString)
                    // - an object with a broken toString or @@toPrimitive implementation
                    try {
                        stringified = String(arg);
                    } catch (e) {}
                    // if it stringifies to [object Object] attempt to JSON stringify
                    if (stringified === '[object Object]') // catch stringify errors and fallback to [object Object]
                    try {
                        stringified = JSON.stringify(arg);
                    } catch (e) {}
                    accum["[" + i + "]"] = stringified;
                    return accum;
                }, {
                    severity: method.indexOf('group') === 0 ? 'log' : method
                }), 'log');
                original.apply(console, args);
            };
            console[method]._restore = function() {
                console[method] = original;
            };
        });
    };
    var CONSOLE_LOG_METHODS = _$filter_12([
        'log',
        'debug',
        'info',
        'warn',
        'error'
    ], function(method) {
        return typeof console !== 'undefined' && typeof console[method] === 'function';
    }); /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var MAX_LINE_LENGTH = 200;
    var MAX_SCRIPT_LENGTH = 500000;
    var _$inlineScriptContent_48 = function(doc, win) {
        if (doc === void 0) doc = document;
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!client._config.trackInlineScripts) return;
                var originalLocation = win.location.href;
                var html = '';
                // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
                // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing
                var isOldIe = !!doc.attachEvent;
                var DOMContentLoaded = isOldIe ? doc.readyState === 'complete' : doc.readyState !== 'loading';
                var getHtml = function() {
                    return doc.documentElement.outerHTML;
                };
                // get whatever HTML exists at this point in time
                html = getHtml();
                var prev = doc.onreadystatechange;
                // then update it when the DOM content has loaded
                doc.onreadystatechange = function() {
                    // IE8 compatible alternative to document#DOMContentLoaded
                    if (doc.readyState === 'interactive') {
                        html = getHtml();
                        DOMContentLoaded = true;
                    }
                    try {
                        prev.apply(this, arguments);
                    } catch (e) {}
                };
                var _lastScript = null;
                var updateLastScript = function(script) {
                    _lastScript = script;
                };
                var getCurrentScript = function() {
                    var script = doc.currentScript || _lastScript;
                    if (!script && !DOMContentLoaded) {
                        var scripts = doc.scripts || doc.getElementsByTagName('script');
                        script = scripts[scripts.length - 1];
                    }
                    return script;
                };
                var addSurroundingCode = function(lineNumber) {
                    // get whatever html has rendered at this point
                    if (!DOMContentLoaded || !html) html = getHtml();
                    // simulate the raw html
                    var htmlLines = [
                        '<!-- DOC START -->'
                    ].concat(html.split('\n'));
                    var zeroBasedLine = lineNumber - 1;
                    var start = Math.max(zeroBasedLine - 3, 0);
                    var end = Math.min(zeroBasedLine + 3, htmlLines.length);
                    return _$reduce_17(htmlLines.slice(start, end), function(accum, line, i) {
                        accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
                        return accum;
                    }, {});
                };
                client.addOnError(function(event) {
                    // remove any of our own frames that may be part the stack this
                    // happens before the inline script check as it happens for all errors
                    event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function(f) {
                        return !/__trace__$/.test(f.method);
                    });
                    var frame = event.errors[0].stacktrace[0];
                    // remove hash and query string from url
                    var cleanUrl = function(url) {
                        return url.replace(/#.*$/, '').replace(/\?.*$/, '');
                    };
                    // if frame.file exists and is not the original location of the page, this can't be an inline script
                    if (frame && frame.file && cleanUrl(frame.file) !== cleanUrl(originalLocation)) return;
                    // grab the last script known to have run
                    var currentScript = getCurrentScript();
                    if (currentScript) {
                        var content = currentScript.innerHTML;
                        event.addMetadata('script', 'content', content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH));
                        // only attempt to grab some surrounding code if we have a line number
                        if (frame && frame.lineNumber) frame.code = addSurroundingCode(frame.lineNumber);
                    }
                }, true);
                // Proxy all the timer functions whose callback is their 0th argument.
                // Keep a reference to the original setTimeout because we need it later
                var _map = _$map_16([
                    'setTimeout',
                    'setInterval',
                    'setImmediate',
                    'requestAnimationFrame'
                ], function(fn) {
                    return __proxy(win, fn, function(original) {
                        return __traceOriginalScript(original, function(args) {
                            return {
                                get: function() {
                                    return args[0];
                                },
                                replace: function(fn) {
                                    args[0] = fn;
                                }
                            };
                        });
                    });
                }), _setTimeout = _map[0];
                // Proxy all the host objects whose prototypes have an addEventListener function
                _$map_16([
                    'EventTarget',
                    'Window',
                    'Node',
                    'ApplicationCache',
                    'AudioTrackList',
                    'ChannelMergerNode',
                    'CryptoOperation',
                    'EventSource',
                    'FileReader',
                    'HTMLUnknownElement',
                    'IDBDatabase',
                    'IDBRequest',
                    'IDBTransaction',
                    'KeyOperation',
                    'MediaController',
                    'MessagePort',
                    'ModalWindow',
                    'Notification',
                    'SVGElementInstance',
                    'Screen',
                    'TextTrack',
                    'TextTrackCue',
                    'TextTrackList',
                    'WebSocket',
                    'WebSocketWorker',
                    'Worker',
                    'XMLHttpRequest',
                    'XMLHttpRequestEventTarget',
                    'XMLHttpRequestUpload'
                ], function(o) {
                    if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, 'addEventListener')) return;
                    __proxy(win[o].prototype, 'addEventListener', function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor);
                    });
                    __proxy(win[o].prototype, 'removeEventListener', function(original) {
                        return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
                    });
                });
                function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
                    if (alsoCallOriginal === void 0) alsoCallOriginal = false;
                    return function() {
                        // this is required for removeEventListener to remove anything added with
                        // addEventListener before the functions started being wrapped by Bugsnag
                        var args = [].slice.call(arguments);
                        try {
                            var cba = callbackAccessor(args);
                            var cb = cba.get();
                            if (alsoCallOriginal) fn.apply(this, args);
                            if (typeof cb !== 'function') return fn.apply(this, args);
                            if (cb.__trace__) cba.replace(cb.__trace__);
                            else {
                                var script = getCurrentScript();
                                // this function mustn't be annonymous due to a bug in the stack
                                // generation logic, meaning it gets tripped up
                                // see: https://github.com/stacktracejs/stack-generator/issues/6
                                cb.__trace__ = function __trace__() {
                                    // set the script that called this function
                                    updateLastScript(script);
                                    // immediately unset the currentScript synchronously below, however
                                    // if this cb throws an error the line after will not get run so schedule
                                    // an almost-immediate aysnc update too
                                    _setTimeout(function() {
                                        updateLastScript(null);
                                    }, 0);
                                    var ret = cb.apply(this, arguments);
                                    updateLastScript(null);
                                    return ret;
                                };
                                cb.__trace__.__trace__ = cb.__trace__;
                                cba.replace(cb.__trace__);
                            }
                        } catch (e) {
                        // swallow these errors on Selenium:
                        // Permission denied to access property '__trace__'
                        // WebDriverException: Message: Permission denied to access property "handleEvent"
                        }
                        // IE8 doesn't let you call .apply() on setTimeout/setInterval
                        if (fn.apply) return fn.apply(this, args);
                        switch(args.length){
                            case 1:
                                return fn(args[0]);
                            case 2:
                                return fn(args[0], args[1]);
                            default:
                                return fn();
                        }
                    };
                }
            },
            configSchema: {
                trackInlineScripts: {
                    validate: function(value) {
                        return value === true || value === false;
                    },
                    defaultValue: function() {
                        return true;
                    },
                    message: 'should be true|false'
                }
            }
        };
    };
    function __proxy(host, name, replacer) {
        var original = host[name];
        if (!original) return original;
        var replacement = replacer(original);
        host[name] = replacement;
        return original;
    }
    function eventTargetCallbackAccessor(args) {
        var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === 'function';
        return {
            get: function() {
                return isEventHandlerObj ? args[1].handleEvent : args[1];
            },
            replace: function(fn) {
                if (isEventHandlerObj) args[1].handleEvent = fn;
                else args[1] = fn;
            }
        };
    }
    /*
 * Leaves breadcrumbs when the user interacts with the DOM
 */ var _$interactionBreadcrumbs_49 = function(win) {
        if (win === void 0) win = window;
        return {
            load: function(client) {
                if (!('addEventListener' in win)) return;
                if (!client._isBreadcrumbTypeEnabled('user')) return;
                win.addEventListener('click', function(event) {
                    var targetText, targetSelector;
                    try {
                        targetText = getNodeText(event.target);
                        targetSelector = getNodeSelector(event.target, win);
                    } catch (e) {
                        targetText = '[hidden]';
                        targetSelector = '[hidden]';
                        client._logger.error('Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z');
                    }
                    client.leaveBreadcrumb('UI click', {
                        targetText: targetText,
                        targetSelector: targetSelector
                    }, 'user');
                }, true);
            }
        };
    };
    var trim = /^\s*([^\s][\s\S]{0,139}[^\s])?\s*/;
    function getNodeText(el) {
        var text = el.textContent || el.innerText || '';
        if (!text && (el.type === 'submit' || el.type === 'button')) text = el.value;
        text = text.replace(trim, '$1');
        if (text.length > 140) return text.slice(0, 135) + '(...)';
        return text;
    }
    // Create a label from tagname, id and css class of the element
    function getNodeSelector(el, win) {
        var parts = [
            el.tagName
        ];
        if (el.id) parts.push('#' + el.id);
        if (el.className && el.className.length) parts.push("." + el.className.split(' ').join('.'));
        // Can't get much more advanced with the current browser
        if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join('');
        try {
            if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
        } catch (e) {
            // Sometimes the query selector can be invalid just return it as-is
            return parts.join('');
        }
        // try to get a more specific selector if this one matches more than one element
        if (el.parentNode.childNodes.length > 1) {
            var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
            parts.push(":nth-child(" + index + ")");
        }
        if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
        // try prepending the parent node selector
        if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join('');
        return parts.join('');
    }
    var _$navigationBreadcrumbs_50 = {};
    /*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/ _$navigationBreadcrumbs_50 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!('addEventListener' in win)) return;
                if (!client._isBreadcrumbTypeEnabled('navigation')) return;
                // returns a function that will drop a breadcrumb with a given name
                var drop = function(name) {
                    return function() {
                        return client.leaveBreadcrumb(name, {}, 'navigation');
                    };
                };
                // simple drops – just names, no meta
                win.addEventListener('pagehide', drop('Page hidden'), true);
                win.addEventListener('pageshow', drop('Page shown'), true);
                win.addEventListener('load', drop('Page loaded'), true);
                win.document.addEventListener('DOMContentLoaded', drop('DOMContentLoaded'), true);
                // some browsers like to emit popstate when the page loads, so only add the popstate listener after that
                win.addEventListener('load', function() {
                    return win.addEventListener('popstate', drop('Navigated back'), true);
                });
                // hashchange has some metadata that we care about
                win.addEventListener('hashchange', function(event) {
                    var metadata = event.oldURL ? {
                        from: relativeLocation(event.oldURL, win),
                        to: relativeLocation(event.newURL, win),
                        state: getCurrentState(win)
                    } : {
                        to: relativeLocation(win.location.href, win)
                    };
                    client.leaveBreadcrumb('Hash changed', metadata, 'navigation');
                }, true);
                // the only way to know about replaceState/pushState is to wrap them… >_<
                if (win.history.replaceState) wrapHistoryFn(client, win.history, 'replaceState', win);
                if (win.history.pushState) wrapHistoryFn(client, win.history, 'pushState', win);
            }
        };
        return plugin;
    };
    // takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
    // just the path and hash parts, e.g. /pages/01.html?yes=no#section-2
    var relativeLocation = function(url, win) {
        var a = win.document.createElement('A');
        a.href = url;
        return "" + a.pathname + a.search + a.hash;
    };
    var stateChangeToMetadata = function(win, state, title, url) {
        var currentPath = relativeLocation(win.location.href, win);
        return {
            title: title,
            state: state,
            prevState: getCurrentState(win),
            to: url || currentPath,
            from: currentPath
        };
    };
    var wrapHistoryFn = function(client, target, fn, win) {
        var orig = target[fn];
        target[fn] = function(state, title, url) {
            client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), 'navigation');
            // if throttle plugin is in use, reset the event sent count
            if (typeof client.resetEventCount === 'function') client.resetEventCount();
            // if the client is operating in auto session-mode, a new route should trigger a new session
            if (client._config.autoTrackSessions) client.startSession();
            // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
            // to '/undefined'. therefore we only pass the url if it's not undefined.
            orig.apply(target, [
                state,
                title
            ].concat(url !== undefined ? url : []));
        };
    };
    var getCurrentState = function(win) {
        try {
            return win.history.state;
        } catch (e) {}
    };
    var BREADCRUMB_TYPE = 'request'; /* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */ 
    /*
 * Leaves breadcrumbs when network requests occur
 */ var _$networkBreadcrumbs_51 = function(_ignoredUrls, win) {
        if (_ignoredUrls === void 0) _ignoredUrls = [];
        if (win === void 0) win = window;
        var restoreFunctions = [];
        var plugin = {
            load: function(client) {
                if (!client._isBreadcrumbTypeEnabled('request')) return;
                var ignoredUrls = [
                    client._config.endpoints.notify,
                    client._config.endpoints.sessions
                ].concat(_ignoredUrls);
                monkeyPatchXMLHttpRequest();
                monkeyPatchFetch();
                // XMLHttpRequest monkey patch
                function monkeyPatchXMLHttpRequest() {
                    if (!('addEventListener' in win.XMLHttpRequest.prototype)) return;
                    var nativeOpen = win.XMLHttpRequest.prototype.open;
                    // override native open()
                    win.XMLHttpRequest.prototype.open = function open(method, url) {
                        var _this = this;
                        var requestSetupKey = false;
                        var error = function() {
                            return handleXHRError(method, url);
                        };
                        var load = function() {
                            return handleXHRLoad(method, url, _this.status);
                        };
                        // if we have already setup listeners, it means open() was called twice, we need to remove
                        // the listeners and recreate them
                        if (requestSetupKey) {
                            this.removeEventListener('load', load);
                            this.removeEventListener('error', error);
                        }
                        // attach load event listener
                        this.addEventListener('load', load);
                        // attach error event listener
                        this.addEventListener('error', error);
                        requestSetupKey = true;
                        nativeOpen.apply(this, arguments);
                    };
                }
                function handleXHRLoad(method, url, status) {
                    if (url === undefined) {
                        client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
                        return;
                    }
                    // an XMLHttpRequest's URL can be an object as long as its 'toString'
                    // returns a URL, e.g. a HTMLAnchorElement
                    if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    var metadata = {
                        status: status,
                        request: method + " " + url
                    };
                    if (status >= 400) // contacted server but got an error response
                    client.leaveBreadcrumb('XMLHttpRequest failed', metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb('XMLHttpRequest succeeded', metadata, BREADCRUMB_TYPE);
                }
                function handleXHRError(method, url) {
                    if (url === undefined) {
                        client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
                        return;
                    }
                    if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) // don't leave a network breadcrumb from bugsnag notify calls
                    return;
                    // failed to contact server
                    client.leaveBreadcrumb('XMLHttpRequest error', {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                }
                // window.fetch monkey patch
                function monkeyPatchFetch() {
                    // only patch it if it exists and if it is not a polyfill (patching a polyfilled
                    // fetch() results in duplicate breadcrumbs for the same request because the
                    // implementation uses XMLHttpRequest which is also patched)
                    if (!('fetch' in win) || win.fetch.polyfill) return;
                    var oldFetch = win.fetch;
                    win.fetch = function fetch() {
                        var _arguments = arguments;
                        var urlOrRequest = arguments[0];
                        var options = arguments[1];
                        var method;
                        var url = null;
                        if (urlOrRequest && typeof urlOrRequest === 'object') {
                            url = urlOrRequest.url;
                            if (options && 'method' in options) method = options.method;
                            else if (urlOrRequest && 'method' in urlOrRequest) method = urlOrRequest.method;
                        } else {
                            url = urlOrRequest;
                            if (options && 'method' in options) method = options.method;
                        }
                        if (method === undefined) method = 'GET';
                        return new Promise(function(resolve, reject) {
                            // pass through to native fetch
                            oldFetch.apply(void 0, _arguments).then(function(response) {
                                handleFetchSuccess(response, method, url);
                                resolve(response);
                            })["catch"](function(error) {
                                handleFetchError(method, url);
                                reject(error);
                            });
                        });
                    };
                }
                var handleFetchSuccess = function(response, method, url) {
                    var metadata = {
                        status: response.status,
                        request: method + " " + url
                    };
                    if (response.status >= 400) // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
                    client.leaveBreadcrumb('fetch() failed', metadata, BREADCRUMB_TYPE);
                    else client.leaveBreadcrumb('fetch() succeeded', metadata, BREADCRUMB_TYPE);
                };
                var handleFetchError = function(method, url) {
                    client.leaveBreadcrumb('fetch() error', {
                        request: method + " " + url
                    }, BREADCRUMB_TYPE);
                };
            }
        };
        return plugin;
    }; /* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */ 
    /*
 * Throttles and dedupes events
 */ var _$throttle_52 = {
        load: function(client) {
            // track sent events for each init of the plugin
            var n = 0;
            // add onError hook
            client.addOnError(function(event) {
                // have max events been sent already?
                if (n >= client._config.maxEvents) {
                    client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");
                    return false;
                }
                n++;
            });
            client.resetEventCount = function() {
                n = 0;
            };
        },
        configSchema: {
            maxEvents: {
                defaultValue: function() {
                    return 10;
                },
                message: "should be a positive integer \u2264100",
                validate: function(val) {
                    return _$intRange_24(1, 100)(val);
                }
            }
        }
    };
    var _$stripQueryString_53 = {}; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    _$stripQueryString_53 = {
        load: function(client) {
            client.addOnError(function(event) {
                var allFrames = _$reduce_17(event.errors, function(accum, er) {
                    return accum.concat(er.stacktrace);
                }, []);
                _$map_16(allFrames, function(frame) {
                    frame.file = strip(frame.file);
                });
            });
        }
    };
    var strip = _$stripQueryString_53._strip = function(str) {
        return typeof str === 'string' ? str.replace(/\?.*$/, '').replace(/#.*$/, '') : str;
    };
    /*
 * Automatically notifies Bugsnag when window.onerror is called
 */ var _$onerror_54 = function(win, component) {
        if (win === void 0) win = window;
        if (component === void 0) component = 'window onerror';
        return {
            load: function(client) {
                if (!client._config.autoDetectErrors) return;
                if (!client._config.enabledErrorTypes.unhandledExceptions) return;
                function onerror(messageOrEvent, url, lineNo, charNo, error) {
                    // Ignore errors with no info due to CORS settings
                    if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) client._logger.warn('Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z');
                    else {
                        // any error sent to window.onerror is unhandled and has severity=error
                        var handledState = {
                            severity: 'error',
                            unhandled: true,
                            severityReason: {
                                type: 'unhandledException'
                            }
                        };
                        var event;
                        // window.onerror can be called in a number of ways. This big if-else is how we
                        // figure out which arguments were supplied, and what kind of values it received.
                        if (error) {
                            // if the last parameter (error) was supplied, this is a modern browser's
                            // way of saying "this value was thrown and not caught"
                            event = client.Event.create(error, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        } else if (// This complex case detects "error" events that are typically synthesised
                        // by jquery's trigger method (although can be created in other ways). In
                        // order to detect this:
                        // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                        // - the second argument (url) must either not exist or be something other than a string (if it
                        //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                        //    function)
                        // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                        typeof messageOrEvent === 'object' && messageOrEvent !== null && (!url || typeof url !== 'string') && !lineNo && !charNo && !error) {
                            // The jQuery event may have a "type" property, if so use it as part of the error message
                            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : 'Error';
                            // attempt to find a message from one of the conventional properties, but
                            // default to empty string (the event will fill it with a placeholder)
                            var message = messageOrEvent.message || messageOrEvent.detail || '';
                            event = client.Event.create({
                                name: name,
                                message: message
                            }, true, handledState, component, 1);
                            // provide the original thing onerror received – not our error-like object we passed to _notify
                            event.originalError = messageOrEvent;
                            // include the raw input as metadata – it might contain more info than we extracted
                            event.addMetadata(component, {
                                event: messageOrEvent,
                                extraParameters: url
                            });
                        } else {
                            // Lastly, if there was no "error" parameter this event was probably from an old
                            // browser that doesn't support that. Instead we need to generate a stacktrace.
                            event = client.Event.create(messageOrEvent, true, handledState, component, 1);
                            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
                        }
                        client._notify(event);
                    }
                    if (typeof prevOnError === 'function') prevOnError.apply(this, arguments);
                }
                var prevOnError = win.onerror;
                win.onerror = onerror;
            }
        };
    };
    // Sometimes the stacktrace has less information than was passed to window.onerror.
    // This function will augment the first stackframe with any useful info that was
    // received as arguments to the onerror callback.
    var decorateStack = function(stack, url, lineNo, charNo) {
        if (!stack[0]) stack.push({});
        var culprit = stack[0];
        if (!culprit.file && typeof url === 'string') culprit.file = url;
        if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;
        if (!culprit.columnNumber) {
            if (isActualNumber(charNo)) culprit.columnNumber = charNo;
            else if (window.event && isActualNumber(window.event.errorCharacter)) culprit.columnNumber = window.event.errorCharacter;
        }
    };
    var isActualNumber = function(n) {
        return typeof n === 'number' && String.call(n) !== 'NaN';
    }; /* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */ 
    var _listener;
    /*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */ var _$unhandledRejection_55 = function(win) {
        if (win === void 0) win = window;
        var plugin = {
            load: function(client) {
                if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;
                var listener = function(evt) {
                    var error = evt.reason;
                    var isBluebird = false;
                    // accessing properties on evt.detail can throw errors (see #394)
                    try {
                        if (evt.detail && evt.detail.reason) {
                            error = evt.detail.reason;
                            isBluebird = true;
                        }
                    } catch (e) {}
                    var event = client.Event.create(error, false, {
                        severity: 'error',
                        unhandled: true,
                        severityReason: {
                            type: 'unhandledPromiseRejection'
                        }
                    }, 'unhandledrejection handler', 1, client._logger);
                    if (isBluebird) _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
                    client._notify(event, function(event) {
                        if (_$iserror_20(event.originalError) && !event.originalError.stack) {
                            var _event$addMetadata;
                            event.addMetadata('unhandledRejection handler', (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
                                name: event.originalError.name,
                                message: event.originalError.message,
                                code: event.originalError.code
                            }, _event$addMetadata));
                        }
                    });
                };
                if ('addEventListener' in win) win.addEventListener('unhandledrejection', listener);
                else win.onunhandledrejection = function(reason, promise) {
                    listener({
                        detail: {
                            reason: reason,
                            promise: promise
                        }
                    });
                };
                _listener = listener;
            }
        };
        return plugin;
    };
    // The stack parser on bluebird stacks in FF get a suprious first frame:
    //
    // Error: derp
    //   b@http://localhost:5000/bluebird.html:22:24
    //   a@http://localhost:5000/bluebird.html:18:9
    //   @http://localhost:5000/bluebird.html:14:9
    //
    // results in
    //   […]
    //     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
    //     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
    //     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
    //     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
    //
    // so the following reduce/accumulator function removes such frames
    //
    // Bluebird pads method names with spaces so trim that too…
    // https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571
    var fixBluebirdStacktrace = function(error) {
        return function(frame) {
            if (frame.file === error.toString()) return;
            if (frame.method) frame.method = frame.method.replace(/^\s+/, '');
        };
    };
    var _$notifier_2 = {};
    var name = 'Bugsnag JavaScript';
    var version = '7.25.0';
    var url = 'https://github.com/bugsnag/bugsnag-js'; /* removed: var _$Client_4 = require('@bugsnag/core/client'); */ 
    // extend the base config schema with some browser-specific options
    var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1); /* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */ 
    var Bugsnag = {
        _client: null,
        createClient: function(opts) {
            // handle very simple use case where user supplies just the api key as a string
            if (typeof opts === 'string') opts = {
                apiKey: opts
            };
            if (!opts) opts = {};
            var internalPlugins = [
                // add browser-specific plugins
                _$app_38,
                _$device_40(),
                _$context_39(),
                _$request_44(),
                _$throttle_52,
                _$session_45,
                _$clientIp_46,
                _$stripQueryString_53,
                _$onerror_54(),
                _$unhandledRejection_55(),
                _$navigationBreadcrumbs_50(),
                _$interactionBreadcrumbs_49(),
                _$networkBreadcrumbs_51(),
                _$consoleBreadcrumbs_47,
                // this one added last to avoid wrapping functionality before bugsnag uses it
                _$inlineScriptContent_48()
            ];
            // configure a client with user supplied options
            var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
                name: name,
                version: version,
                url: url
            });
            // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)
            bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);
            bugsnag._logger.debug('Loaded!');
            bugsnag.leaveBreadcrumb('Bugsnag loaded', {}, 'state');
            return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
        },
        start: function(opts) {
            if (Bugsnag._client) {
                Bugsnag._client._logger.warn('Bugsnag.start() was called more than once. Ignoring.');
                return Bugsnag._client;
            }
            Bugsnag._client = Bugsnag.createClient(opts);
            return Bugsnag._client;
        },
        isStarted: function() {
            return Bugsnag._client != null;
        }
    };
    _$map_16([
        'resetEventCount'
    ].concat(_$keys_15(_$Client_4.prototype)), function(m) {
        if (/^_/.test(m)) return;
        Bugsnag[m] = function() {
            if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
            Bugsnag._client._depth += 1;
            var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);
            Bugsnag._client._depth -= 1;
            return ret;
        };
    });
    _$notifier_2 = Bugsnag;
    _$notifier_2.Client = _$Client_4;
    _$notifier_2.Event = _$Event_6;
    _$notifier_2.Session = _$Session_35;
    _$notifier_2.Breadcrumb = _$Breadcrumb_3;
    // Export a "default" property for compatibility with ESM imports
    _$notifier_2["default"] = Bugsnag;
    return _$notifier_2;
});

});

/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ function $05f55b05e8c5faeb$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $cd54608a2366dcc8$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $05f55b05e8c5faeb$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $9fceebefc81b9e0c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9fceebefc81b9e0c$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $9fceebefc81b9e0c$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


var $037d96a8ea63578e$exports = {};

$parcel$export($037d96a8ea63578e$exports, "popperGenerator", function () { return $8e50ab7f6df66515$export$ed5e13716264f202; });
$parcel$export($037d96a8ea63578e$exports, "detectOverflow", function () { return $770789f62eaa4fda$export$2e2bcd8739ae039; });
$parcel$export($037d96a8ea63578e$exports, "createPopperBase", function () { return $8e50ab7f6df66515$export$8f7491d57c8f97a9; });
$parcel$export($037d96a8ea63578e$exports, "createPopper", function () { return $e5cb608a34b9518d$export$8f7491d57c8f97a9; });
$parcel$export($037d96a8ea63578e$exports, "createPopperLite", function () { return $62a1e81a3ee64dfb$export$8f7491d57c8f97a9; });
var $4c7f6a037c9619e5$exports = {};

$parcel$export($4c7f6a037c9619e5$exports, "top", function () { return $4c7f6a037c9619e5$export$1e95b668f3b82d; });
$parcel$export($4c7f6a037c9619e5$exports, "bottom", function () { return $4c7f6a037c9619e5$export$40e543e69a8b3fbb; });
$parcel$export($4c7f6a037c9619e5$exports, "right", function () { return $4c7f6a037c9619e5$export$79ffe56a765070d2; });
$parcel$export($4c7f6a037c9619e5$exports, "left", function () { return $4c7f6a037c9619e5$export$eabcd2c8791e7bf4; });
$parcel$export($4c7f6a037c9619e5$exports, "auto", function () { return $4c7f6a037c9619e5$export$dfb5619354ba860; });
$parcel$export($4c7f6a037c9619e5$exports, "basePlacements", function () { return $4c7f6a037c9619e5$export$aec2ce47c367b8c3; });
$parcel$export($4c7f6a037c9619e5$exports, "start", function () { return $4c7f6a037c9619e5$export$b3571188c770cc5a; });
$parcel$export($4c7f6a037c9619e5$exports, "end", function () { return $4c7f6a037c9619e5$export$bd5df0f255a350f8; });
$parcel$export($4c7f6a037c9619e5$exports, "clippingParents", function () { return $4c7f6a037c9619e5$export$390fd549c5303b4d; });
$parcel$export($4c7f6a037c9619e5$exports, "viewport", function () { return $4c7f6a037c9619e5$export$d7b7311ec04a3e8f; });
$parcel$export($4c7f6a037c9619e5$exports, "popper", function () { return $4c7f6a037c9619e5$export$ae5ab1c730825774; });
$parcel$export($4c7f6a037c9619e5$exports, "reference", function () { return $4c7f6a037c9619e5$export$ca50aac9f3ba507f; });
$parcel$export($4c7f6a037c9619e5$exports, "variationPlacements", function () { return $4c7f6a037c9619e5$export$368f9a87e87fa4e1; });
$parcel$export($4c7f6a037c9619e5$exports, "placements", function () { return $4c7f6a037c9619e5$export$803cd8101b6c182b; });
$parcel$export($4c7f6a037c9619e5$exports, "beforeRead", function () { return $4c7f6a037c9619e5$export$421679a7c3d56e; });
$parcel$export($4c7f6a037c9619e5$exports, "read", function () { return $4c7f6a037c9619e5$export$aafa59e2e03f2942; });
$parcel$export($4c7f6a037c9619e5$exports, "afterRead", function () { return $4c7f6a037c9619e5$export$6964f6c886723980; });
$parcel$export($4c7f6a037c9619e5$exports, "beforeMain", function () { return $4c7f6a037c9619e5$export$c65e99957a05207c; });
$parcel$export($4c7f6a037c9619e5$exports, "main", function () { return $4c7f6a037c9619e5$export$f22da7240b7add18; });
$parcel$export($4c7f6a037c9619e5$exports, "afterMain", function () { return $4c7f6a037c9619e5$export$bab79516f2d662fe; });
$parcel$export($4c7f6a037c9619e5$exports, "beforeWrite", function () { return $4c7f6a037c9619e5$export$8d4d2d70e7d46032; });
$parcel$export($4c7f6a037c9619e5$exports, "write", function () { return $4c7f6a037c9619e5$export$68d8715fc104d294; });
$parcel$export($4c7f6a037c9619e5$exports, "afterWrite", function () { return $4c7f6a037c9619e5$export$70a6e5159acce2e6; });
$parcel$export($4c7f6a037c9619e5$exports, "modifierPhases", function () { return $4c7f6a037c9619e5$export$d087d3878fdf71d5; });
var $4c7f6a037c9619e5$export$1e95b668f3b82d = 'top';
var $4c7f6a037c9619e5$export$40e543e69a8b3fbb = 'bottom';
var $4c7f6a037c9619e5$export$79ffe56a765070d2 = 'right';
var $4c7f6a037c9619e5$export$eabcd2c8791e7bf4 = 'left';
var $4c7f6a037c9619e5$export$dfb5619354ba860 = 'auto';
var $4c7f6a037c9619e5$export$aec2ce47c367b8c3 = [
    $4c7f6a037c9619e5$export$1e95b668f3b82d,
    $4c7f6a037c9619e5$export$40e543e69a8b3fbb,
    $4c7f6a037c9619e5$export$79ffe56a765070d2,
    $4c7f6a037c9619e5$export$eabcd2c8791e7bf4
];
var $4c7f6a037c9619e5$export$b3571188c770cc5a = 'start';
var $4c7f6a037c9619e5$export$bd5df0f255a350f8 = 'end';
var $4c7f6a037c9619e5$export$390fd549c5303b4d = 'clippingParents';
var $4c7f6a037c9619e5$export$d7b7311ec04a3e8f = 'viewport';
var $4c7f6a037c9619e5$export$ae5ab1c730825774 = 'popper';
var $4c7f6a037c9619e5$export$ca50aac9f3ba507f = 'reference';
var $4c7f6a037c9619e5$export$368f9a87e87fa4e1 = /*#__PURE__*/ $4c7f6a037c9619e5$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $4c7f6a037c9619e5$export$b3571188c770cc5a,
        placement + "-" + $4c7f6a037c9619e5$export$bd5df0f255a350f8
    ]);
}, []);
var $4c7f6a037c9619e5$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($4c7f6a037c9619e5$export$aec2ce47c367b8c3, [
    $4c7f6a037c9619e5$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $4c7f6a037c9619e5$export$b3571188c770cc5a,
        placement + "-" + $4c7f6a037c9619e5$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $4c7f6a037c9619e5$export$421679a7c3d56e = 'beforeRead';
var $4c7f6a037c9619e5$export$aafa59e2e03f2942 = 'read';
var $4c7f6a037c9619e5$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $4c7f6a037c9619e5$export$c65e99957a05207c = 'beforeMain';
var $4c7f6a037c9619e5$export$f22da7240b7add18 = 'main';
var $4c7f6a037c9619e5$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $4c7f6a037c9619e5$export$8d4d2d70e7d46032 = 'beforeWrite';
var $4c7f6a037c9619e5$export$68d8715fc104d294 = 'write';
var $4c7f6a037c9619e5$export$70a6e5159acce2e6 = 'afterWrite';
var $4c7f6a037c9619e5$export$d087d3878fdf71d5 = [
    $4c7f6a037c9619e5$export$421679a7c3d56e,
    $4c7f6a037c9619e5$export$aafa59e2e03f2942,
    $4c7f6a037c9619e5$export$6964f6c886723980,
    $4c7f6a037c9619e5$export$c65e99957a05207c,
    $4c7f6a037c9619e5$export$f22da7240b7add18,
    $4c7f6a037c9619e5$export$bab79516f2d662fe,
    $4c7f6a037c9619e5$export$8d4d2d70e7d46032,
    $4c7f6a037c9619e5$export$68d8715fc104d294,
    $4c7f6a037c9619e5$export$70a6e5159acce2e6
];


var $90469b276143f673$exports = {};

$parcel$export($90469b276143f673$exports, "applyStyles", function () { return $78af5951cf4897ba$export$2e2bcd8739ae039; });
$parcel$export($90469b276143f673$exports, "arrow", function () { return $f8e4e62f6708da9e$export$2e2bcd8739ae039; });
$parcel$export($90469b276143f673$exports, "computeStyles", function () { return $8d7307b3a288aef8$export$2e2bcd8739ae039; });
$parcel$export($90469b276143f673$exports, "eventListeners", function () { return $3bdd671b5ffd46f4$export$2e2bcd8739ae039; });
$parcel$export($90469b276143f673$exports, "flip", function () { return $96eb7757d648568e$export$2e2bcd8739ae039; });
$parcel$export($90469b276143f673$exports, "hide", function () { return $e87c3f7336375dba$export$2e2bcd8739ae039; });
$parcel$export($90469b276143f673$exports, "offset", function () { return $a3b225f9f5812f1d$export$2e2bcd8739ae039; });
$parcel$export($90469b276143f673$exports, "popperOffsets", function () { return $dc7f9b8aaa318f75$export$2e2bcd8739ae039; });
$parcel$export($90469b276143f673$exports, "preventOverflow", function () { return $9ea0a88c50128771$export$2e2bcd8739ae039; });
function $d9dc50ab2727c933$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $f84ffcac48fe6fde$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $82979bf085cb1a71$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $82979bf085cb1a71$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $82979bf085cb1a71$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $78af5951cf4897ba$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(element) || !(0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $78af5951cf4897ba$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(element) || !(0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $78af5951cf4897ba$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $78af5951cf4897ba$var$applyStyles,
    effect: $78af5951cf4897ba$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $82ebb6e034e8a76c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $d2c1f4881237f690$export$8960430cfd85939f = Math.max;
var $d2c1f4881237f690$export$96ec731ed4dcb222 = Math.min;
var $d2c1f4881237f690$export$2077e0241d6afd3c = Math.round;



function $920284c384f8c3d9$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b1d1981f3edf8366$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $920284c384f8c3d9$export$2e2bcd8739ae039)());
}


function $bf496f0ee5aff42a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $d2c1f4881237f690$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $d2c1f4881237f690$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $82979bf085cb1a71$export$45a5e7f76e0caa8d)(element) ? (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b1d1981f3edf8366$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $7a78d06fd6eec7ae$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bf496f0ee5aff42a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $9a5f5597816d9680$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $82979bf085cb1a71$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $261a055708cd12ce$export$2e2bcd8739ae039(element) {
    return (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $aeff8b562589b15b$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(element)) >= 0;
}




function $8bcd517aa7ee3b5f$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $82979bf085cb1a71$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e086b81abe261aea$export$2e2bcd8739ae039(element) {
    if ((0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $82979bf085cb1a71$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $8bcd517aa7ee3b5f$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $e589a81980a2d4a6$var$getTrueOffsetParent(element) {
    if (!(0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $261a055708cd12ce$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $e589a81980a2d4a6$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $920284c384f8c3d9$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $920284c384f8c3d9$export$2e2bcd8739ae039)());
    if (isIE && (0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $261a055708cd12ce$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $e086b81abe261aea$export$2e2bcd8739ae039)(element);
    if ((0, $82979bf085cb1a71$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $261a055708cd12ce$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $e589a81980a2d4a6$export$2e2bcd8739ae039(element) {
    var window = (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(element);
    var offsetParent = $e589a81980a2d4a6$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $aeff8b562589b15b$export$2e2bcd8739ae039)(offsetParent) && (0, $261a055708cd12ce$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $e589a81980a2d4a6$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $261a055708cd12ce$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $e589a81980a2d4a6$var$getContainingBlock(element) || window;
}


function $1a1ed2218db919e8$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $f69f6c510da2d7b4$export$f28d906d67a997f3(min, value, max) {
    return (0, $d2c1f4881237f690$export$8960430cfd85939f)(min, (0, $d2c1f4881237f690$export$96ec731ed4dcb222)(value, max));
}
function $f69f6c510da2d7b4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $f69f6c510da2d7b4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $ac310f97029236a2$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $cece7ae751f8a327$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $ac310f97029236a2$export$2e2bcd8739ae039)(), paddingObject);
}


function $668f0a26164d060b$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $f8e4e62f6708da9e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cece7ae751f8a327$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $668f0a26164d060b$export$2e2bcd8739ae039)(padding, (0, $4c7f6a037c9619e5$export$aec2ce47c367b8c3)));
};
function $f8e4e62f6708da9e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $1a1ed2218db919e8$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4),
        (0, $4c7f6a037c9619e5$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f8e4e62f6708da9e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7a78d06fd6eec7ae$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $4c7f6a037c9619e5$export$1e95b668f3b82d) : (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb) : (0, $4c7f6a037c9619e5$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $e589a81980a2d4a6$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $f69f6c510da2d7b4$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f8e4e62f6708da9e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $9a5f5597816d9680$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f8e4e62f6708da9e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f8e4e62f6708da9e$var$arrow,
    effect: $f8e4e62f6708da9e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $3df839991f5040f5$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $8d7307b3a288aef8$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8d7307b3a288aef8$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $d2c1f4881237f690$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $d2c1f4881237f690$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $8d7307b3a288aef8$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4);
    var sideY = (0, $4c7f6a037c9619e5$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $e589a81980a2d4a6$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $8bcd517aa7ee3b5f$export$2e2bcd8739ae039)(popper);
            if ((0, $261a055708cd12ce$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $4c7f6a037c9619e5$export$1e95b668f3b82d) || (placement === (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4) || placement === (0, $4c7f6a037c9619e5$export$79ffe56a765070d2)) && variation === (0, $4c7f6a037c9619e5$export$bd5df0f255a350f8)) {
            sideY = (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4) || (placement === (0, $4c7f6a037c9619e5$export$1e95b668f3b82d) || placement === (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb)) && variation === (0, $4c7f6a037c9619e5$export$bd5df0f255a350f8)) {
            sideX = (0, $4c7f6a037c9619e5$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8d7307b3a288aef8$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8d7307b3a288aef8$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $8d7307b3a288aef8$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $3df839991f5040f5$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8d7307b3a288aef8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8d7307b3a288aef8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8d7307b3a288aef8$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $8d7307b3a288aef8$var$computeStyles,
    data: {}
};



var $3bdd671b5ffd46f4$var$passive = {
    passive: true
};
function $3bdd671b5ffd46f4$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3bdd671b5ffd46f4$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3bdd671b5ffd46f4$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3bdd671b5ffd46f4$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3bdd671b5ffd46f4$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3bdd671b5ffd46f4$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3bdd671b5ffd46f4$var$effect,
    data: {}
};


var $fb4f17ff74884c56$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $fb4f17ff74884c56$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $fb4f17ff74884c56$var$hash[matched];
    });
}



var $355856d5f5591eb4$var$hash = {
    start: 'end',
    end: 'start'
};
function $355856d5f5591eb4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $355856d5f5591eb4$var$hash[matched];
    });
}








function $bd0d15af815d9992$export$2e2bcd8739ae039(node) {
    var win = (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $2ed711ce0cc4cb13$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bf496f0ee5aff42a$export$2e2bcd8739ae039)((0, $8bcd517aa7ee3b5f$export$2e2bcd8739ae039)(element)).left + (0, $bd0d15af815d9992$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $3731b58d443dd8af$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(element);
    var html = (0, $8bcd517aa7ee3b5f$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b1d1981f3edf8366$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2ed711ce0cc4cb13$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $6aa147789e5a330d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $8bcd517aa7ee3b5f$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $bd0d15af815d9992$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $d2c1f4881237f690$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $d2c1f4881237f690$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2ed711ce0cc4cb13$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $261a055708cd12ce$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $d2c1f4881237f690$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $871c7a245c20f92e$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $261a055708cd12ce$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $3bfe027a33b152da$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(node) && (0, $871c7a245c20f92e$export$2e2bcd8739ae039)(node)) return node;
    return $3bfe027a33b152da$export$2e2bcd8739ae039((0, $e086b81abe261aea$export$2e2bcd8739ae039)(node));
}





function $e52ab204fe9af9e7$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3bfe027a33b152da$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $871c7a245c20f92e$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($e52ab204fe9af9e7$export$2e2bcd8739ae039((0, $e086b81abe261aea$export$2e2bcd8739ae039)(target)));
}










function $0f48f9148624b463$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $b803b00c64ea4727$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bf496f0ee5aff42a$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $b803b00c64ea4727$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $4c7f6a037c9619e5$export$d7b7311ec04a3e8f) ? (0, $0f48f9148624b463$export$2e2bcd8739ae039)((0, $3731b58d443dd8af$export$2e2bcd8739ae039)(element, strategy)) : (0, $82979bf085cb1a71$export$45a5e7f76e0caa8d)(clippingParent) ? $b803b00c64ea4727$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $0f48f9148624b463$export$2e2bcd8739ae039)((0, $6aa147789e5a330d$export$2e2bcd8739ae039)((0, $8bcd517aa7ee3b5f$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $b803b00c64ea4727$var$getClippingParents(element) {
    var clippingParents = (0, $e52ab204fe9af9e7$export$2e2bcd8739ae039)((0, $e086b81abe261aea$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $261a055708cd12ce$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(element) ? (0, $e589a81980a2d4a6$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $82979bf085cb1a71$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $82979bf085cb1a71$export$45a5e7f76e0caa8d)(clippingParent) && (0, $9a5f5597816d9680$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $b803b00c64ea4727$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $b803b00c64ea4727$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $b803b00c64ea4727$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $d2c1f4881237f690$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $d2c1f4881237f690$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $d2c1f4881237f690$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $d2c1f4881237f690$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $b803b00c64ea4727$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $015967f9392d8cc8$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $3df839991f5040f5$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $4c7f6a037c9619e5$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $4c7f6a037c9619e5$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $1a1ed2218db919e8$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $4c7f6a037c9619e5$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $4c7f6a037c9619e5$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $770789f62eaa4fda$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $4c7f6a037c9619e5$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $4c7f6a037c9619e5$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $4c7f6a037c9619e5$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cece7ae751f8a327$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $668f0a26164d060b$export$2e2bcd8739ae039)(padding, (0, $4c7f6a037c9619e5$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $4c7f6a037c9619e5$export$ae5ab1c730825774) ? (0, $4c7f6a037c9619e5$export$ca50aac9f3ba507f) : (0, $4c7f6a037c9619e5$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $b803b00c64ea4727$export$2e2bcd8739ae039)((0, $82979bf085cb1a71$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $8bcd517aa7ee3b5f$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bf496f0ee5aff42a$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $015967f9392d8cc8$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $0f48f9148624b463$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $4c7f6a037c9619e5$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $4c7f6a037c9619e5$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $4c7f6a037c9619e5$export$79ffe56a765070d2),
                (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $4c7f6a037c9619e5$export$1e95b668f3b82d),
                (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $6fbc14ab236c3faf$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $4c7f6a037c9619e5$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $3df839991f5040f5$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $4c7f6a037c9619e5$export$368f9a87e87fa4e1) : (0, $4c7f6a037c9619e5$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $3df839991f5040f5$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $4c7f6a037c9619e5$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $770789f62eaa4fda$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $96eb7757d648568e$var$getExpandedFallbackPlacements(placement) {
    if ((0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(placement) === (0, $4c7f6a037c9619e5$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $fb4f17ff74884c56$export$2e2bcd8739ae039)(placement);
    return [
        (0, $355856d5f5591eb4$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $355856d5f5591eb4$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $96eb7757d648568e$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $fb4f17ff74884c56$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $96eb7757d648568e$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(placement) === (0, $4c7f6a037c9619e5$export$dfb5619354ba860) ? (0, $6fbc14ab236c3faf$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $3df839991f5040f5$export$2e2bcd8739ae039)(placement) === (0, $4c7f6a037c9619e5$export$b3571188c770cc5a);
        var isVertical = [
            (0, $4c7f6a037c9619e5$export$1e95b668f3b82d),
            (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $770789f62eaa4fda$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $4c7f6a037c9619e5$export$79ffe56a765070d2) : (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb) : (0, $4c7f6a037c9619e5$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $fb4f17ff74884c56$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $fb4f17ff74884c56$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $96eb7757d648568e$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $96eb7757d648568e$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $e87c3f7336375dba$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $e87c3f7336375dba$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $4c7f6a037c9619e5$export$1e95b668f3b82d),
        (0, $4c7f6a037c9619e5$export$79ffe56a765070d2),
        (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb),
        (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $e87c3f7336375dba$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $770789f62eaa4fda$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $770789f62eaa4fda$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $e87c3f7336375dba$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $e87c3f7336375dba$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $e87c3f7336375dba$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $e87c3f7336375dba$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $e87c3f7336375dba$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $e87c3f7336375dba$var$hide
};




function $a3b225f9f5812f1d$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4),
        (0, $4c7f6a037c9619e5$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4),
        (0, $4c7f6a037c9619e5$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a3b225f9f5812f1d$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $4c7f6a037c9619e5$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a3b225f9f5812f1d$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a3b225f9f5812f1d$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a3b225f9f5812f1d$var$offset
};



function $dc7f9b8aaa318f75$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $015967f9392d8cc8$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dc7f9b8aaa318f75$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $dc7f9b8aaa318f75$var$popperOffsets,
    data: {}
};





function $f4ee4995e871c163$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $9ea0a88c50128771$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $770789f62eaa4fda$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $82ebb6e034e8a76c$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $3df839991f5040f5$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $1a1ed2218db919e8$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $f4ee4995e871c163$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $4c7f6a037c9619e5$export$1e95b668f3b82d) : (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb) : (0, $4c7f6a037c9619e5$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $4c7f6a037c9619e5$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $4c7f6a037c9619e5$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7a78d06fd6eec7ae$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $ac310f97029236a2$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $f69f6c510da2d7b4$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $e589a81980a2d4a6$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $f69f6c510da2d7b4$export$f28d906d67a997f3)(tether ? (0, $d2c1f4881237f690$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $d2c1f4881237f690$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $4c7f6a037c9619e5$export$1e95b668f3b82d) : (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $4c7f6a037c9619e5$export$40e543e69a8b3fbb) : (0, $4c7f6a037c9619e5$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $4c7f6a037c9619e5$export$1e95b668f3b82d),
            (0, $4c7f6a037c9619e5$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $f69f6c510da2d7b4$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $f69f6c510da2d7b4$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9ea0a88c50128771$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9ea0a88c50128771$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $33b5d53c16f2cb83$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $fb0da281412f95b0$export$2e2bcd8739ae039(node) {
    if (node === (0, $f84ffcac48fe6fde$export$2e2bcd8739ae039)(node) || !(0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(node)) return (0, $bd0d15af815d9992$export$2e2bcd8739ae039)(node);
    else return (0, $33b5d53c16f2cb83$export$2e2bcd8739ae039)(node);
}








function $51b3c61a2cadbe2b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $d2c1f4881237f690$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $d2c1f4881237f690$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $51b3c61a2cadbe2b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(offsetParent) && $51b3c61a2cadbe2b$var$isElementScaled(offsetParent);
    var documentElement = (0, $8bcd517aa7ee3b5f$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $bf496f0ee5aff42a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d9dc50ab2727c933$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $871c7a245c20f92e$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $fb0da281412f95b0$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $82979bf085cb1a71$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $bf496f0ee5aff42a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2ed711ce0cc4cb13$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $dc350932c1130bd3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $dc350932c1130bd3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $dc350932c1130bd3$var$order(modifiers); // order based on phase
    return (0, $4c7f6a037c9619e5$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $c77bf4e23a5cba8e$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $36b8499de20a552a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $8e50ab7f6df66515$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $8e50ab7f6df66515$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $8e50ab7f6df66515$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $8e50ab7f6df66515$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $8e50ab7f6df66515$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $82979bf085cb1a71$export$45a5e7f76e0caa8d)(reference) ? (0, $e52ab204fe9af9e7$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $e52ab204fe9af9e7$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $e52ab204fe9af9e7$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $dc350932c1130bd3$export$2e2bcd8739ae039)((0, $36b8499de20a552a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$8e50ab7f6df66515$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $51b3c61a2cadbe2b$export$2e2bcd8739ae039)(reference, (0, $e589a81980a2d4a6$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $7a78d06fd6eec7ae$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $c77bf4e23a5cba8e$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$8e50ab7f6df66515$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $8e50ab7f6df66515$export$8f7491d57c8f97a9 = /*#__PURE__*/ $8e50ab7f6df66515$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $e5cb608a34b9518d$export$d34966752335dd47 = [
    (0, $3bdd671b5ffd46f4$export$2e2bcd8739ae039),
    (0, $dc7f9b8aaa318f75$export$2e2bcd8739ae039),
    (0, $8d7307b3a288aef8$export$2e2bcd8739ae039),
    (0, $78af5951cf4897ba$export$2e2bcd8739ae039),
    (0, $a3b225f9f5812f1d$export$2e2bcd8739ae039),
    (0, $96eb7757d648568e$export$2e2bcd8739ae039),
    (0, $9ea0a88c50128771$export$2e2bcd8739ae039),
    (0, $f8e4e62f6708da9e$export$2e2bcd8739ae039),
    (0, $e87c3f7336375dba$export$2e2bcd8739ae039)
];
var $e5cb608a34b9518d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8e50ab7f6df66515$export$ed5e13716264f202)({
    defaultModifiers: $e5cb608a34b9518d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $62a1e81a3ee64dfb$export$d34966752335dd47 = [
    (0, $3bdd671b5ffd46f4$export$2e2bcd8739ae039),
    (0, $dc7f9b8aaa318f75$export$2e2bcd8739ae039),
    (0, $8d7307b3a288aef8$export$2e2bcd8739ae039),
    (0, $78af5951cf4897ba$export$2e2bcd8739ae039)
];
var $62a1e81a3ee64dfb$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8e50ab7f6df66515$export$ed5e13716264f202)({
    defaultModifiers: $62a1e81a3ee64dfb$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($037d96a8ea63578e$exports, $4c7f6a037c9619e5$exports);
$parcel$exportWildcard($037d96a8ea63578e$exports, $90469b276143f673$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$elementMap = new Map();
const $bc78252b337306e3$var$Data = {
    set (element, key, instance) {
        if (!$bc78252b337306e3$var$elementMap.has(element)) $bc78252b337306e3$var$elementMap.set(element, new Map());
        const instanceMap = $bc78252b337306e3$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($bc78252b337306e3$var$elementMap.has(element)) return $bc78252b337306e3$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$bc78252b337306e3$var$elementMap.has(element)) return;
        const instanceMap = $bc78252b337306e3$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $bc78252b337306e3$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $bc78252b337306e3$var$MAX_UID = 1000000;
const $bc78252b337306e3$var$MILLISECONDS_MULTIPLIER = 1000;
const $bc78252b337306e3$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $bc78252b337306e3$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $bc78252b337306e3$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $bc78252b337306e3$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $bc78252b337306e3$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $bc78252b337306e3$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $bc78252b337306e3$var$MILLISECONDS_MULTIPLIER;
};
const $bc78252b337306e3$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($bc78252b337306e3$var$TRANSITION_END));
};
const $bc78252b337306e3$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $bc78252b337306e3$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($bc78252b337306e3$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($bc78252b337306e3$var$parseSelector(object));
    return null;
};
const $bc78252b337306e3$var$isVisible = (element)=>{
    if (!$bc78252b337306e3$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $bc78252b337306e3$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $bc78252b337306e3$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $bc78252b337306e3$var$findShadowRoot(element.parentNode);
};
const $bc78252b337306e3$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $bc78252b337306e3$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $bc78252b337306e3$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $bc78252b337306e3$var$DOMContentLoadedCallbacks = [];
const $bc78252b337306e3$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$bc78252b337306e3$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $bc78252b337306e3$var$DOMContentLoadedCallbacks)callback();
        });
        $bc78252b337306e3$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $bc78252b337306e3$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $bc78252b337306e3$var$defineJQueryPlugin = (plugin)=>{
    $bc78252b337306e3$var$onDOMContentLoaded(()=>{
        const $ = $bc78252b337306e3$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $bc78252b337306e3$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $bc78252b337306e3$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $bc78252b337306e3$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $bc78252b337306e3$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($bc78252b337306e3$var$TRANSITION_END, handler);
        $bc78252b337306e3$var$execute(callback);
    };
    transitionElement.addEventListener($bc78252b337306e3$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $bc78252b337306e3$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $bc78252b337306e3$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $bc78252b337306e3$var$stripNameRegex = /\..*/;
const $bc78252b337306e3$var$stripUidRegex = /::\d+$/;
const $bc78252b337306e3$var$eventRegistry = {}; // Events storage
let $bc78252b337306e3$var$uidEvent = 1;
const $bc78252b337306e3$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $bc78252b337306e3$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $bc78252b337306e3$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$bc78252b337306e3$var$uidEvent++}` || element.uidEvent || $bc78252b337306e3$var$uidEvent++;
}
function $bc78252b337306e3$var$getElementEvents(element) {
    const uid = $bc78252b337306e3$var$makeEventUid(element);
    element.uidEvent = uid;
    $bc78252b337306e3$var$eventRegistry[uid] = $bc78252b337306e3$var$eventRegistry[uid] || {};
    return $bc78252b337306e3$var$eventRegistry[uid];
}
function $bc78252b337306e3$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $bc78252b337306e3$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $bc78252b337306e3$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $bc78252b337306e3$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $bc78252b337306e3$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $bc78252b337306e3$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $bc78252b337306e3$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $bc78252b337306e3$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $bc78252b337306e3$var$getTypeEvent(originalTypeEvent);
    if (!$bc78252b337306e3$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $bc78252b337306e3$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $bc78252b337306e3$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $bc78252b337306e3$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $bc78252b337306e3$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $bc78252b337306e3$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $bc78252b337306e3$var$makeEventUid(callable, originalTypeEvent.replace($bc78252b337306e3$var$namespaceRegex, ''));
    const fn = isDelegated ? $bc78252b337306e3$var$bootstrapDelegationHandler(element, handler, callable) : $bc78252b337306e3$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $bc78252b337306e3$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $bc78252b337306e3$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $bc78252b337306e3$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $bc78252b337306e3$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $bc78252b337306e3$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($bc78252b337306e3$var$stripNameRegex, '');
    return $bc78252b337306e3$var$customEvents[event] || event;
}
const $bc78252b337306e3$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $bc78252b337306e3$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $bc78252b337306e3$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $bc78252b337306e3$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $bc78252b337306e3$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $bc78252b337306e3$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$bc78252b337306e3$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($bc78252b337306e3$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $bc78252b337306e3$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $bc78252b337306e3$var$getjQuery();
        const typeEvent = $bc78252b337306e3$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $bc78252b337306e3$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $bc78252b337306e3$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $bc78252b337306e3$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $bc78252b337306e3$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $bc78252b337306e3$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$bc78252b337306e3$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$bc78252b337306e3$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $bc78252b337306e3$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $bc78252b337306e3$var$normalizeData(element.getAttribute(`data-bs-${$bc78252b337306e3$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $bc78252b337306e3$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $bc78252b337306e3$var$isElement(element) ? $bc78252b337306e3$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return (0, $cd54608a2366dcc8$export$71511d61b312f219)({}, this.constructor.Default, typeof jsonConfig === 'object' ? jsonConfig : {}, $bc78252b337306e3$var$isElement(element) ? $bc78252b337306e3$var$Manipulator.getDataAttributes(element) : {}, typeof config === 'object' ? config : {});
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $bc78252b337306e3$var$isElement(value) ? 'element' : $bc78252b337306e3$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $bc78252b337306e3$var$BaseComponent extends $bc78252b337306e3$var$Config {
    // Public
    dispose() {
        $bc78252b337306e3$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $bc78252b337306e3$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $bc78252b337306e3$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $bc78252b337306e3$var$Data.get($bc78252b337306e3$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $bc78252b337306e3$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
    constructor(element, config){
        super();
        element = $bc78252b337306e3$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $bc78252b337306e3$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $bc78252b337306e3$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$bc78252b337306e3$var$parseSelector(sel)).join(',') : null;
};
const $bc78252b337306e3$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$bc78252b337306e3$var$isDisabled(el) && $bc78252b337306e3$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $bc78252b337306e3$var$getSelector(element);
        if (selector) return $bc78252b337306e3$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $bc78252b337306e3$var$getSelector(element);
        return selector ? $bc78252b337306e3$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $bc78252b337306e3$var$getSelector(element);
        return selector ? $bc78252b337306e3$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $bc78252b337306e3$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $bc78252b337306e3$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($bc78252b337306e3$var$isDisabled(this)) return;
        const target = $bc78252b337306e3$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$f = 'alert';
const $bc78252b337306e3$var$DATA_KEY$a = 'bs.alert';
const $bc78252b337306e3$var$EVENT_KEY$b = `.${$bc78252b337306e3$var$DATA_KEY$a}`;
const $bc78252b337306e3$var$EVENT_CLOSE = `close${$bc78252b337306e3$var$EVENT_KEY$b}`;
const $bc78252b337306e3$var$EVENT_CLOSED = `closed${$bc78252b337306e3$var$EVENT_KEY$b}`;
const $bc78252b337306e3$var$CLASS_NAME_FADE$5 = 'fade';
const $bc78252b337306e3$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $bc78252b337306e3$export$caec2af78bcc877f extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get NAME() {
        return $bc78252b337306e3$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($bc78252b337306e3$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$enableDismissTrigger($bc78252b337306e3$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$e = 'button';
const $bc78252b337306e3$var$DATA_KEY$9 = 'bs.button';
const $bc78252b337306e3$var$EVENT_KEY$a = `.${$bc78252b337306e3$var$DATA_KEY$9}`;
const $bc78252b337306e3$var$DATA_API_KEY$6 = '.data-api';
const $bc78252b337306e3$var$CLASS_NAME_ACTIVE$3 = 'active';
const $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $bc78252b337306e3$var$EVENT_CLICK_DATA_API$6 = `click${$bc78252b337306e3$var$EVENT_KEY$a}${$bc78252b337306e3$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $bc78252b337306e3$export$353f5b6fc5456de1 extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get NAME() {
        return $bc78252b337306e3$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($bc78252b337306e3$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_CLICK_DATA_API$6, $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$5);
    const data = $bc78252b337306e3$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$d = 'swipe';
const $bc78252b337306e3$var$EVENT_KEY$9 = '.bs.swipe';
const $bc78252b337306e3$var$EVENT_TOUCHSTART = `touchstart${$bc78252b337306e3$var$EVENT_KEY$9}`;
const $bc78252b337306e3$var$EVENT_TOUCHMOVE = `touchmove${$bc78252b337306e3$var$EVENT_KEY$9}`;
const $bc78252b337306e3$var$EVENT_TOUCHEND = `touchend${$bc78252b337306e3$var$EVENT_KEY$9}`;
const $bc78252b337306e3$var$EVENT_POINTERDOWN = `pointerdown${$bc78252b337306e3$var$EVENT_KEY$9}`;
const $bc78252b337306e3$var$EVENT_POINTERUP = `pointerup${$bc78252b337306e3$var$EVENT_KEY$9}`;
const $bc78252b337306e3$var$POINTER_TYPE_TOUCH = 'touch';
const $bc78252b337306e3$var$POINTER_TYPE_PEN = 'pen';
const $bc78252b337306e3$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $bc78252b337306e3$var$SWIPE_THRESHOLD = 40;
const $bc78252b337306e3$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $bc78252b337306e3$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $bc78252b337306e3$var$Swipe extends $bc78252b337306e3$var$Config {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$c;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$c;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$d;
    }
    // Public
    dispose() {
        $bc78252b337306e3$var$EventHandler.off(this._element, $bc78252b337306e3$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $bc78252b337306e3$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $bc78252b337306e3$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $bc78252b337306e3$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $bc78252b337306e3$var$POINTER_TYPE_PEN || event.pointerType === $bc78252b337306e3$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$bc78252b337306e3$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$c = 'carousel';
const $bc78252b337306e3$var$DATA_KEY$8 = 'bs.carousel';
const $bc78252b337306e3$var$EVENT_KEY$8 = `.${$bc78252b337306e3$var$DATA_KEY$8}`;
const $bc78252b337306e3$var$DATA_API_KEY$5 = '.data-api';
const $bc78252b337306e3$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $bc78252b337306e3$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $bc78252b337306e3$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $bc78252b337306e3$var$ORDER_NEXT = 'next';
const $bc78252b337306e3$var$ORDER_PREV = 'prev';
const $bc78252b337306e3$var$DIRECTION_LEFT = 'left';
const $bc78252b337306e3$var$DIRECTION_RIGHT = 'right';
const $bc78252b337306e3$var$EVENT_SLIDE = `slide${$bc78252b337306e3$var$EVENT_KEY$8}`;
const $bc78252b337306e3$var$EVENT_SLID = `slid${$bc78252b337306e3$var$EVENT_KEY$8}`;
const $bc78252b337306e3$var$EVENT_KEYDOWN$1 = `keydown${$bc78252b337306e3$var$EVENT_KEY$8}`;
const $bc78252b337306e3$var$EVENT_MOUSEENTER$1 = `mouseenter${$bc78252b337306e3$var$EVENT_KEY$8}`;
const $bc78252b337306e3$var$EVENT_MOUSELEAVE$1 = `mouseleave${$bc78252b337306e3$var$EVENT_KEY$8}`;
const $bc78252b337306e3$var$EVENT_DRAG_START = `dragstart${$bc78252b337306e3$var$EVENT_KEY$8}`;
const $bc78252b337306e3$var$EVENT_LOAD_DATA_API$3 = `load${$bc78252b337306e3$var$EVENT_KEY$8}${$bc78252b337306e3$var$DATA_API_KEY$5}`;
const $bc78252b337306e3$var$EVENT_CLICK_DATA_API$5 = `click${$bc78252b337306e3$var$EVENT_KEY$8}${$bc78252b337306e3$var$DATA_API_KEY$5}`;
const $bc78252b337306e3$var$CLASS_NAME_CAROUSEL = 'carousel';
const $bc78252b337306e3$var$CLASS_NAME_ACTIVE$2 = 'active';
const $bc78252b337306e3$var$CLASS_NAME_SLIDE = 'slide';
const $bc78252b337306e3$var$CLASS_NAME_END = 'carousel-item-end';
const $bc78252b337306e3$var$CLASS_NAME_START = 'carousel-item-start';
const $bc78252b337306e3$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $bc78252b337306e3$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $bc78252b337306e3$var$SELECTOR_ACTIVE = '.active';
const $bc78252b337306e3$var$SELECTOR_ITEM = '.carousel-item';
const $bc78252b337306e3$var$SELECTOR_ACTIVE_ITEM = $bc78252b337306e3$var$SELECTOR_ACTIVE + $bc78252b337306e3$var$SELECTOR_ITEM;
const $bc78252b337306e3$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $bc78252b337306e3$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $bc78252b337306e3$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $bc78252b337306e3$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $bc78252b337306e3$var$KEY_TO_DIRECTION = {
    [$bc78252b337306e3$var$ARROW_LEFT_KEY$1]: $bc78252b337306e3$var$DIRECTION_RIGHT,
    [$bc78252b337306e3$var$ARROW_RIGHT_KEY$1]: $bc78252b337306e3$var$DIRECTION_LEFT
};
const $bc78252b337306e3$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $bc78252b337306e3$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $bc78252b337306e3$export$144901db2ea8e967 extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$b;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$b;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$c;
    }
    // Public
    next() {
        this._slide($bc78252b337306e3$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $bc78252b337306e3$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($bc78252b337306e3$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $bc78252b337306e3$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $bc78252b337306e3$var$EventHandler.one(this._element, $bc78252b337306e3$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $bc78252b337306e3$var$EventHandler.one(this._element, $bc78252b337306e3$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $bc78252b337306e3$var$ORDER_NEXT : $bc78252b337306e3$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $bc78252b337306e3$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_ITEM_IMG, this._element))$bc78252b337306e3$var$EventHandler.on(img, $bc78252b337306e3$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $bc78252b337306e3$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($bc78252b337306e3$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($bc78252b337306e3$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $bc78252b337306e3$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $bc78252b337306e3$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($bc78252b337306e3$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $bc78252b337306e3$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($bc78252b337306e3$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $bc78252b337306e3$var$ORDER_NEXT;
        const nextElement = element || $bc78252b337306e3$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $bc78252b337306e3$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($bc78252b337306e3$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $bc78252b337306e3$var$CLASS_NAME_START : $bc78252b337306e3$var$CLASS_NAME_END;
        const orderClassName = isNext ? $bc78252b337306e3$var$CLASS_NAME_NEXT : $bc78252b337306e3$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $bc78252b337306e3$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($bc78252b337306e3$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($bc78252b337306e3$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($bc78252b337306e3$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($bc78252b337306e3$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($bc78252b337306e3$var$isRTL()) return direction === $bc78252b337306e3$var$DIRECTION_LEFT ? $bc78252b337306e3$var$ORDER_PREV : $bc78252b337306e3$var$ORDER_NEXT;
        return direction === $bc78252b337306e3$var$DIRECTION_LEFT ? $bc78252b337306e3$var$ORDER_NEXT : $bc78252b337306e3$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($bc78252b337306e3$var$isRTL()) return order === $bc78252b337306e3$var$ORDER_PREV ? $bc78252b337306e3$var$DIRECTION_LEFT : $bc78252b337306e3$var$DIRECTION_RIGHT;
        return order === $bc78252b337306e3$var$ORDER_PREV ? $bc78252b337306e3$var$DIRECTION_RIGHT : $bc78252b337306e3$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $bc78252b337306e3$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_CLICK_DATA_API$5, $bc78252b337306e3$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $bc78252b337306e3$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($bc78252b337306e3$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $bc78252b337306e3$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($bc78252b337306e3$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$bc78252b337306e3$var$EventHandler.on(window, $bc78252b337306e3$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$bc78252b337306e3$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$b = 'collapse';
const $bc78252b337306e3$var$DATA_KEY$7 = 'bs.collapse';
const $bc78252b337306e3$var$EVENT_KEY$7 = `.${$bc78252b337306e3$var$DATA_KEY$7}`;
const $bc78252b337306e3$var$DATA_API_KEY$4 = '.data-api';
const $bc78252b337306e3$var$EVENT_SHOW$6 = `show${$bc78252b337306e3$var$EVENT_KEY$7}`;
const $bc78252b337306e3$var$EVENT_SHOWN$6 = `shown${$bc78252b337306e3$var$EVENT_KEY$7}`;
const $bc78252b337306e3$var$EVENT_HIDE$6 = `hide${$bc78252b337306e3$var$EVENT_KEY$7}`;
const $bc78252b337306e3$var$EVENT_HIDDEN$6 = `hidden${$bc78252b337306e3$var$EVENT_KEY$7}`;
const $bc78252b337306e3$var$EVENT_CLICK_DATA_API$4 = `click${$bc78252b337306e3$var$EVENT_KEY$7}${$bc78252b337306e3$var$DATA_API_KEY$4}`;
const $bc78252b337306e3$var$CLASS_NAME_SHOW$7 = 'show';
const $bc78252b337306e3$var$CLASS_NAME_COLLAPSE = 'collapse';
const $bc78252b337306e3$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $bc78252b337306e3$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $bc78252b337306e3$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$bc78252b337306e3$var$CLASS_NAME_COLLAPSE} .${$bc78252b337306e3$var$CLASS_NAME_COLLAPSE}`;
const $bc78252b337306e3$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $bc78252b337306e3$var$WIDTH = 'width';
const $bc78252b337306e3$var$HEIGHT = 'height';
const $bc78252b337306e3$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $bc78252b337306e3$var$Default$a = {
    parent: null,
    toggle: true
};
const $bc78252b337306e3$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $bc78252b337306e3$export$78768a9af065a7b extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$a;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$a;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($bc78252b337306e3$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$bc78252b337306e3$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_COLLAPSE, $bc78252b337306e3$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $bc78252b337306e3$var$reflow(this._element);
        this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_COLLAPSE, $bc78252b337306e3$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $bc78252b337306e3$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_COLLAPSE);
            $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($bc78252b337306e3$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $bc78252b337306e3$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($bc78252b337306e3$var$CLASS_NAME_HORIZONTAL) ? $bc78252b337306e3$var$WIDTH : $bc78252b337306e3$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $bc78252b337306e3$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $bc78252b337306e3$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($bc78252b337306e3$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $bc78252b337306e3$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $bc78252b337306e3$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $bc78252b337306e3$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_CLICK_DATA_API$4, $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $bc78252b337306e3$var$SelectorEngine.getMultipleElementsFromSelector(this))$bc78252b337306e3$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$a = 'dropdown';
const $bc78252b337306e3$var$DATA_KEY$6 = 'bs.dropdown';
const $bc78252b337306e3$var$EVENT_KEY$6 = `.${$bc78252b337306e3$var$DATA_KEY$6}`;
const $bc78252b337306e3$var$DATA_API_KEY$3 = '.data-api';
const $bc78252b337306e3$var$ESCAPE_KEY$2 = 'Escape';
const $bc78252b337306e3$var$TAB_KEY$1 = 'Tab';
const $bc78252b337306e3$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $bc78252b337306e3$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $bc78252b337306e3$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $bc78252b337306e3$var$EVENT_HIDE$5 = `hide${$bc78252b337306e3$var$EVENT_KEY$6}`;
const $bc78252b337306e3$var$EVENT_HIDDEN$5 = `hidden${$bc78252b337306e3$var$EVENT_KEY$6}`;
const $bc78252b337306e3$var$EVENT_SHOW$5 = `show${$bc78252b337306e3$var$EVENT_KEY$6}`;
const $bc78252b337306e3$var$EVENT_SHOWN$5 = `shown${$bc78252b337306e3$var$EVENT_KEY$6}`;
const $bc78252b337306e3$var$EVENT_CLICK_DATA_API$3 = `click${$bc78252b337306e3$var$EVENT_KEY$6}${$bc78252b337306e3$var$DATA_API_KEY$3}`;
const $bc78252b337306e3$var$EVENT_KEYDOWN_DATA_API = `keydown${$bc78252b337306e3$var$EVENT_KEY$6}${$bc78252b337306e3$var$DATA_API_KEY$3}`;
const $bc78252b337306e3$var$EVENT_KEYUP_DATA_API = `keyup${$bc78252b337306e3$var$EVENT_KEY$6}${$bc78252b337306e3$var$DATA_API_KEY$3}`;
const $bc78252b337306e3$var$CLASS_NAME_SHOW$6 = 'show';
const $bc78252b337306e3$var$CLASS_NAME_DROPUP = 'dropup';
const $bc78252b337306e3$var$CLASS_NAME_DROPEND = 'dropend';
const $bc78252b337306e3$var$CLASS_NAME_DROPSTART = 'dropstart';
const $bc78252b337306e3$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $bc78252b337306e3$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$3}.${$bc78252b337306e3$var$CLASS_NAME_SHOW$6}`;
const $bc78252b337306e3$var$SELECTOR_MENU = '.dropdown-menu';
const $bc78252b337306e3$var$SELECTOR_NAVBAR = '.navbar';
const $bc78252b337306e3$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $bc78252b337306e3$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $bc78252b337306e3$var$PLACEMENT_TOP = $bc78252b337306e3$var$isRTL() ? 'top-end' : 'top-start';
const $bc78252b337306e3$var$PLACEMENT_TOPEND = $bc78252b337306e3$var$isRTL() ? 'top-start' : 'top-end';
const $bc78252b337306e3$var$PLACEMENT_BOTTOM = $bc78252b337306e3$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $bc78252b337306e3$var$PLACEMENT_BOTTOMEND = $bc78252b337306e3$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $bc78252b337306e3$var$PLACEMENT_RIGHT = $bc78252b337306e3$var$isRTL() ? 'left-start' : 'right-start';
const $bc78252b337306e3$var$PLACEMENT_LEFT = $bc78252b337306e3$var$isRTL() ? 'right-start' : 'left-start';
const $bc78252b337306e3$var$PLACEMENT_TOPCENTER = 'top';
const $bc78252b337306e3$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $bc78252b337306e3$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $bc78252b337306e3$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $bc78252b337306e3$export$931cbfb6bfb85fc extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$9;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$9;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($bc78252b337306e3$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($bc78252b337306e3$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$bc78252b337306e3$var$EventHandler.on(element, 'mouseover', $bc78252b337306e3$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOW$6);
        $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($bc78252b337306e3$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$bc78252b337306e3$var$EventHandler.off(element, 'mouseover', $bc78252b337306e3$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $bc78252b337306e3$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$bc78252b337306e3$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$bc78252b337306e3$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $037d96a8ea63578e$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($bc78252b337306e3$var$isElement(this._config.reference)) referenceElement = $bc78252b337306e3$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $037d96a8ea63578e$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($bc78252b337306e3$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($bc78252b337306e3$var$CLASS_NAME_DROPEND)) return $bc78252b337306e3$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($bc78252b337306e3$var$CLASS_NAME_DROPSTART)) return $bc78252b337306e3$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($bc78252b337306e3$var$CLASS_NAME_DROPUP_CENTER)) return $bc78252b337306e3$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($bc78252b337306e3$var$CLASS_NAME_DROPDOWN_CENTER)) return $bc78252b337306e3$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($bc78252b337306e3$var$CLASS_NAME_DROPUP)) return isEnd ? $bc78252b337306e3$var$PLACEMENT_TOPEND : $bc78252b337306e3$var$PLACEMENT_TOP;
        return isEnd ? $bc78252b337306e3$var$PLACEMENT_BOTTOMEND : $bc78252b337306e3$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($bc78252b337306e3$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $bc78252b337306e3$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return (0, $cd54608a2366dcc8$export$71511d61b312f219)({}, defaultBsPopperConfig, $bc78252b337306e3$var$execute(this._config.popperConfig, [
            undefined,
            defaultBsPopperConfig
        ]));
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$bc78252b337306e3$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $bc78252b337306e3$var$getNextActiveElement(items, target, key === $bc78252b337306e3$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $bc78252b337306e3$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $bc78252b337306e3$var$TAB_KEY$1) return;
        const openToggles = $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $bc78252b337306e3$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $bc78252b337306e3$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $bc78252b337306e3$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $bc78252b337306e3$var$ARROW_UP_KEY$1,
            $bc78252b337306e3$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$3) ? this : $bc78252b337306e3$var$SelectorEngine.prev(this, $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$3)[0] || $bc78252b337306e3$var$SelectorEngine.next(this, $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$3)[0] || $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $bc78252b337306e3$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $bc78252b337306e3$var$SelectorEngine.next(this._element, $bc78252b337306e3$var$SELECTOR_MENU)[0] || $bc78252b337306e3$var$SelectorEngine.prev(this._element, $bc78252b337306e3$var$SELECTOR_MENU)[0] || $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_KEYDOWN_DATA_API, $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$3, $bc78252b337306e3$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_KEYDOWN_DATA_API, $bc78252b337306e3$var$SELECTOR_MENU, $bc78252b337306e3$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_CLICK_DATA_API$3, $bc78252b337306e3$export$931cbfb6bfb85fc.clearMenus);
$bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_KEYUP_DATA_API, $bc78252b337306e3$export$931cbfb6bfb85fc.clearMenus);
$bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_CLICK_DATA_API$3, $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $bc78252b337306e3$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$9 = 'backdrop';
const $bc78252b337306e3$var$CLASS_NAME_FADE$4 = 'fade';
const $bc78252b337306e3$var$CLASS_NAME_SHOW$5 = 'show';
const $bc78252b337306e3$var$EVENT_MOUSEDOWN = `mousedown.bs.${$bc78252b337306e3$var$NAME$9}`;
const $bc78252b337306e3$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $bc78252b337306e3$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $bc78252b337306e3$var$Backdrop extends $bc78252b337306e3$var$Config {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$8;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$8;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $bc78252b337306e3$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $bc78252b337306e3$var$reflow(element);
        element.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $bc78252b337306e3$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $bc78252b337306e3$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $bc78252b337306e3$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $bc78252b337306e3$var$EventHandler.off(this._element, $bc78252b337306e3$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($bc78252b337306e3$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $bc78252b337306e3$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $bc78252b337306e3$var$EventHandler.on(element, $bc78252b337306e3$var$EVENT_MOUSEDOWN, ()=>{
            $bc78252b337306e3$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $bc78252b337306e3$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$8 = 'focustrap';
const $bc78252b337306e3$var$DATA_KEY$5 = 'bs.focustrap';
const $bc78252b337306e3$var$EVENT_KEY$5 = `.${$bc78252b337306e3$var$DATA_KEY$5}`;
const $bc78252b337306e3$var$EVENT_FOCUSIN$2 = `focusin${$bc78252b337306e3$var$EVENT_KEY$5}`;
const $bc78252b337306e3$var$EVENT_KEYDOWN_TAB = `keydown.tab${$bc78252b337306e3$var$EVENT_KEY$5}`;
const $bc78252b337306e3$var$TAB_KEY = 'Tab';
const $bc78252b337306e3$var$TAB_NAV_FORWARD = 'forward';
const $bc78252b337306e3$var$TAB_NAV_BACKWARD = 'backward';
const $bc78252b337306e3$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $bc78252b337306e3$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $bc78252b337306e3$var$FocusTrap extends $bc78252b337306e3$var$Config {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$7;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$7;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $bc78252b337306e3$var$EventHandler.off(document, $bc78252b337306e3$var$EVENT_KEY$5); // guard against infinite focus loop
        $bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $bc78252b337306e3$var$EventHandler.off(document, $bc78252b337306e3$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $bc78252b337306e3$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $bc78252b337306e3$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $bc78252b337306e3$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $bc78252b337306e3$var$TAB_NAV_BACKWARD : $bc78252b337306e3$var$TAB_NAV_FORWARD;
    }
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $bc78252b337306e3$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $bc78252b337306e3$var$PROPERTY_PADDING = 'padding-right';
const $bc78252b337306e3$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $bc78252b337306e3$var$ScrollBarHelper {
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $bc78252b337306e3$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($bc78252b337306e3$var$SELECTOR_FIXED_CONTENT, $bc78252b337306e3$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($bc78252b337306e3$var$SELECTOR_STICKY_CONTENT, $bc78252b337306e3$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $bc78252b337306e3$var$PROPERTY_PADDING);
        this._resetElementAttributes($bc78252b337306e3$var$SELECTOR_FIXED_CONTENT, $bc78252b337306e3$var$PROPERTY_PADDING);
        this._resetElementAttributes($bc78252b337306e3$var$SELECTOR_STICKY_CONTENT, $bc78252b337306e3$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $bc78252b337306e3$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $bc78252b337306e3$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $bc78252b337306e3$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($bc78252b337306e3$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $bc78252b337306e3$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
    constructor(){
        this._element = document.body;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$7 = 'modal';
const $bc78252b337306e3$var$DATA_KEY$4 = 'bs.modal';
const $bc78252b337306e3$var$EVENT_KEY$4 = `.${$bc78252b337306e3$var$DATA_KEY$4}`;
const $bc78252b337306e3$var$DATA_API_KEY$2 = '.data-api';
const $bc78252b337306e3$var$ESCAPE_KEY$1 = 'Escape';
const $bc78252b337306e3$var$EVENT_HIDE$4 = `hide${$bc78252b337306e3$var$EVENT_KEY$4}`;
const $bc78252b337306e3$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$bc78252b337306e3$var$EVENT_KEY$4}`;
const $bc78252b337306e3$var$EVENT_HIDDEN$4 = `hidden${$bc78252b337306e3$var$EVENT_KEY$4}`;
const $bc78252b337306e3$var$EVENT_SHOW$4 = `show${$bc78252b337306e3$var$EVENT_KEY$4}`;
const $bc78252b337306e3$var$EVENT_SHOWN$4 = `shown${$bc78252b337306e3$var$EVENT_KEY$4}`;
const $bc78252b337306e3$var$EVENT_RESIZE$1 = `resize${$bc78252b337306e3$var$EVENT_KEY$4}`;
const $bc78252b337306e3$var$EVENT_CLICK_DISMISS = `click.dismiss${$bc78252b337306e3$var$EVENT_KEY$4}`;
const $bc78252b337306e3$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$bc78252b337306e3$var$EVENT_KEY$4}`;
const $bc78252b337306e3$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$bc78252b337306e3$var$EVENT_KEY$4}`;
const $bc78252b337306e3$var$EVENT_CLICK_DATA_API$2 = `click${$bc78252b337306e3$var$EVENT_KEY$4}${$bc78252b337306e3$var$DATA_API_KEY$2}`;
const $bc78252b337306e3$var$CLASS_NAME_OPEN = 'modal-open';
const $bc78252b337306e3$var$CLASS_NAME_FADE$3 = 'fade';
const $bc78252b337306e3$var$CLASS_NAME_SHOW$4 = 'show';
const $bc78252b337306e3$var$CLASS_NAME_STATIC = 'modal-static';
const $bc78252b337306e3$var$OPEN_SELECTOR$1 = '.modal.show';
const $bc78252b337306e3$var$SELECTOR_DIALOG = '.modal-dialog';
const $bc78252b337306e3$var$SELECTOR_MODAL_BODY = '.modal-body';
const $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $bc78252b337306e3$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $bc78252b337306e3$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $bc78252b337306e3$export$2b77a92f1a5ad772 extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$6;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$6;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($bc78252b337306e3$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $bc78252b337306e3$var$EventHandler.off(window, $bc78252b337306e3$var$EVENT_KEY$4);
        $bc78252b337306e3$var$EventHandler.off(this._dialog, $bc78252b337306e3$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $bc78252b337306e3$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $bc78252b337306e3$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $bc78252b337306e3$var$reflow(this._element);
        this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $bc78252b337306e3$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $bc78252b337306e3$var$EventHandler.on(window, $bc78252b337306e3$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $bc78252b337306e3$var$EventHandler.one(this._element, $bc78252b337306e3$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($bc78252b337306e3$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($bc78252b337306e3$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($bc78252b337306e3$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $bc78252b337306e3$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $bc78252b337306e3$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
    constructor(element, config){
        super(element, config);
        this._dialog = $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $bc78252b337306e3$var$ScrollBarHelper();
        this._addEventListeners();
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_CLICK_DATA_API$2, $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $bc78252b337306e3$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $bc78252b337306e3$var$EventHandler.one(target, $bc78252b337306e3$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $bc78252b337306e3$var$EventHandler.one(target, $bc78252b337306e3$var$EVENT_HIDDEN$4, ()=>{
            if ($bc78252b337306e3$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $bc78252b337306e3$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $bc78252b337306e3$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$bc78252b337306e3$var$enableDismissTrigger($bc78252b337306e3$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$6 = 'offcanvas';
const $bc78252b337306e3$var$DATA_KEY$3 = 'bs.offcanvas';
const $bc78252b337306e3$var$EVENT_KEY$3 = `.${$bc78252b337306e3$var$DATA_KEY$3}`;
const $bc78252b337306e3$var$DATA_API_KEY$1 = '.data-api';
const $bc78252b337306e3$var$EVENT_LOAD_DATA_API$2 = `load${$bc78252b337306e3$var$EVENT_KEY$3}${$bc78252b337306e3$var$DATA_API_KEY$1}`;
const $bc78252b337306e3$var$ESCAPE_KEY = 'Escape';
const $bc78252b337306e3$var$CLASS_NAME_SHOW$3 = 'show';
const $bc78252b337306e3$var$CLASS_NAME_SHOWING$1 = 'showing';
const $bc78252b337306e3$var$CLASS_NAME_HIDING = 'hiding';
const $bc78252b337306e3$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $bc78252b337306e3$var$OPEN_SELECTOR = '.offcanvas.show';
const $bc78252b337306e3$var$EVENT_SHOW$3 = `show${$bc78252b337306e3$var$EVENT_KEY$3}`;
const $bc78252b337306e3$var$EVENT_SHOWN$3 = `shown${$bc78252b337306e3$var$EVENT_KEY$3}`;
const $bc78252b337306e3$var$EVENT_HIDE$3 = `hide${$bc78252b337306e3$var$EVENT_KEY$3}`;
const $bc78252b337306e3$var$EVENT_HIDE_PREVENTED = `hidePrevented${$bc78252b337306e3$var$EVENT_KEY$3}`;
const $bc78252b337306e3$var$EVENT_HIDDEN$3 = `hidden${$bc78252b337306e3$var$EVENT_KEY$3}`;
const $bc78252b337306e3$var$EVENT_RESIZE = `resize${$bc78252b337306e3$var$EVENT_KEY$3}`;
const $bc78252b337306e3$var$EVENT_CLICK_DATA_API$1 = `click${$bc78252b337306e3$var$EVENT_KEY$3}${$bc78252b337306e3$var$DATA_API_KEY$1}`;
const $bc78252b337306e3$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$bc78252b337306e3$var$EVENT_KEY$3}`;
const $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $bc78252b337306e3$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $bc78252b337306e3$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $bc78252b337306e3$export$591ca0244c9dfcd4 extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$5;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$5;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $bc78252b337306e3$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOWING$1);
            $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOW$3, $bc78252b337306e3$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $bc78252b337306e3$var$ScrollBarHelper().reset();
            $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $bc78252b337306e3$var$Backdrop({
            className: $bc78252b337306e3$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $bc78252b337306e3$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $bc78252b337306e3$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_CLICK_DATA_API$1, $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $bc78252b337306e3$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($bc78252b337306e3$var$isDisabled(this)) return;
    $bc78252b337306e3$var$EventHandler.one(target, $bc78252b337306e3$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($bc78252b337306e3$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $bc78252b337306e3$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $bc78252b337306e3$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$bc78252b337306e3$var$EventHandler.on(window, $bc78252b337306e3$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$OPEN_SELECTOR))$bc78252b337306e3$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$bc78252b337306e3$var$EventHandler.on(window, $bc78252b337306e3$var$EVENT_RESIZE, ()=>{
    for (const element of $bc78252b337306e3$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $bc78252b337306e3$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$bc78252b337306e3$var$enableDismissTrigger($bc78252b337306e3$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $bc78252b337306e3$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $bc78252b337306e3$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $bc78252b337306e3$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $bc78252b337306e3$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $bc78252b337306e3$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $bc78252b337306e3$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($bc78252b337306e3$var$uriAttributes.has(attributeName)) return Boolean($bc78252b337306e3$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $bc78252b337306e3$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$bc78252b337306e3$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$5 = 'TemplateFactory';
const $bc78252b337306e3$var$Default$4 = {
    allowList: $bc78252b337306e3$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $bc78252b337306e3$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $bc78252b337306e3$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $bc78252b337306e3$var$TemplateFactory extends $bc78252b337306e3$var$Config {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$4;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$4;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = (0, $cd54608a2366dcc8$export$71511d61b312f219)({}, this._config.content, content);
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $bc78252b337306e3$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $bc78252b337306e3$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($bc78252b337306e3$var$isElement(content)) {
            this._putElementInTemplate($bc78252b337306e3$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $bc78252b337306e3$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $bc78252b337306e3$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$4 = 'tooltip';
const $bc78252b337306e3$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $bc78252b337306e3$var$CLASS_NAME_FADE$2 = 'fade';
const $bc78252b337306e3$var$CLASS_NAME_MODAL = 'modal';
const $bc78252b337306e3$var$CLASS_NAME_SHOW$2 = 'show';
const $bc78252b337306e3$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $bc78252b337306e3$var$SELECTOR_MODAL = `.${$bc78252b337306e3$var$CLASS_NAME_MODAL}`;
const $bc78252b337306e3$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $bc78252b337306e3$var$TRIGGER_HOVER = 'hover';
const $bc78252b337306e3$var$TRIGGER_FOCUS = 'focus';
const $bc78252b337306e3$var$TRIGGER_CLICK = 'click';
const $bc78252b337306e3$var$TRIGGER_MANUAL = 'manual';
const $bc78252b337306e3$var$EVENT_HIDE$2 = 'hide';
const $bc78252b337306e3$var$EVENT_HIDDEN$2 = 'hidden';
const $bc78252b337306e3$var$EVENT_SHOW$2 = 'show';
const $bc78252b337306e3$var$EVENT_SHOWN$2 = 'shown';
const $bc78252b337306e3$var$EVENT_INSERTED = 'inserted';
const $bc78252b337306e3$var$EVENT_CLICK$1 = 'click';
const $bc78252b337306e3$var$EVENT_FOCUSIN$1 = 'focusin';
const $bc78252b337306e3$var$EVENT_FOCUSOUT$1 = 'focusout';
const $bc78252b337306e3$var$EVENT_MOUSEENTER = 'mouseenter';
const $bc78252b337306e3$var$EVENT_MOUSELEAVE = 'mouseleave';
const $bc78252b337306e3$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $bc78252b337306e3$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $bc78252b337306e3$var$isRTL() ? 'right' : 'left'
};
const $bc78252b337306e3$var$Default$3 = {
    allowList: $bc78252b337306e3$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $bc78252b337306e3$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $bc78252b337306e3$export$28c660c63b792dea extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$3;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$3;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $bc78252b337306e3$var$EventHandler.off(this._element.closest($bc78252b337306e3$var$SELECTOR_MODAL), $bc78252b337306e3$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, this.constructor.eventName($bc78252b337306e3$var$EVENT_SHOW$2));
        const shadowRoot = $bc78252b337306e3$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $bc78252b337306e3$var$EventHandler.trigger(this._element, this.constructor.eventName($bc78252b337306e3$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$bc78252b337306e3$var$EventHandler.on(element, 'mouseover', $bc78252b337306e3$var$noop);
        const complete = ()=>{
            $bc78252b337306e3$var$EventHandler.trigger(this._element, this.constructor.eventName($bc78252b337306e3$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, this.constructor.eventName($bc78252b337306e3$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$bc78252b337306e3$var$EventHandler.off(element, 'mouseover', $bc78252b337306e3$var$noop);
        this._activeTrigger[$bc78252b337306e3$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$bc78252b337306e3$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$bc78252b337306e3$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $bc78252b337306e3$var$EventHandler.trigger(this._element, this.constructor.eventName($bc78252b337306e3$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($bc78252b337306e3$var$CLASS_NAME_FADE$2, $bc78252b337306e3$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $bc78252b337306e3$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($bc78252b337306e3$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $bc78252b337306e3$var$TemplateFactory((0, $9fceebefc81b9e0c$export$71511d61b312f219)((0, $cd54608a2366dcc8$export$71511d61b312f219)({}, this._config), {
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        }));
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$bc78252b337306e3$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($bc78252b337306e3$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($bc78252b337306e3$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $bc78252b337306e3$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $bc78252b337306e3$var$AttachmentMap[placement.toUpperCase()];
        return $037d96a8ea63578e$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $bc78252b337306e3$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return (0, $cd54608a2366dcc8$export$71511d61b312f219)({}, defaultBsPopperConfig, $bc78252b337306e3$var$execute(this._config.popperConfig, [
            undefined,
            defaultBsPopperConfig
        ]));
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $bc78252b337306e3$var$EventHandler.on(this._element, this.constructor.eventName($bc78252b337306e3$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$bc78252b337306e3$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$bc78252b337306e3$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $bc78252b337306e3$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $bc78252b337306e3$var$TRIGGER_HOVER ? this.constructor.eventName($bc78252b337306e3$var$EVENT_MOUSEENTER) : this.constructor.eventName($bc78252b337306e3$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $bc78252b337306e3$var$TRIGGER_HOVER ? this.constructor.eventName($bc78252b337306e3$var$EVENT_MOUSELEAVE) : this.constructor.eventName($bc78252b337306e3$var$EVENT_FOCUSOUT$1);
                $bc78252b337306e3$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $bc78252b337306e3$var$TRIGGER_FOCUS : $bc78252b337306e3$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $bc78252b337306e3$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $bc78252b337306e3$var$TRIGGER_FOCUS : $bc78252b337306e3$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $bc78252b337306e3$var$EventHandler.on(this._element.closest($bc78252b337306e3$var$SELECTOR_MODAL), $bc78252b337306e3$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $bc78252b337306e3$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($bc78252b337306e3$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = (0, $cd54608a2366dcc8$export$71511d61b312f219)({}, dataAttributes, typeof config === 'object' && config ? config : {});
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $bc78252b337306e3$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    constructor(element, config){
        if (typeof $037d96a8ea63578e$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
}
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$3 = 'popover';
const $bc78252b337306e3$var$SELECTOR_TITLE = '.popover-header';
const $bc78252b337306e3$var$SELECTOR_CONTENT = '.popover-body';
const $bc78252b337306e3$var$Default$2 = (0, $9fceebefc81b9e0c$export$71511d61b312f219)((0, $cd54608a2366dcc8$export$71511d61b312f219)({}, $bc78252b337306e3$export$28c660c63b792dea.Default), {
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
});
const $bc78252b337306e3$var$DefaultType$2 = (0, $9fceebefc81b9e0c$export$71511d61b312f219)((0, $cd54608a2366dcc8$export$71511d61b312f219)({}, $bc78252b337306e3$export$28c660c63b792dea.DefaultType), {
    content: '(null|string|element|function)'
});
/**
 * Class definition
 */ class $bc78252b337306e3$export$5b6b19405a83ff9d extends $bc78252b337306e3$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$2;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$2;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$bc78252b337306e3$var$SELECTOR_TITLE]: this._getTitle(),
            [$bc78252b337306e3$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$2 = 'scrollspy';
const $bc78252b337306e3$var$DATA_KEY$2 = 'bs.scrollspy';
const $bc78252b337306e3$var$EVENT_KEY$2 = `.${$bc78252b337306e3$var$DATA_KEY$2}`;
const $bc78252b337306e3$var$DATA_API_KEY = '.data-api';
const $bc78252b337306e3$var$EVENT_ACTIVATE = `activate${$bc78252b337306e3$var$EVENT_KEY$2}`;
const $bc78252b337306e3$var$EVENT_CLICK = `click${$bc78252b337306e3$var$EVENT_KEY$2}`;
const $bc78252b337306e3$var$EVENT_LOAD_DATA_API$1 = `load${$bc78252b337306e3$var$EVENT_KEY$2}${$bc78252b337306e3$var$DATA_API_KEY}`;
const $bc78252b337306e3$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $bc78252b337306e3$var$CLASS_NAME_ACTIVE$1 = 'active';
const $bc78252b337306e3$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $bc78252b337306e3$var$SELECTOR_TARGET_LINKS = '[href]';
const $bc78252b337306e3$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $bc78252b337306e3$var$SELECTOR_NAV_LINKS = '.nav-link';
const $bc78252b337306e3$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $bc78252b337306e3$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $bc78252b337306e3$var$SELECTOR_LINK_ITEMS = `${$bc78252b337306e3$var$SELECTOR_NAV_LINKS}, ${$bc78252b337306e3$var$SELECTOR_NAV_ITEMS} > ${$bc78252b337306e3$var$SELECTOR_NAV_LINKS}, ${$bc78252b337306e3$var$SELECTOR_LIST_ITEMS}`;
const $bc78252b337306e3$var$SELECTOR_DROPDOWN = '.dropdown';
const $bc78252b337306e3$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $bc78252b337306e3$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $bc78252b337306e3$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $bc78252b337306e3$export$a6472a5298a374be extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default$1;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType$1;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $bc78252b337306e3$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $bc78252b337306e3$var$EventHandler.off(this._config.target, $bc78252b337306e3$var$EVENT_CLICK);
        $bc78252b337306e3$var$EventHandler.on(this._config.target, $bc78252b337306e3$var$EVENT_CLICK, $bc78252b337306e3$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $bc78252b337306e3$var$isDisabled(anchor)) continue;
            const observableSection = $bc78252b337306e3$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($bc78252b337306e3$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($bc78252b337306e3$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($bc78252b337306e3$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($bc78252b337306e3$var$SELECTOR_DROPDOWN)).classList.add($bc78252b337306e3$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $bc78252b337306e3$var$SelectorEngine.parents(target, $bc78252b337306e3$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $bc78252b337306e3$var$SelectorEngine.prev(listGroup, $bc78252b337306e3$var$SELECTOR_LINK_ITEMS))item.classList.add($bc78252b337306e3$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($bc78252b337306e3$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $bc78252b337306e3$var$SelectorEngine.find(`${$bc78252b337306e3$var$SELECTOR_TARGET_LINKS}.${$bc78252b337306e3$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($bc78252b337306e3$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$EventHandler.on(window, $bc78252b337306e3$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_DATA_SPY))$bc78252b337306e3$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME$1 = 'tab';
const $bc78252b337306e3$var$DATA_KEY$1 = 'bs.tab';
const $bc78252b337306e3$var$EVENT_KEY$1 = `.${$bc78252b337306e3$var$DATA_KEY$1}`;
const $bc78252b337306e3$var$EVENT_HIDE$1 = `hide${$bc78252b337306e3$var$EVENT_KEY$1}`;
const $bc78252b337306e3$var$EVENT_HIDDEN$1 = `hidden${$bc78252b337306e3$var$EVENT_KEY$1}`;
const $bc78252b337306e3$var$EVENT_SHOW$1 = `show${$bc78252b337306e3$var$EVENT_KEY$1}`;
const $bc78252b337306e3$var$EVENT_SHOWN$1 = `shown${$bc78252b337306e3$var$EVENT_KEY$1}`;
const $bc78252b337306e3$var$EVENT_CLICK_DATA_API = `click${$bc78252b337306e3$var$EVENT_KEY$1}`;
const $bc78252b337306e3$var$EVENT_KEYDOWN = `keydown${$bc78252b337306e3$var$EVENT_KEY$1}`;
const $bc78252b337306e3$var$EVENT_LOAD_DATA_API = `load${$bc78252b337306e3$var$EVENT_KEY$1}`;
const $bc78252b337306e3$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $bc78252b337306e3$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $bc78252b337306e3$var$ARROW_UP_KEY = 'ArrowUp';
const $bc78252b337306e3$var$ARROW_DOWN_KEY = 'ArrowDown';
const $bc78252b337306e3$var$HOME_KEY = 'Home';
const $bc78252b337306e3$var$END_KEY = 'End';
const $bc78252b337306e3$var$CLASS_NAME_ACTIVE = 'active';
const $bc78252b337306e3$var$CLASS_NAME_FADE$1 = 'fade';
const $bc78252b337306e3$var$CLASS_NAME_SHOW$1 = 'show';
const $bc78252b337306e3$var$CLASS_DROPDOWN = 'dropdown';
const $bc78252b337306e3$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $bc78252b337306e3$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $bc78252b337306e3$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$bc78252b337306e3$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $bc78252b337306e3$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $bc78252b337306e3$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $bc78252b337306e3$var$SELECTOR_INNER = `.nav-link${$bc78252b337306e3$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$bc78252b337306e3$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$bc78252b337306e3$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $bc78252b337306e3$var$SELECTOR_INNER_ELEM = `${$bc78252b337306e3$var$SELECTOR_INNER}, ${$bc78252b337306e3$var$SELECTOR_DATA_TOGGLE}`;
const $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$bc78252b337306e3$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$bc78252b337306e3$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$bc78252b337306e3$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $bc78252b337306e3$export$3e41faf802a29e71 extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get NAME() {
        return $bc78252b337306e3$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $bc78252b337306e3$var$EventHandler.trigger(active, $bc78252b337306e3$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $bc78252b337306e3$var$EventHandler.trigger(innerElem, $bc78252b337306e3$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($bc78252b337306e3$var$CLASS_NAME_ACTIVE);
        this._activate($bc78252b337306e3$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $bc78252b337306e3$var$EventHandler.trigger(element, $bc78252b337306e3$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($bc78252b337306e3$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($bc78252b337306e3$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($bc78252b337306e3$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $bc78252b337306e3$var$EventHandler.trigger(element, $bc78252b337306e3$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($bc78252b337306e3$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $bc78252b337306e3$var$ARROW_LEFT_KEY,
            $bc78252b337306e3$var$ARROW_RIGHT_KEY,
            $bc78252b337306e3$var$ARROW_UP_KEY,
            $bc78252b337306e3$var$ARROW_DOWN_KEY,
            $bc78252b337306e3$var$HOME_KEY,
            $bc78252b337306e3$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$bc78252b337306e3$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $bc78252b337306e3$var$HOME_KEY,
            $bc78252b337306e3$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $bc78252b337306e3$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $bc78252b337306e3$var$ARROW_RIGHT_KEY,
                $bc78252b337306e3$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $bc78252b337306e3$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $bc78252b337306e3$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $bc78252b337306e3$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($bc78252b337306e3$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $bc78252b337306e3$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($bc78252b337306e3$var$SELECTOR_DROPDOWN_TOGGLE, $bc78252b337306e3$var$CLASS_NAME_ACTIVE);
        toggle($bc78252b337306e3$var$SELECTOR_DROPDOWN_MENU, $bc78252b337306e3$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($bc78252b337306e3$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($bc78252b337306e3$var$SELECTOR_INNER_ELEM) ? elem : $bc78252b337306e3$var$SelectorEngine.findOne($bc78252b337306e3$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($bc78252b337306e3$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    constructor(element){
        super(element);
        this._parent = this._element.closest($bc78252b337306e3$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$EventHandler.on(document, $bc78252b337306e3$var$EVENT_CLICK_DATA_API, $bc78252b337306e3$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($bc78252b337306e3$var$isDisabled(this)) return;
    $bc78252b337306e3$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $bc78252b337306e3$var$EventHandler.on(window, $bc78252b337306e3$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $bc78252b337306e3$var$SelectorEngine.find($bc78252b337306e3$var$SELECTOR_DATA_TOGGLE_ACTIVE))$bc78252b337306e3$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $bc78252b337306e3$var$NAME = 'toast';
const $bc78252b337306e3$var$DATA_KEY = 'bs.toast';
const $bc78252b337306e3$var$EVENT_KEY = `.${$bc78252b337306e3$var$DATA_KEY}`;
const $bc78252b337306e3$var$EVENT_MOUSEOVER = `mouseover${$bc78252b337306e3$var$EVENT_KEY}`;
const $bc78252b337306e3$var$EVENT_MOUSEOUT = `mouseout${$bc78252b337306e3$var$EVENT_KEY}`;
const $bc78252b337306e3$var$EVENT_FOCUSIN = `focusin${$bc78252b337306e3$var$EVENT_KEY}`;
const $bc78252b337306e3$var$EVENT_FOCUSOUT = `focusout${$bc78252b337306e3$var$EVENT_KEY}`;
const $bc78252b337306e3$var$EVENT_HIDE = `hide${$bc78252b337306e3$var$EVENT_KEY}`;
const $bc78252b337306e3$var$EVENT_HIDDEN = `hidden${$bc78252b337306e3$var$EVENT_KEY}`;
const $bc78252b337306e3$var$EVENT_SHOW = `show${$bc78252b337306e3$var$EVENT_KEY}`;
const $bc78252b337306e3$var$EVENT_SHOWN = `shown${$bc78252b337306e3$var$EVENT_KEY}`;
const $bc78252b337306e3$var$CLASS_NAME_FADE = 'fade';
const $bc78252b337306e3$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $bc78252b337306e3$var$CLASS_NAME_SHOW = 'show';
const $bc78252b337306e3$var$CLASS_NAME_SHOWING = 'showing';
const $bc78252b337306e3$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $bc78252b337306e3$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $bc78252b337306e3$export$8d8dc7d5f743331b extends $bc78252b337306e3$var$BaseComponent {
    // Getters
    static get Default() {
        return $bc78252b337306e3$var$Default;
    }
    static get DefaultType() {
        return $bc78252b337306e3$var$DefaultType;
    }
    static get NAME() {
        return $bc78252b337306e3$var$NAME;
    }
    // Public
    show() {
        const showEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOWING);
            $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_HIDE); // @deprecated
        $bc78252b337306e3$var$reflow(this._element);
        this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOW, $bc78252b337306e3$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOWING, $bc78252b337306e3$var$CLASS_NAME_SHOW);
            $bc78252b337306e3$var$EventHandler.trigger(this._element, $bc78252b337306e3$var$EVENT_HIDDEN);
        };
        this._element.classList.add($bc78252b337306e3$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($bc78252b337306e3$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($bc78252b337306e3$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $bc78252b337306e3$var$EventHandler.on(this._element, $bc78252b337306e3$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $bc78252b337306e3$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
}
/**
 * Data API implementation
 */ $bc78252b337306e3$var$enableDismissTrigger($bc78252b337306e3$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $bc78252b337306e3$var$defineJQueryPlugin($bc78252b337306e3$export$8d8dc7d5f743331b);


const $38f51f2d8fd307c2$export$1b00a204b1f1aa92 = 16;
const $38f51f2d8fd307c2$export$8b0894f4c14eda03 = 1272;
const $38f51f2d8fd307c2$export$d37404c264af2f19 = 1181;
const $38f51f2d8fd307c2$export$7c20e21b18d14832 = 'MBS';
const $38f51f2d8fd307c2$export$7a948dda2e5abcb7 = {
    terms: 'http://www.goodgamestudios.com/terms_{{lang}}/#terms',
    legal: 'https://www.goodgamestudios.com/terms_{{lang}}/#imprint',
    support: 'https://support.goodgamestudios.com/',
    getTermsLink (lang) {
        return this.terms.replace('{{lang}}', lang);
    },
    getLegalLink (lang) {
        return this.legal.replace('{{lang}}', lang);
    },
    getSupportLink (lang, gameId) {
        return `${this.support}?lang=${lang}&g=${gameId}`;
    }
};
const $38f51f2d8fd307c2$export$7b541698c79bb80a = {
    PAGE_LOADED: 0,
    WRONG_CODE_ENTRY: 1,
    CORRECT_CODE_ENTRY: 2,
    CORRECT_CODE_ENTRY_BANNED: 3,
    ERROR_RESPONSE: 4
};




// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $8c6d2ee41c19aeed$var$getRandomValues;
var $8c6d2ee41c19aeed$var$rnds8 = new Uint8Array(16);
function $8c6d2ee41c19aeed$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$8c6d2ee41c19aeed$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $8c6d2ee41c19aeed$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$8c6d2ee41c19aeed$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $8c6d2ee41c19aeed$var$getRandomValues($8c6d2ee41c19aeed$var$rnds8);
}


var $4527f8c3601543b9$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $e7d75195cf38330e$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $4527f8c3601543b9$export$2e2bcd8739ae039).test(uuid);
}
var $e7d75195cf38330e$export$2e2bcd8739ae039 = $e7d75195cf38330e$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $2f699c1169fec9ec$var$byteToHex = [];
for(var $2f699c1169fec9ec$var$i = 0; $2f699c1169fec9ec$var$i < 256; ++$2f699c1169fec9ec$var$i)$2f699c1169fec9ec$var$byteToHex.push(($2f699c1169fec9ec$var$i + 0x100).toString(16).substr(1));
function $2f699c1169fec9ec$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($2f699c1169fec9ec$var$byteToHex[arr[offset + 0]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 1]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 2]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 3]] + '-' + $2f699c1169fec9ec$var$byteToHex[arr[offset + 4]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 5]] + '-' + $2f699c1169fec9ec$var$byteToHex[arr[offset + 6]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 7]] + '-' + $2f699c1169fec9ec$var$byteToHex[arr[offset + 8]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 9]] + '-' + $2f699c1169fec9ec$var$byteToHex[arr[offset + 10]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 11]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 12]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 13]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 14]] + $2f699c1169fec9ec$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $e7d75195cf38330e$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $2f699c1169fec9ec$export$2e2bcd8739ae039 = $2f699c1169fec9ec$var$stringify;


function $aa0bbc811b0c1b57$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $8c6d2ee41c19aeed$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2f699c1169fec9ec$export$2e2bcd8739ae039)(rnds);
}
var $aa0bbc811b0c1b57$export$2e2bcd8739ae039 = $aa0bbc811b0c1b57$var$v4;


var $36139e949b21be0d$exports = {};
(function(global, factory) {
    $36139e949b21be0d$exports = factory();
})($36139e949b21be0d$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});


var $210451231afb5fd1$exports = {};

$210451231afb5fd1$exports = (parcelRequire("c4yuT"));


'use strict';
function $637b2afa1d42a1c4$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $e327140bec0e75f7$exports = {};
// shim for using process in browser
var $e327140bec0e75f7$var$process = $e327140bec0e75f7$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e327140bec0e75f7$var$cachedSetTimeout;
var $e327140bec0e75f7$var$cachedClearTimeout;
function $e327140bec0e75f7$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $e327140bec0e75f7$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $e327140bec0e75f7$var$cachedSetTimeout = setTimeout;
        else $e327140bec0e75f7$var$cachedSetTimeout = $e327140bec0e75f7$var$defaultSetTimout;
    } catch (e) {
        $e327140bec0e75f7$var$cachedSetTimeout = $e327140bec0e75f7$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $e327140bec0e75f7$var$cachedClearTimeout = clearTimeout;
        else $e327140bec0e75f7$var$cachedClearTimeout = $e327140bec0e75f7$var$defaultClearTimeout;
    } catch (e) {
        $e327140bec0e75f7$var$cachedClearTimeout = $e327140bec0e75f7$var$defaultClearTimeout;
    }
})();
function $e327140bec0e75f7$var$runTimeout(fun) {
    if ($e327140bec0e75f7$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e327140bec0e75f7$var$cachedSetTimeout === $e327140bec0e75f7$var$defaultSetTimout || !$e327140bec0e75f7$var$cachedSetTimeout) && setTimeout) {
        $e327140bec0e75f7$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e327140bec0e75f7$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e327140bec0e75f7$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e327140bec0e75f7$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e327140bec0e75f7$var$runClearTimeout(marker) {
    if ($e327140bec0e75f7$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e327140bec0e75f7$var$cachedClearTimeout === $e327140bec0e75f7$var$defaultClearTimeout || !$e327140bec0e75f7$var$cachedClearTimeout) && clearTimeout) {
        $e327140bec0e75f7$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e327140bec0e75f7$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e327140bec0e75f7$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e327140bec0e75f7$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e327140bec0e75f7$var$queue = [];
var $e327140bec0e75f7$var$draining = false;
var $e327140bec0e75f7$var$currentQueue;
var $e327140bec0e75f7$var$queueIndex = -1;
function $e327140bec0e75f7$var$cleanUpNextTick() {
    if (!$e327140bec0e75f7$var$draining || !$e327140bec0e75f7$var$currentQueue) return;
    $e327140bec0e75f7$var$draining = false;
    if ($e327140bec0e75f7$var$currentQueue.length) $e327140bec0e75f7$var$queue = $e327140bec0e75f7$var$currentQueue.concat($e327140bec0e75f7$var$queue);
    else $e327140bec0e75f7$var$queueIndex = -1;
    if ($e327140bec0e75f7$var$queue.length) $e327140bec0e75f7$var$drainQueue();
}
function $e327140bec0e75f7$var$drainQueue() {
    if ($e327140bec0e75f7$var$draining) return;
    var timeout = $e327140bec0e75f7$var$runTimeout($e327140bec0e75f7$var$cleanUpNextTick);
    $e327140bec0e75f7$var$draining = true;
    var len = $e327140bec0e75f7$var$queue.length;
    while(len){
        $e327140bec0e75f7$var$currentQueue = $e327140bec0e75f7$var$queue;
        $e327140bec0e75f7$var$queue = [];
        while(++$e327140bec0e75f7$var$queueIndex < len)if ($e327140bec0e75f7$var$currentQueue) $e327140bec0e75f7$var$currentQueue[$e327140bec0e75f7$var$queueIndex].run();
        $e327140bec0e75f7$var$queueIndex = -1;
        len = $e327140bec0e75f7$var$queue.length;
    }
    $e327140bec0e75f7$var$currentQueue = null;
    $e327140bec0e75f7$var$draining = false;
    $e327140bec0e75f7$var$runClearTimeout(timeout);
}
$e327140bec0e75f7$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e327140bec0e75f7$var$queue.push(new $e327140bec0e75f7$var$Item(fun, args));
    if ($e327140bec0e75f7$var$queue.length === 1 && !$e327140bec0e75f7$var$draining) $e327140bec0e75f7$var$runTimeout($e327140bec0e75f7$var$drainQueue);
};
// v8 likes predictible objects
function $e327140bec0e75f7$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e327140bec0e75f7$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e327140bec0e75f7$var$process.title = 'browser';
$e327140bec0e75f7$var$process.browser = true;
$e327140bec0e75f7$var$process.env = {};
$e327140bec0e75f7$var$process.argv = [];
$e327140bec0e75f7$var$process.version = ''; // empty string to avoid regexp issues
$e327140bec0e75f7$var$process.versions = {};
function $e327140bec0e75f7$var$noop() {}
$e327140bec0e75f7$var$process.on = $e327140bec0e75f7$var$noop;
$e327140bec0e75f7$var$process.addListener = $e327140bec0e75f7$var$noop;
$e327140bec0e75f7$var$process.once = $e327140bec0e75f7$var$noop;
$e327140bec0e75f7$var$process.off = $e327140bec0e75f7$var$noop;
$e327140bec0e75f7$var$process.removeListener = $e327140bec0e75f7$var$noop;
$e327140bec0e75f7$var$process.removeAllListeners = $e327140bec0e75f7$var$noop;
$e327140bec0e75f7$var$process.emit = $e327140bec0e75f7$var$noop;
$e327140bec0e75f7$var$process.prependListener = $e327140bec0e75f7$var$noop;
$e327140bec0e75f7$var$process.prependOnceListener = $e327140bec0e75f7$var$noop;
$e327140bec0e75f7$var$process.listeners = function(name) {
    return [];
};
$e327140bec0e75f7$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$e327140bec0e75f7$var$process.cwd = function() {
    return '/';
};
$e327140bec0e75f7$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$e327140bec0e75f7$var$process.umask = function() {
    return 0;
};


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $d82f452f96bd0198$var$toString } = Object.prototype;
const { getPrototypeOf: $d82f452f96bd0198$var$getPrototypeOf } = Object;
const { iterator: $d82f452f96bd0198$var$iterator, toStringTag: $d82f452f96bd0198$var$toStringTag } = Symbol;
const $d82f452f96bd0198$var$kindOf = ((cache)=>(thing)=>{
        const str = $d82f452f96bd0198$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $d82f452f96bd0198$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$d82f452f96bd0198$var$kindOf(thing) === type;
};
const $d82f452f96bd0198$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $d82f452f96bd0198$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $d82f452f96bd0198$var$isUndefined = $d82f452f96bd0198$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $d82f452f96bd0198$var$isBuffer(val) {
    return val !== null && !$d82f452f96bd0198$var$isUndefined(val) && val.constructor !== null && !$d82f452f96bd0198$var$isUndefined(val.constructor) && $d82f452f96bd0198$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $d82f452f96bd0198$var$isArrayBuffer = $d82f452f96bd0198$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $d82f452f96bd0198$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $d82f452f96bd0198$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $d82f452f96bd0198$var$isString = $d82f452f96bd0198$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $d82f452f96bd0198$var$isFunction = $d82f452f96bd0198$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $d82f452f96bd0198$var$isNumber = $d82f452f96bd0198$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $d82f452f96bd0198$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $d82f452f96bd0198$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $d82f452f96bd0198$var$isPlainObject = (val)=>{
    if ($d82f452f96bd0198$var$kindOf(val) !== 'object') return false;
    const prototype = $d82f452f96bd0198$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($d82f452f96bd0198$var$toStringTag in val) && !($d82f452f96bd0198$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $d82f452f96bd0198$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$d82f452f96bd0198$var$isObject(val) || $d82f452f96bd0198$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $d82f452f96bd0198$var$isDate = $d82f452f96bd0198$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $d82f452f96bd0198$var$isFile = $d82f452f96bd0198$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $d82f452f96bd0198$var$isBlob = $d82f452f96bd0198$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $d82f452f96bd0198$var$isFileList = $d82f452f96bd0198$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $d82f452f96bd0198$var$isStream = (val)=>$d82f452f96bd0198$var$isObject(val) && $d82f452f96bd0198$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $d82f452f96bd0198$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $d82f452f96bd0198$var$isFunction(thing.append) && ((kind = $d82f452f96bd0198$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $d82f452f96bd0198$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $d82f452f96bd0198$var$isURLSearchParams = $d82f452f96bd0198$var$kindOfTest('URLSearchParams');
const [$d82f452f96bd0198$var$isReadableStream, $d82f452f96bd0198$var$isRequest, $d82f452f96bd0198$var$isResponse, $d82f452f96bd0198$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($d82f452f96bd0198$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $d82f452f96bd0198$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $d82f452f96bd0198$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($d82f452f96bd0198$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($d82f452f96bd0198$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $d82f452f96bd0198$var$findKey(obj, key) {
    if ($d82f452f96bd0198$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $d82f452f96bd0198$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $d82f452f96bd0198$var$isContextDefined = (context)=>!$d82f452f96bd0198$var$isUndefined(context) && context !== $d82f452f96bd0198$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $d82f452f96bd0198$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $d82f452f96bd0198$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $d82f452f96bd0198$var$findKey(result, key) || key;
        if ($d82f452f96bd0198$var$isPlainObject(result[targetKey]) && $d82f452f96bd0198$var$isPlainObject(val)) result[targetKey] = $d82f452f96bd0198$var$merge(result[targetKey], val);
        else if ($d82f452f96bd0198$var$isPlainObject(val)) result[targetKey] = $d82f452f96bd0198$var$merge({}, val);
        else if ($d82f452f96bd0198$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$d82f452f96bd0198$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $d82f452f96bd0198$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $d82f452f96bd0198$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $d82f452f96bd0198$var$forEach(b, (val, key)=>{
        if (thisArg && $d82f452f96bd0198$var$isFunction(val)) a[key] = (0, $637b2afa1d42a1c4$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $d82f452f96bd0198$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $d82f452f96bd0198$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $d82f452f96bd0198$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $d82f452f96bd0198$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $d82f452f96bd0198$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $d82f452f96bd0198$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($d82f452f96bd0198$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$d82f452f96bd0198$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $d82f452f96bd0198$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $d82f452f96bd0198$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $d82f452f96bd0198$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$d82f452f96bd0198$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $d82f452f96bd0198$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $d82f452f96bd0198$var$isHTMLForm = $d82f452f96bd0198$var$kindOfTest('HTMLFormElement');
const $d82f452f96bd0198$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $d82f452f96bd0198$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $d82f452f96bd0198$var$isRegExp = $d82f452f96bd0198$var$kindOfTest('RegExp');
const $d82f452f96bd0198$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $d82f452f96bd0198$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $d82f452f96bd0198$var$freezeMethods = (obj)=>{
    $d82f452f96bd0198$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($d82f452f96bd0198$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$d82f452f96bd0198$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $d82f452f96bd0198$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $d82f452f96bd0198$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $d82f452f96bd0198$var$noop = ()=>{};
const $d82f452f96bd0198$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $d82f452f96bd0198$var$isSpecCompliantForm(thing) {
    return !!(thing && $d82f452f96bd0198$var$isFunction(thing.append) && thing[$d82f452f96bd0198$var$toStringTag] === 'FormData' && thing[$d82f452f96bd0198$var$iterator]);
}
const $d82f452f96bd0198$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($d82f452f96bd0198$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($d82f452f96bd0198$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $d82f452f96bd0198$var$isArray(source) ? [] : {};
                $d82f452f96bd0198$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$d82f452f96bd0198$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $d82f452f96bd0198$var$isAsyncFn = $d82f452f96bd0198$var$kindOfTest('AsyncFunction');
const $d82f452f96bd0198$var$isThenable = (thing)=>thing && ($d82f452f96bd0198$var$isObject(thing) || $d82f452f96bd0198$var$isFunction(thing)) && $d82f452f96bd0198$var$isFunction(thing.then) && $d82f452f96bd0198$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $d82f452f96bd0198$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $d82f452f96bd0198$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $d82f452f96bd0198$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $d82f452f96bd0198$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $d82f452f96bd0198$var$isFunction($d82f452f96bd0198$var$_global.postMessage));
const $d82f452f96bd0198$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($d82f452f96bd0198$var$_global) : typeof $e327140bec0e75f7$exports !== 'undefined' && $e327140bec0e75f7$exports.nextTick || $d82f452f96bd0198$var$_setImmediate;
// *********************
const $d82f452f96bd0198$var$isIterable = (thing)=>thing != null && $d82f452f96bd0198$var$isFunction(thing[$d82f452f96bd0198$var$iterator]);
var $d82f452f96bd0198$export$2e2bcd8739ae039 = {
    isArray: $d82f452f96bd0198$var$isArray,
    isArrayBuffer: $d82f452f96bd0198$var$isArrayBuffer,
    isBuffer: $d82f452f96bd0198$var$isBuffer,
    isFormData: $d82f452f96bd0198$var$isFormData,
    isArrayBufferView: $d82f452f96bd0198$var$isArrayBufferView,
    isString: $d82f452f96bd0198$var$isString,
    isNumber: $d82f452f96bd0198$var$isNumber,
    isBoolean: $d82f452f96bd0198$var$isBoolean,
    isObject: $d82f452f96bd0198$var$isObject,
    isPlainObject: $d82f452f96bd0198$var$isPlainObject,
    isEmptyObject: $d82f452f96bd0198$var$isEmptyObject,
    isReadableStream: $d82f452f96bd0198$var$isReadableStream,
    isRequest: $d82f452f96bd0198$var$isRequest,
    isResponse: $d82f452f96bd0198$var$isResponse,
    isHeaders: $d82f452f96bd0198$var$isHeaders,
    isUndefined: $d82f452f96bd0198$var$isUndefined,
    isDate: $d82f452f96bd0198$var$isDate,
    isFile: $d82f452f96bd0198$var$isFile,
    isBlob: $d82f452f96bd0198$var$isBlob,
    isRegExp: $d82f452f96bd0198$var$isRegExp,
    isFunction: $d82f452f96bd0198$var$isFunction,
    isStream: $d82f452f96bd0198$var$isStream,
    isURLSearchParams: $d82f452f96bd0198$var$isURLSearchParams,
    isTypedArray: $d82f452f96bd0198$var$isTypedArray,
    isFileList: $d82f452f96bd0198$var$isFileList,
    forEach: $d82f452f96bd0198$var$forEach,
    merge: $d82f452f96bd0198$var$merge,
    extend: $d82f452f96bd0198$var$extend,
    trim: $d82f452f96bd0198$var$trim,
    stripBOM: $d82f452f96bd0198$var$stripBOM,
    inherits: $d82f452f96bd0198$var$inherits,
    toFlatObject: $d82f452f96bd0198$var$toFlatObject,
    kindOf: $d82f452f96bd0198$var$kindOf,
    kindOfTest: $d82f452f96bd0198$var$kindOfTest,
    endsWith: $d82f452f96bd0198$var$endsWith,
    toArray: $d82f452f96bd0198$var$toArray,
    forEachEntry: $d82f452f96bd0198$var$forEachEntry,
    matchAll: $d82f452f96bd0198$var$matchAll,
    isHTMLForm: $d82f452f96bd0198$var$isHTMLForm,
    hasOwnProperty: $d82f452f96bd0198$var$hasOwnProperty,
    hasOwnProp: $d82f452f96bd0198$var$hasOwnProperty,
    reduceDescriptors: $d82f452f96bd0198$var$reduceDescriptors,
    freezeMethods: $d82f452f96bd0198$var$freezeMethods,
    toObjectSet: $d82f452f96bd0198$var$toObjectSet,
    toCamelCase: $d82f452f96bd0198$var$toCamelCase,
    noop: $d82f452f96bd0198$var$noop,
    toFiniteNumber: $d82f452f96bd0198$var$toFiniteNumber,
    findKey: $d82f452f96bd0198$var$findKey,
    global: $d82f452f96bd0198$var$_global,
    isContextDefined: $d82f452f96bd0198$var$isContextDefined,
    isSpecCompliantForm: $d82f452f96bd0198$var$isSpecCompliantForm,
    toJSONObject: $d82f452f96bd0198$var$toJSONObject,
    isAsyncFn: $d82f452f96bd0198$var$isAsyncFn,
    isThenable: $d82f452f96bd0198$var$isThenable,
    setImmediate: $d82f452f96bd0198$var$_setImmediate,
    asap: $d82f452f96bd0198$var$asap,
    isIterable: $d82f452f96bd0198$var$isIterable
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $9c64fe188853780b$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $d82f452f96bd0198$export$2e2bcd8739ae039).inherits($9c64fe188853780b$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $d82f452f96bd0198$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $9c64fe188853780b$var$prototype = $9c64fe188853780b$var$AxiosError.prototype;
const $9c64fe188853780b$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $9c64fe188853780b$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($9c64fe188853780b$var$AxiosError, $9c64fe188853780b$var$descriptors);
Object.defineProperty($9c64fe188853780b$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$9c64fe188853780b$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($9c64fe188853780b$var$prototype);
    (0, $d82f452f96bd0198$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $9c64fe188853780b$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $9c64fe188853780b$export$2e2bcd8739ae039 = $9c64fe188853780b$var$AxiosError;


// eslint-disable-next-line strict
var $da315430f87afb59$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a8018fdf90ef4285$export$a143d493d941bafc;
var $a8018fdf90ef4285$export$e4cf37d7f6fb9e0a;
var $a8018fdf90ef4285$export$f99ded8fe4b79145;
var $a8018fdf90ef4285$export$599f31c3813fae4d;
'use strict';
var $d3f92f06ad5003a3$export$a48f0734ac7c2329;
var $d3f92f06ad5003a3$export$d622b2ad8d90c771;
var $d3f92f06ad5003a3$export$6100ba28696e12de;
'use strict';
$d3f92f06ad5003a3$export$a48f0734ac7c2329 = $d3f92f06ad5003a3$var$byteLength;
$d3f92f06ad5003a3$export$d622b2ad8d90c771 = $d3f92f06ad5003a3$var$toByteArray;
$d3f92f06ad5003a3$export$6100ba28696e12de = $d3f92f06ad5003a3$var$fromByteArray;
var $d3f92f06ad5003a3$var$lookup = [];
var $d3f92f06ad5003a3$var$revLookup = [];
var $d3f92f06ad5003a3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $d3f92f06ad5003a3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $d3f92f06ad5003a3$var$i = 0, $d3f92f06ad5003a3$var$len = $d3f92f06ad5003a3$var$code.length; $d3f92f06ad5003a3$var$i < $d3f92f06ad5003a3$var$len; ++$d3f92f06ad5003a3$var$i){
    $d3f92f06ad5003a3$var$lookup[$d3f92f06ad5003a3$var$i] = $d3f92f06ad5003a3$var$code[$d3f92f06ad5003a3$var$i];
    $d3f92f06ad5003a3$var$revLookup[$d3f92f06ad5003a3$var$code.charCodeAt($d3f92f06ad5003a3$var$i)] = $d3f92f06ad5003a3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$d3f92f06ad5003a3$var$revLookup['-'.charCodeAt(0)] = 62;
$d3f92f06ad5003a3$var$revLookup['_'.charCodeAt(0)] = 63;
function $d3f92f06ad5003a3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $d3f92f06ad5003a3$var$byteLength(b64) {
    var lens = $d3f92f06ad5003a3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d3f92f06ad5003a3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $d3f92f06ad5003a3$var$toByteArray(b64) {
    var tmp;
    var lens = $d3f92f06ad5003a3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $d3f92f06ad5003a3$var$Arr($d3f92f06ad5003a3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $d3f92f06ad5003a3$var$revLookup[b64.charCodeAt(i)] << 18 | $d3f92f06ad5003a3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $d3f92f06ad5003a3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $d3f92f06ad5003a3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $d3f92f06ad5003a3$var$revLookup[b64.charCodeAt(i)] << 2 | $d3f92f06ad5003a3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $d3f92f06ad5003a3$var$revLookup[b64.charCodeAt(i)] << 10 | $d3f92f06ad5003a3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $d3f92f06ad5003a3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $d3f92f06ad5003a3$var$tripletToBase64(num) {
    return $d3f92f06ad5003a3$var$lookup[num >> 18 & 0x3F] + $d3f92f06ad5003a3$var$lookup[num >> 12 & 0x3F] + $d3f92f06ad5003a3$var$lookup[num >> 6 & 0x3F] + $d3f92f06ad5003a3$var$lookup[num & 0x3F];
}
function $d3f92f06ad5003a3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($d3f92f06ad5003a3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $d3f92f06ad5003a3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($d3f92f06ad5003a3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($d3f92f06ad5003a3$var$lookup[tmp >> 2] + $d3f92f06ad5003a3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($d3f92f06ad5003a3$var$lookup[tmp >> 10] + $d3f92f06ad5003a3$var$lookup[tmp >> 4 & 0x3F] + $d3f92f06ad5003a3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $435a89352207a31e$export$aafa59e2e03f2942;
var $435a89352207a31e$export$68d8715fc104d294;
$435a89352207a31e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$435a89352207a31e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $a8018fdf90ef4285$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$a8018fdf90ef4285$export$a143d493d941bafc = $a8018fdf90ef4285$var$Buffer;
$a8018fdf90ef4285$export$e4cf37d7f6fb9e0a = $a8018fdf90ef4285$var$SlowBuffer;
$a8018fdf90ef4285$export$f99ded8fe4b79145 = 50;
var $a8018fdf90ef4285$var$K_MAX_LENGTH = 0x7fffffff;
$a8018fdf90ef4285$export$599f31c3813fae4d = $a8018fdf90ef4285$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a8018fdf90ef4285$var$Buffer.TYPED_ARRAY_SUPPORT = $a8018fdf90ef4285$var$typedArraySupport();
if (!$a8018fdf90ef4285$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a8018fdf90ef4285$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a8018fdf90ef4285$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$a8018fdf90ef4285$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a8018fdf90ef4285$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$a8018fdf90ef4285$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a8018fdf90ef4285$var$createBuffer(length) {
    if (length > $a8018fdf90ef4285$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a8018fdf90ef4285$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a8018fdf90ef4285$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a8018fdf90ef4285$var$allocUnsafe(arg);
    }
    return $a8018fdf90ef4285$var$from(arg, encodingOrOffset, length);
}
$a8018fdf90ef4285$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a8018fdf90ef4285$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $a8018fdf90ef4285$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a8018fdf90ef4285$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a8018fdf90ef4285$var$isInstance(value, ArrayBuffer) || value && $a8018fdf90ef4285$var$isInstance(value.buffer, ArrayBuffer)) return $a8018fdf90ef4285$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($a8018fdf90ef4285$var$isInstance(value, SharedArrayBuffer) || value && $a8018fdf90ef4285$var$isInstance(value.buffer, SharedArrayBuffer))) return $a8018fdf90ef4285$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a8018fdf90ef4285$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $a8018fdf90ef4285$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $a8018fdf90ef4285$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a8018fdf90ef4285$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a8018fdf90ef4285$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a8018fdf90ef4285$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a8018fdf90ef4285$var$Buffer, Uint8Array);
function $a8018fdf90ef4285$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a8018fdf90ef4285$var$alloc(size, fill, encoding) {
    $a8018fdf90ef4285$var$assertSize(size);
    if (size <= 0) return $a8018fdf90ef4285$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $a8018fdf90ef4285$var$createBuffer(size).fill(fill, encoding) : $a8018fdf90ef4285$var$createBuffer(size).fill(fill);
    return $a8018fdf90ef4285$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a8018fdf90ef4285$var$Buffer.alloc = function(size, fill, encoding) {
    return $a8018fdf90ef4285$var$alloc(size, fill, encoding);
};
function $a8018fdf90ef4285$var$allocUnsafe(size) {
    $a8018fdf90ef4285$var$assertSize(size);
    return $a8018fdf90ef4285$var$createBuffer(size < 0 ? 0 : $a8018fdf90ef4285$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a8018fdf90ef4285$var$Buffer.allocUnsafe = function(size) {
    return $a8018fdf90ef4285$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a8018fdf90ef4285$var$Buffer.allocUnsafeSlow = function(size) {
    return $a8018fdf90ef4285$var$allocUnsafe(size);
};
function $a8018fdf90ef4285$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$a8018fdf90ef4285$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $a8018fdf90ef4285$var$byteLength(string, encoding) | 0;
    var buf = $a8018fdf90ef4285$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a8018fdf90ef4285$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $a8018fdf90ef4285$var$checked(array.length) | 0;
    var buf = $a8018fdf90ef4285$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a8018fdf90ef4285$var$fromArrayView(arrayView) {
    if ($a8018fdf90ef4285$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $a8018fdf90ef4285$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a8018fdf90ef4285$var$fromArrayLike(arrayView);
}
function $a8018fdf90ef4285$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a8018fdf90ef4285$var$Buffer.prototype);
    return buf;
}
function $a8018fdf90ef4285$var$fromObject(obj) {
    if ($a8018fdf90ef4285$var$Buffer.isBuffer(obj)) {
        var len = $a8018fdf90ef4285$var$checked(obj.length) | 0;
        var buf = $a8018fdf90ef4285$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $a8018fdf90ef4285$var$numberIsNaN(obj.length)) return $a8018fdf90ef4285$var$createBuffer(0);
        return $a8018fdf90ef4285$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $a8018fdf90ef4285$var$fromArrayLike(obj.data);
}
function $a8018fdf90ef4285$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a8018fdf90ef4285$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a8018fdf90ef4285$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $a8018fdf90ef4285$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a8018fdf90ef4285$var$Buffer.alloc(+length);
}
$a8018fdf90ef4285$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a8018fdf90ef4285$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a8018fdf90ef4285$var$Buffer.compare = function compare(a, b) {
    if ($a8018fdf90ef4285$var$isInstance(a, Uint8Array)) a = $a8018fdf90ef4285$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a8018fdf90ef4285$var$isInstance(b, Uint8Array)) b = $a8018fdf90ef4285$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a8018fdf90ef4285$var$Buffer.isBuffer(a) || !$a8018fdf90ef4285$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a8018fdf90ef4285$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$a8018fdf90ef4285$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a8018fdf90ef4285$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $a8018fdf90ef4285$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($a8018fdf90ef4285$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $a8018fdf90ef4285$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a8018fdf90ef4285$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a8018fdf90ef4285$var$byteLength(string, encoding) {
    if ($a8018fdf90ef4285$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a8018fdf90ef4285$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $a8018fdf90ef4285$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $a8018fdf90ef4285$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a8018fdf90ef4285$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a8018fdf90ef4285$var$Buffer.byteLength = $a8018fdf90ef4285$var$byteLength;
function $a8018fdf90ef4285$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $a8018fdf90ef4285$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $a8018fdf90ef4285$var$utf8Slice(this, start, end);
        case 'ascii':
            return $a8018fdf90ef4285$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $a8018fdf90ef4285$var$latin1Slice(this, start, end);
        case 'base64':
            return $a8018fdf90ef4285$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a8018fdf90ef4285$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a8018fdf90ef4285$var$Buffer.prototype._isBuffer = true;
function $a8018fdf90ef4285$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a8018fdf90ef4285$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$a8018fdf90ef4285$var$swap(this, i, i + 1);
    return this;
};
$a8018fdf90ef4285$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $a8018fdf90ef4285$var$swap(this, i, i + 3);
        $a8018fdf90ef4285$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a8018fdf90ef4285$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $a8018fdf90ef4285$var$swap(this, i, i + 7);
        $a8018fdf90ef4285$var$swap(this, i + 1, i + 6);
        $a8018fdf90ef4285$var$swap(this, i + 2, i + 5);
        $a8018fdf90ef4285$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a8018fdf90ef4285$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $a8018fdf90ef4285$var$utf8Slice(this, 0, length);
    return $a8018fdf90ef4285$var$slowToString.apply(this, arguments);
};
$a8018fdf90ef4285$var$Buffer.prototype.toLocaleString = $a8018fdf90ef4285$var$Buffer.prototype.toString;
$a8018fdf90ef4285$var$Buffer.prototype.equals = function equals(b) {
    if (!$a8018fdf90ef4285$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $a8018fdf90ef4285$var$Buffer.compare(this, b) === 0;
};
$a8018fdf90ef4285$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $a8018fdf90ef4285$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($a8018fdf90ef4285$var$customInspectSymbol) $a8018fdf90ef4285$var$Buffer.prototype[$a8018fdf90ef4285$var$customInspectSymbol] = $a8018fdf90ef4285$var$Buffer.prototype.inspect;
$a8018fdf90ef4285$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a8018fdf90ef4285$var$isInstance(target, Uint8Array)) target = $a8018fdf90ef4285$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a8018fdf90ef4285$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a8018fdf90ef4285$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a8018fdf90ef4285$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $a8018fdf90ef4285$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a8018fdf90ef4285$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a8018fdf90ef4285$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a8018fdf90ef4285$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $a8018fdf90ef4285$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a8018fdf90ef4285$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a8018fdf90ef4285$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a8018fdf90ef4285$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a8018fdf90ef4285$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a8018fdf90ef4285$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a8018fdf90ef4285$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a8018fdf90ef4285$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a8018fdf90ef4285$var$utf8Write(buf, string, offset, length) {
    return $a8018fdf90ef4285$var$blitBuffer($a8018fdf90ef4285$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a8018fdf90ef4285$var$asciiWrite(buf, string, offset, length) {
    return $a8018fdf90ef4285$var$blitBuffer($a8018fdf90ef4285$var$asciiToBytes(string), buf, offset, length);
}
function $a8018fdf90ef4285$var$base64Write(buf, string, offset, length) {
    return $a8018fdf90ef4285$var$blitBuffer($a8018fdf90ef4285$var$base64ToBytes(string), buf, offset, length);
}
function $a8018fdf90ef4285$var$ucs2Write(buf, string, offset, length) {
    return $a8018fdf90ef4285$var$blitBuffer($a8018fdf90ef4285$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a8018fdf90ef4285$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $a8018fdf90ef4285$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $a8018fdf90ef4285$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $a8018fdf90ef4285$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $a8018fdf90ef4285$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a8018fdf90ef4285$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a8018fdf90ef4285$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a8018fdf90ef4285$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $d3f92f06ad5003a3$export$6100ba28696e12de(buf);
    else return $d3f92f06ad5003a3$export$6100ba28696e12de(buf.slice(start, end));
}
function $a8018fdf90ef4285$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a8018fdf90ef4285$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $a8018fdf90ef4285$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a8018fdf90ef4285$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $a8018fdf90ef4285$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a8018fdf90ef4285$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a8018fdf90ef4285$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a8018fdf90ef4285$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a8018fdf90ef4285$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $a8018fdf90ef4285$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a8018fdf90ef4285$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a8018fdf90ef4285$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a8018fdf90ef4285$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a8018fdf90ef4285$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$a8018fdf90ef4285$var$Buffer.prototype.readUintLE = $a8018fdf90ef4285$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a8018fdf90ef4285$var$Buffer.prototype.readUintBE = $a8018fdf90ef4285$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a8018fdf90ef4285$var$Buffer.prototype.readUint8 = $a8018fdf90ef4285$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a8018fdf90ef4285$var$Buffer.prototype.readUint16LE = $a8018fdf90ef4285$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a8018fdf90ef4285$var$Buffer.prototype.readUint16BE = $a8018fdf90ef4285$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a8018fdf90ef4285$var$Buffer.prototype.readUint32LE = $a8018fdf90ef4285$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a8018fdf90ef4285$var$Buffer.prototype.readUint32BE = $a8018fdf90ef4285$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a8018fdf90ef4285$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a8018fdf90ef4285$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a8018fdf90ef4285$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a8018fdf90ef4285$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a8018fdf90ef4285$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a8018fdf90ef4285$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a8018fdf90ef4285$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a8018fdf90ef4285$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 4, this.length);
    return $435a89352207a31e$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$a8018fdf90ef4285$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 4, this.length);
    return $435a89352207a31e$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$a8018fdf90ef4285$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 8, this.length);
    return $435a89352207a31e$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$a8018fdf90ef4285$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkOffset(offset, 8, this.length);
    return $435a89352207a31e$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $a8018fdf90ef4285$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a8018fdf90ef4285$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$a8018fdf90ef4285$var$Buffer.prototype.writeUintLE = $a8018fdf90ef4285$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a8018fdf90ef4285$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeUintBE = $a8018fdf90ef4285$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a8018fdf90ef4285$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeUint8 = $a8018fdf90ef4285$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeUint16LE = $a8018fdf90ef4285$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeUint16BE = $a8018fdf90ef4285$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeUint32LE = $a8018fdf90ef4285$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeUint32BE = $a8018fdf90ef4285$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a8018fdf90ef4285$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a8018fdf90ef4285$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a8018fdf90ef4285$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a8018fdf90ef4285$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $a8018fdf90ef4285$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $435a89352207a31e$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a8018fdf90ef4285$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a8018fdf90ef4285$var$writeFloat(this, value, offset, true, noAssert);
};
$a8018fdf90ef4285$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a8018fdf90ef4285$var$writeFloat(this, value, offset, false, noAssert);
};
function $a8018fdf90ef4285$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a8018fdf90ef4285$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $435a89352207a31e$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a8018fdf90ef4285$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a8018fdf90ef4285$var$writeDouble(this, value, offset, true, noAssert);
};
$a8018fdf90ef4285$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a8018fdf90ef4285$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a8018fdf90ef4285$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a8018fdf90ef4285$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a8018fdf90ef4285$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$a8018fdf90ef4285$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $a8018fdf90ef4285$var$Buffer.isBuffer(val) ? val : $a8018fdf90ef4285$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $a8018fdf90ef4285$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a8018fdf90ef4285$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a8018fdf90ef4285$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $a8018fdf90ef4285$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $a8018fdf90ef4285$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a8018fdf90ef4285$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a8018fdf90ef4285$var$base64ToBytes(str) {
    return $d3f92f06ad5003a3$export$d622b2ad8d90c771($a8018fdf90ef4285$var$base64clean(str));
}
function $a8018fdf90ef4285$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a8018fdf90ef4285$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a8018fdf90ef4285$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $a8018fdf90ef4285$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $f58ffd618d880169$require$Buffer = $a8018fdf90ef4285$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $f58ffd618d880169$var$isVisitable(thing) {
    return (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $f58ffd618d880169$var$removeBrackets(key) {
    return (0, $d82f452f96bd0198$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $f58ffd618d880169$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $f58ffd618d880169$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $f58ffd618d880169$var$isFlatArray(arr) {
    return (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(arr) && !arr.some($f58ffd618d880169$var$isVisitable);
}
const $f58ffd618d880169$var$predicates = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).toFlatObject((0, $d82f452f96bd0198$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $f58ffd618d880169$var$toFormData(obj, formData, options) {
    if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $da315430f87afb59$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $9c64fe188853780b$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $f58ffd618d880169$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(value) && $f58ffd618d880169$var$isFlatArray(value) || ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFileList(value) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $f58ffd618d880169$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $f58ffd618d880169$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($f58ffd618d880169$var$isVisitable(value)) return true;
        formData.append($f58ffd618d880169$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($f58ffd618d880169$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $f58ffd618d880169$var$isVisitable
    });
    function build(value, path) {
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $f58ffd618d880169$export$2e2bcd8739ae039 = $f58ffd618d880169$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $fe0ecff350b304e4$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $fe0ecff350b304e4$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $f58ffd618d880169$export$2e2bcd8739ae039)(params, this, options);
}
const $fe0ecff350b304e4$var$prototype = $fe0ecff350b304e4$var$AxiosURLSearchParams.prototype;
$fe0ecff350b304e4$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$fe0ecff350b304e4$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $fe0ecff350b304e4$var$encode);
    } : $fe0ecff350b304e4$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $fe0ecff350b304e4$export$2e2bcd8739ae039 = $fe0ecff350b304e4$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $d83795c4759a90cb$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $d83795c4759a90cb$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $d83795c4759a90cb$var$encode;
    if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $fe0ecff350b304e4$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $c82eb4fead37f217$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $c82eb4fead37f217$export$2e2bcd8739ae039 = $c82eb4fead37f217$var$InterceptorManager;





'use strict';
var $ba4dbc937e10736d$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};








'use strict';
var $d36fc0885573bec7$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $fe0ecff350b304e4$export$2e2bcd8739ae039);


'use strict';
var $12f50f34bb0f6db6$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $5c377c7ec7ec3295$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $5a8f902bab2db281$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $d36fc0885573bec7$export$2e2bcd8739ae039,
        FormData: $12f50f34bb0f6db6$export$2e2bcd8739ae039,
        Blob: $5c377c7ec7ec3295$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $6e2637002758af5c$exports = {};

$parcel$export($6e2637002758af5c$exports, "hasBrowserEnv", function () { return $6e2637002758af5c$export$c4996c4b7b93b0bf; });
$parcel$export($6e2637002758af5c$exports, "navigator", function () { return $6e2637002758af5c$export$ec7c8efa7f5790ae; });
$parcel$export($6e2637002758af5c$exports, "hasStandardBrowserEnv", function () { return $6e2637002758af5c$export$c0bcc9250309d66; });
$parcel$export($6e2637002758af5c$exports, "hasStandardBrowserWebWorkerEnv", function () { return $6e2637002758af5c$export$c81692cf5af97dac; });
$parcel$export($6e2637002758af5c$exports, "origin", function () { return $6e2637002758af5c$export$f710a83a91838a36; });
const $6e2637002758af5c$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $6e2637002758af5c$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $6e2637002758af5c$export$c0bcc9250309d66 = $6e2637002758af5c$export$c4996c4b7b93b0bf && (!$6e2637002758af5c$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($6e2637002758af5c$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $6e2637002758af5c$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $6e2637002758af5c$export$f710a83a91838a36 = $6e2637002758af5c$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $528f9532d6567770$export$2e2bcd8739ae039 = (0, $cd54608a2366dcc8$export$71511d61b312f219)({}, $6e2637002758af5c$exports, (0, $5a8f902bab2db281$export$2e2bcd8739ae039));


'use strict';
function $c06dde869a07cd92$export$2e2bcd8739ae039(data, options) {
    return (0, $f58ffd618d880169$export$2e2bcd8739ae039)(data, new (0, $528f9532d6567770$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $cd54608a2366dcc8$export$71511d61b312f219)({
        visitor: function(value, key, path, helpers) {
            if ((0, $528f9532d6567770$export$2e2bcd8739ae039).isNode && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $2324c8b51ed637ef$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $d82f452f96bd0198$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $2324c8b51ed637ef$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $2324c8b51ed637ef$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $2324c8b51ed637ef$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFormData(formData) && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($2324c8b51ed637ef$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $2324c8b51ed637ef$export$2e2bcd8739ae039 = $2324c8b51ed637ef$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $3319b500ff2065be$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $d82f452f96bd0198$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $3319b500ff2065be$var$defaults = {
    transitional: (0, $ba4dbc937e10736d$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $2324c8b51ed637ef$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isBuffer(data) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isStream(data) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFile(data) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isBlob(data) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $c06dde869a07cd92$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $f58ffd618d880169$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $3319b500ff2065be$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $3319b500ff2065be$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isResponse(data) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $9c64fe188853780b$export$2e2bcd8739ae039).from(e, (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $528f9532d6567770$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $528f9532d6567770$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $3319b500ff2065be$var$defaults.headers[method] = {};
});
var $3319b500ff2065be$export$2e2bcd8739ae039 = $3319b500ff2065be$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36a44d89cc7ea202$var$ignoreDuplicateOf = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36a44d89cc7ea202$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36a44d89cc7ea202$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $b06eee669d760172$var$$internals = Symbol('internals');
function $b06eee669d760172$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $b06eee669d760172$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(value) ? value.map($b06eee669d760172$var$normalizeValue) : String(value);
}
function $b06eee669d760172$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $b06eee669d760172$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $b06eee669d760172$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $b06eee669d760172$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $b06eee669d760172$var$buildAccessors(obj, header) {
    const accessorName = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $b06eee669d760172$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $b06eee669d760172$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $b06eee669d760172$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$b06eee669d760172$var$isValidHeaderName(header)) setHeaders((0, $36a44d89cc7ea202$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isObject(header) && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $b06eee669d760172$var$normalizeHeader(header);
        if (header) {
            const key = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $b06eee669d760172$var$parseTokens(value);
                if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $b06eee669d760172$var$normalizeHeader(header);
        if (header) {
            const key = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $b06eee669d760172$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $b06eee669d760172$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $b06eee669d760172$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $b06eee669d760172$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $b06eee669d760172$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $b06eee669d760172$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $b06eee669d760172$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$b06eee669d760172$var$$internals] = this[$b06eee669d760172$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $b06eee669d760172$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $b06eee669d760172$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$b06eee669d760172$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $d82f452f96bd0198$export$2e2bcd8739ae039).reduceDescriptors($b06eee669d760172$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $d82f452f96bd0198$export$2e2bcd8739ae039).freezeMethods($b06eee669d760172$var$AxiosHeaders);
var $b06eee669d760172$export$2e2bcd8739ae039 = $b06eee669d760172$var$AxiosHeaders;


'use strict';
function $ffdcacf528c64d5c$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $3319b500ff2065be$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $b06eee669d760172$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $c8c2ad565cbf2a72$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $980d4b9efa91e299$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $9c64fe188853780b$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $d82f452f96bd0198$export$2e2bcd8739ae039).inherits($980d4b9efa91e299$var$CanceledError, (0, $9c64fe188853780b$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $980d4b9efa91e299$export$2e2bcd8739ae039 = $980d4b9efa91e299$var$CanceledError;







'use strict';
function $417a47fcea7dc277$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $9c64fe188853780b$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $731c60eb1f5d08b4$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $e1d0702a20b78846$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $e1d0702a20b78846$export$2e2bcd8739ae039 = $e1d0702a20b78846$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $4a361572774d082e$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $4a361572774d082e$export$2e2bcd8739ae039 = $4a361572774d082e$var$throttle;



const $33a4ee84b34583bb$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $e1d0702a20b78846$export$2e2bcd8739ae039)(50, 250);
    return (0, $4a361572774d082e$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $33a4ee84b34583bb$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $33a4ee84b34583bb$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $d82f452f96bd0198$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $a9b7762004fcc58c$export$2e2bcd8739ae039 = (0, $528f9532d6567770$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $528f9532d6567770$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $528f9532d6567770$export$2e2bcd8739ae039).origin), (0, $528f9532d6567770$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $528f9532d6567770$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $a175c0eee2995666$export$2e2bcd8739ae039 = (0, $528f9532d6567770$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $73e2afd3d9b1a382$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $4e7db27166f3e0f6$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $15c22144430e5e05$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $73e2afd3d9b1a382$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $4e7db27166f3e0f6$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





'use strict';
const $e7cbb920a68395d3$var$headersToObject = (thing)=>thing instanceof (0, $b06eee669d760172$export$2e2bcd8739ae039) ? (0, $cd54608a2366dcc8$export$71511d61b312f219)({}, thing) : thing;
function $e7cbb920a68395d3$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isPlainObject(target) && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $d82f452f96bd0198$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $d82f452f96bd0198$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($e7cbb920a68395d3$var$headersToObject(a), $e7cbb920a68395d3$var$headersToObject(b), prop, true)
    };
    (0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach(Object.keys((0, $cd54608a2366dcc8$export$71511d61b312f219)({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $a24b9df0c470b48a$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $e7cbb920a68395d3$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $b06eee669d760172$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $d83795c4759a90cb$export$2e2bcd8739ae039)((0, $15c22144430e5e05$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $528f9532d6567770$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $528f9532d6567770$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $528f9532d6567770$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $a9b7762004fcc58c$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $a175c0eee2995666$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $2f7791e3155504b9$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2f7791e3155504b9$export$2e2bcd8739ae039 = $2f7791e3155504b9$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $a24b9df0c470b48a$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $b06eee669d760172$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $b06eee669d760172$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $417a47fcea7dc277$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $9c64fe188853780b$export$2e2bcd8739ae039)('Request aborted', (0, $9c64fe188853780b$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $9c64fe188853780b$export$2e2bcd8739ae039)(msg, (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $ba4dbc937e10736d$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $9c64fe188853780b$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $9c64fe188853780b$export$2e2bcd8739ae039).ETIMEDOUT : (0, $9c64fe188853780b$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $33a4ee84b34583bb$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $33a4ee84b34583bb$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $980d4b9efa91e299$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $731c60eb1f5d08b4$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $528f9532d6567770$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $9c64fe188853780b$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};










const $e78b72cf8ba96899$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $9c64fe188853780b$export$2e2bcd8739ae039) ? err : new (0, $980d4b9efa91e299$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $9c64fe188853780b$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $9c64fe188853780b$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $d82f452f96bd0198$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $e78b72cf8ba96899$export$2e2bcd8739ae039 = $e78b72cf8ba96899$var$composeSignals;


const $59bad38bd6f4703c$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $59bad38bd6f4703c$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $59bad38bd6f4703c$var$readStream(iterable))yield* $59bad38bd6f4703c$export$71b051935044bd5d(chunk, chunkSize);
};
const $59bad38bd6f4703c$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $59bad38bd6f4703c$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $59bad38bd6f4703c$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $18bce2a54f2beb17$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $18bce2a54f2beb17$var$isFunction } = (0, $d82f452f96bd0198$export$2e2bcd8739ae039);
const $18bce2a54f2beb17$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $d82f452f96bd0198$export$2e2bcd8739ae039).global);
const { ReadableStream: $18bce2a54f2beb17$var$ReadableStream, TextEncoder: $18bce2a54f2beb17$var$TextEncoder } = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).global;
const $18bce2a54f2beb17$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $18bce2a54f2beb17$var$factory = (env)=>{
    env = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $18bce2a54f2beb17$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $18bce2a54f2beb17$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $18bce2a54f2beb17$var$isFunction(Request);
    const isResponseSupported = $18bce2a54f2beb17$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $18bce2a54f2beb17$var$isFunction($18bce2a54f2beb17$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $18bce2a54f2beb17$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $18bce2a54f2beb17$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $18bce2a54f2beb17$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $528f9532d6567770$export$2e2bcd8739ae039).origin, {
            body: new $18bce2a54f2beb17$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $18bce2a54f2beb17$var$test(()=>(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $9c64fe188853780b$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $528f9532d6567770$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $a24b9df0c470b48a$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $e78b72cf8ba96899$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $33a4ee84b34583bb$export$d9fadd12586c18d6)(requestContentLength, (0, $33a4ee84b34583bb$export$c1b28109d46c3592)((0, $33a4ee84b34583bb$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $59bad38bd6f4703c$export$b0119225647bd83)(_request.body, $18bce2a54f2beb17$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = (0, $9fceebefc81b9e0c$export$71511d61b312f219)((0, $cd54608a2366dcc8$export$71511d61b312f219)({}, fetchOptions), {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $33a4ee84b34583bb$export$d9fadd12586c18d6)(responseContentLength, (0, $33a4ee84b34583bb$export$c1b28109d46c3592)((0, $33a4ee84b34583bb$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $59bad38bd6f4703c$export$b0119225647bd83)(response.body, $18bce2a54f2beb17$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $d82f452f96bd0198$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $417a47fcea7dc277$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $b06eee669d760172$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $9c64fe188853780b$export$2e2bcd8739ae039)('Network Error', (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $9c64fe188853780b$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
        }
    };
};
const $18bce2a54f2beb17$var$seedCache = new Map();
const $18bce2a54f2beb17$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $18bce2a54f2beb17$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $18bce2a54f2beb17$var$factory(env));
        map = target;
    }
    return target;
};
const $18bce2a54f2beb17$var$adapter = $18bce2a54f2beb17$export$3105c6651375d4fa();
var $18bce2a54f2beb17$export$2e2bcd8739ae039 = $18bce2a54f2beb17$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ const $efa0db4a1611a8ba$var$knownAdapters = {
    http: (0, $da315430f87afb59$export$2e2bcd8739ae039),
    xhr: (0, $2f7791e3155504b9$export$2e2bcd8739ae039),
    fetch: {
        get: $18bce2a54f2beb17$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach($efa0db4a1611a8ba$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ const $efa0db4a1611a8ba$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $efa0db4a1611a8ba$var$isResolvedHandle = (adapter)=>(0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $efa0db4a1611a8ba$var$getAdapter(adapters, config) {
    adapters = (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$efa0db4a1611a8ba$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $efa0db4a1611a8ba$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $9c64fe188853780b$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($efa0db4a1611a8ba$var$renderReason).join('\n') : ' ' + $efa0db4a1611a8ba$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $9c64fe188853780b$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $efa0db4a1611a8ba$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $efa0db4a1611a8ba$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $efa0db4a1611a8ba$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $7d72e1af36c1d340$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $980d4b9efa91e299$export$2e2bcd8739ae039)(null, config);
}
function $7d72e1af36c1d340$export$2e2bcd8739ae039(config) {
    $7d72e1af36c1d340$var$throwIfCancellationRequested(config);
    config.headers = (0, $b06eee669d760172$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $ffdcacf528c64d5c$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $efa0db4a1611a8ba$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $3319b500ff2065be$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $7d72e1af36c1d340$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $ffdcacf528c64d5c$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $b06eee669d760172$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $c8c2ad565cbf2a72$export$2e2bcd8739ae039)(reason)) {
            $7d72e1af36c1d340$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $ffdcacf528c64d5c$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $b06eee669d760172$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $8fd1c7af4f2abe10$export$a4ad2735b021c132 = "1.13.2";



'use strict';
const $9c8e95e971febd3e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $9c8e95e971febd3e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $9c8e95e971febd3e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $9c8e95e971febd3e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $8fd1c7af4f2abe10$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $9c64fe188853780b$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$9c8e95e971febd3e$var$deprecatedWarnings[opt]) {
            $9c8e95e971febd3e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$9c8e95e971febd3e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $9c8e95e971febd3e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $9c64fe188853780b$export$2e2bcd8739ae039)('options must be an object', (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $9c64fe188853780b$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $9c64fe188853780b$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $9c64fe188853780b$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $9c8e95e971febd3e$export$2e2bcd8739ae039 = {
    assertOptions: $9c8e95e971febd3e$var$assertOptions,
    validators: $9c8e95e971febd3e$var$validators
};



'use strict';
const $1cd74ba212e1c8b9$var$validators = (0, $9c8e95e971febd3e$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $1cd74ba212e1c8b9$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $e7cbb920a68395d3$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $9c8e95e971febd3e$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $1cd74ba212e1c8b9$var$validators.transitional($1cd74ba212e1c8b9$var$validators.boolean),
            forcedJSONParsing: $1cd74ba212e1c8b9$var$validators.transitional($1cd74ba212e1c8b9$var$validators.boolean),
            clarifyTimeoutError: $1cd74ba212e1c8b9$var$validators.transitional($1cd74ba212e1c8b9$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $9c8e95e971febd3e$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $1cd74ba212e1c8b9$var$validators.function,
                serialize: $1cd74ba212e1c8b9$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $9c8e95e971febd3e$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $1cd74ba212e1c8b9$var$validators.spelling('baseURL'),
            withXsrfToken: $1cd74ba212e1c8b9$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $b06eee669d760172$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $7d72e1af36c1d340$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $7d72e1af36c1d340$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $e7cbb920a68395d3$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $15c22144430e5e05$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $d83795c4759a90cb$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $c82eb4fead37f217$export$2e2bcd8739ae039)(),
            response: new (0, $c82eb4fead37f217$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $1cd74ba212e1c8b9$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $e7cbb920a68395d3$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $d82f452f96bd0198$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $e7cbb920a68395d3$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $1cd74ba212e1c8b9$var$Axios.prototype[method] = generateHTTPMethod();
    $1cd74ba212e1c8b9$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $1cd74ba212e1c8b9$export$2e2bcd8739ae039 = $1cd74ba212e1c8b9$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $17f175df886aa8ed$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $17f175df886aa8ed$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $980d4b9efa91e299$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $17f175df886aa8ed$export$2e2bcd8739ae039 = $17f175df886aa8ed$var$CancelToken;






'use strict';
function $9c8e32a44418b4e0$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $d4d5d2fc23daa88d$export$2e2bcd8739ae039(payload) {
    return (0, $d82f452f96bd0198$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $243b777ff4fa2a24$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($243b777ff4fa2a24$var$HttpStatusCode).forEach(([key, value])=>{
    $243b777ff4fa2a24$var$HttpStatusCode[value] = key;
});
var $243b777ff4fa2a24$export$2e2bcd8739ae039 = $243b777ff4fa2a24$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $999e1eddad838c4e$var$createInstance(defaultConfig) {
    const context = new (0, $1cd74ba212e1c8b9$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $637b2afa1d42a1c4$export$2e2bcd8739ae039)((0, $1cd74ba212e1c8b9$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $d82f452f96bd0198$export$2e2bcd8739ae039).extend(instance, (0, $1cd74ba212e1c8b9$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $d82f452f96bd0198$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $999e1eddad838c4e$var$createInstance((0, $e7cbb920a68395d3$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $999e1eddad838c4e$var$axios = $999e1eddad838c4e$var$createInstance((0, $3319b500ff2065be$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$999e1eddad838c4e$var$axios.Axios = (0, $1cd74ba212e1c8b9$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$999e1eddad838c4e$var$axios.CanceledError = (0, $980d4b9efa91e299$export$2e2bcd8739ae039);
$999e1eddad838c4e$var$axios.CancelToken = (0, $17f175df886aa8ed$export$2e2bcd8739ae039);
$999e1eddad838c4e$var$axios.isCancel = (0, $c8c2ad565cbf2a72$export$2e2bcd8739ae039);
$999e1eddad838c4e$var$axios.VERSION = (0, $8fd1c7af4f2abe10$export$a4ad2735b021c132);
$999e1eddad838c4e$var$axios.toFormData = (0, $f58ffd618d880169$export$2e2bcd8739ae039);
// Expose AxiosError class
$999e1eddad838c4e$var$axios.AxiosError = (0, $9c64fe188853780b$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$999e1eddad838c4e$var$axios.Cancel = $999e1eddad838c4e$var$axios.CanceledError;
// Expose all/spread
$999e1eddad838c4e$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$999e1eddad838c4e$var$axios.spread = (0, $9c8e32a44418b4e0$export$2e2bcd8739ae039);
// Expose isAxiosError
$999e1eddad838c4e$var$axios.isAxiosError = (0, $d4d5d2fc23daa88d$export$2e2bcd8739ae039);
// Expose mergeConfig
$999e1eddad838c4e$var$axios.mergeConfig = (0, $e7cbb920a68395d3$export$2e2bcd8739ae039);
$999e1eddad838c4e$var$axios.AxiosHeaders = (0, $b06eee669d760172$export$2e2bcd8739ae039);
$999e1eddad838c4e$var$axios.formToJSON = (thing)=>(0, $2324c8b51ed637ef$export$2e2bcd8739ae039)((0, $d82f452f96bd0198$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$999e1eddad838c4e$var$axios.getAdapter = (0, $efa0db4a1611a8ba$export$2e2bcd8739ae039).getAdapter;
$999e1eddad838c4e$var$axios.HttpStatusCode = (0, $243b777ff4fa2a24$export$2e2bcd8739ae039);
$999e1eddad838c4e$var$axios.default = $999e1eddad838c4e$var$axios;
var // this module should only have a default export
$999e1eddad838c4e$export$2e2bcd8739ae039 = $999e1eddad838c4e$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c204f4f528561efe$export$1c00760e9e5a4e95, AxiosError: $c204f4f528561efe$export$c1fbed17c2f6a328, CanceledError: $c204f4f528561efe$export$1ab0c6b20d94fa14, isCancel: $c204f4f528561efe$export$3b22524397b493c6, CancelToken: $c204f4f528561efe$export$fd08e3cb425f0d61, VERSION: $c204f4f528561efe$export$a4ad2735b021c132, all: $c204f4f528561efe$export$84bf76cd7afc7469, Cancel: $c204f4f528561efe$export$848c9b7ead0df967, isAxiosError: $c204f4f528561efe$export$fbafdbe06a5b5a9a, spread: $c204f4f528561efe$export$3ae0fd4797ed47c8, toFormData: $c204f4f528561efe$export$10ae0d317ea97f8b, AxiosHeaders: $c204f4f528561efe$export$4e7d6ff0f3e6520, HttpStatusCode: $c204f4f528561efe$export$a972f69c851492b3, formToJSON: $c204f4f528561efe$export$86d7c59254d6a2c9, getAdapter: $c204f4f528561efe$export$17ddc20a97d669e2, mergeConfig: $c204f4f528561efe$export$7ec1ebcfa9d8bd6a } = (0, $999e1eddad838c4e$export$2e2bcd8739ae039);


(0, (/*@__PURE__*/$parcel$interopDefault($210451231afb5fd1$exports))).start({
    apiKey: "3e71707dda51c37549f2db4752ef8670",
    releaseStage: "production"
});
const $f148185795ca145e$export$74584b47fd40751e = async (trackingData)=>{
    const response = await (0, $999e1eddad838c4e$export$2e2bcd8739ae039).post("https://shop-client-tracking.goodgamestudios.com", trackingData).catch((error)=>{
        $f148185795ca145e$export$275a2173e9d84865(error);
        return error;
    });
    return response.status === 200;
};
const $f148185795ca145e$export$275a2173e9d84865 = (error)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($210451231afb5fd1$exports))).notify(error);
};
const $f148185795ca145e$export$180605366c04f0cd = ()=>{
    const queryParameters = new URLSearchParams(window.location.search);
    const userLang = queryParameters.has('lang') && queryParameters.get('lang') || navigator.language;
    return userLang;
};
const $f148185795ca145e$export$3447b803a5f9c7a0 = (texts)=>{
    const elements = document.querySelectorAll('[data-lang-tag]');
    for (const element of elements){
        const langTagName = element.dataset.langTag;
        if (texts[langTagName]) element.innerHTML = texts[langTagName];
        if (langTagName === '@year') element.textContent = new Date().getFullYear().toString();
    }
};
const $f148185795ca145e$export$dfe04b9b30f4004a = (name, value, formElement)=>{
    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    formElement.append(input);
};
const $f148185795ca145e$export$a0db4953bb08f589 = (href)=>{
    const element = document.createElement('link');
    element.href = href;
    document.head.append(element);
};



var $98afe526f3d8cd1d$exports = {};
$98afe526f3d8cd1d$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Zad\xe1n spr\xe1vn\xfd k\xf3d","webShop_howToFindId_desc":"Sv\xe9 osobn\xed ID najdete na sv\xe9m hr\xe1\u010Dsk\xe9m profilu.","webShop_howToFindId_link":"Kde najdu sv\xe9 osobn\xed ID?","webshop_offer_voucher_codeIsIncorrect":"Nespr\xe1vn\xfd k\xf3d","webshop_offer_voucher_enterYourCode":"Zadejte sv\xe9 osobn\xed ID","webShop_unexpectedError_desc":"Do\u0161lo k neo\u010Dek\xe1van\xe9 chyb\u011B, zkuste to pros\xedm pozd\u011Bji.","webShop_accountBanned_desc":"\xda\u010Det zablokov\xe1n!","webshop_confirm":"Ok","webshop_termsConditions_1":"V\u0161eobecn\xe9 obchodn\xed podm\xednky","webshop_purchase_privacyPolicy":"Ochrana \xfadaj\u016F","webshop_legal_1":"Pr\xe1vn\xed informace","webshop_support_1":"Podpora","mbs_access_welcome_desc":"V\xedtejte, hr\xe1\u010Di {0}","btn_login":"P\u0159ihl\xe1sit se","mbs_access_error_sessionExpired_desc":"Relace vypr\u0161ela. Zadejte pros\xedm ID \xfa\u010Dtu ru\u010Dn\u011B."}');


var $2c8bdf24769236f8$exports = {};
$2c8bdf24769236f8$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Korrekt kode indtastet","webShop_howToFindId_desc":"Du kan finde og kopiere dit personlige ID under din spillerprofil.","webShop_howToFindId_link":"Hvor finder jeg mit personlige ID?","webshop_offer_voucher_codeIsIncorrect":"Koden er forkert","webshop_offer_voucher_enterYourCode":"Indtast dit personlige ID","webShop_unexpectedError_desc":"Der opstod en uventet fejl. Pr\xf8v igen senere.","webShop_accountBanned_desc":"Konto sp\xe6rret!","webshop_confirm":"OK","webshop_termsConditions_1":"Brugsbetingelser","webshop_purchase_privacyPolicy":"Fortrolighedspolitik","webshop_legal_1":"Juridisk","webshop_support_1":"Support","mbs_access_welcome_desc":"Velkommen, {0}","btn_login":"Log ind","mbs_access_error_sessionExpired_desc":"Din session er udl\xf8bet. Indtast dit konto-ID manuelt."}');


var $9f1152623e5714c5$exports = {};
$9f1152623e5714c5$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Korrekten Code eingegeben","webShop_howToFindId_desc":"Ihr k\xf6nnt Eure pers\xf6nliche ID in Eurem Spielerprofil finden und kopieren.","webShop_howToFindId_link":"Wo finde ich meine pers\xf6nliche ID?","webshop_offer_voucher_codeIsIncorrect":"Code stimmt nicht","webshop_offer_voucher_enterYourCode":"Gebt Eure pers\xf6nliche ID ein.","webShop_unexpectedError_desc":"Ein unerwarteter Fehler ist aufgetreten. Bitte versucht es sp\xe4ter erneut.","webShop_accountBanned_desc":"Account gesperrt!","webshop_confirm":"OK","webshop_termsConditions_1":"AGB","webshop_purchase_privacyPolicy":"Datenschutzerkl\xe4rung","webshop_legal_1":"Rechtliches","webshop_support_1":"Support","mbs_access_welcome_desc":"Willkommen, {0}","btn_login":"Login","mbs_access_error_sessionExpired_desc":"Eure Sitzung ist abgelaufen, bitte die Account-ID manuell eingeben."}');


var $35f3f576787e6916$exports = {};
$35f3f576787e6916$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03B8\u03B7\u03BA\u03B5 \u03C3\u03C9\u03C3\u03C4\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2","webShop_howToFindId_desc":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C2 \u03BD\u03B1 \u03B2\u03C1\u03B5\u03B9\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C8\u03B5\u03B9\u03C2 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03BF\u03C5 ID \u03C3\u03C4\u03BF \u03C0\u03C1\u03BF\u03C6\u03AF\u03BB \u03C0\u03B1\u03AF\u03BA\u03C4\u03B7 \u03C3\u03BF\u03C5.","webShop_howToFindId_link":"\u03A0\u03BF\u03CD \u03BC\u03C0\u03BF\u03C1\u03CE \u03BD\u03B1 \u03B2\u03C1\u03C9 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03BC\u03BF\u03C5 \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC;","webshop_offer_voucher_codeIsIncorrect":"\u039F \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BB\u03B1\u03BD\u03B8\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2","webshop_offer_voucher_enterYourCode":"\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B5 \u03C4\u03BF \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03B9\u03BA\u03CC \u03C3\u03BF\u03C5 \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC","webShop_unexpectedError_desc":"\u03A0\u03C1\u03BF\u03AD\u03BA\u03C5\u03C8\u03B5 \u03BC\u03B7 \u03B1\u03BD\u03B1\u03BC\u03B5\u03BD\u03CC\u03BC\u03B5\u03BD\u03BF \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1, \u03B4\u03BF\u03BA\u03AF\u03BC\u03B1\u03C3\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1.","webShop_accountBanned_desc":"\u039B\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC\u03C2 \u03B1\u03C0\u03BF\u03BA\u03BB\u03B5\u03AF\u03C3\u03C4\u03B7\u03BA\u03B5!","webshop_confirm":"OK","webshop_termsConditions_1":"\u038C\u03C1\u03BF\u03B9 &amp; \u03A0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2","webshop_purchase_privacyPolicy":"\u03A0\u03BF\u03BB\u03B9\u03C4\u03B9\u03BA\u03AE \u03B1\u03C0\u03BF\u03C1\u03C1\u03AE\u03C4\u03BF\u03C5","webshop_legal_1":"\u039D\u03BF\u03BC\u03B9\u03BA\u03AD\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2","webshop_support_1":"\u03A5\u03C0\u03BF\u03C3\u03C4\u03AE\u03C1\u03B9\u03BE\u03B7","mbs_access_welcome_desc":"\u039A\u03B1\u03BB\u03CE\u03C2 \u03CC\u03C1\u03B9\u03C3\u03B5\u03C2, {0}","btn_login":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","mbs_access_error_sessionExpired_desc":"\u0397 \u03C0\u03B5\u03C1\u03AF\u03BF\u03B4\u03BF\u03C2 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1\u03C2 \u03AD\u03BB\u03B7\u03BE\u03B5. \u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B5 \u03C4\u03BF ID \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD \u03C3\u03BF\u03C5 \u03BC\u03B7 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1."}');


var $817438c799bd82af$exports = {};
$817438c799bd82af$exports = JSON.parse("{\"webshop_offer_voucher_correctCode\":\"Correct code entered\",\"webShop_howToFindId_desc\":\"You can find and copy your personal ID in your player profile.\",\"webShop_howToFindId_link\":\"Where do I find my personal ID?\",\"webshop_offer_voucher_codeIsIncorrect\":\"Code is incorrect\",\"webshop_offer_voucher_enterYourCode\":\"Enter your personal ID\",\"webShop_unexpectedError_desc\":\"An unexpected error occurred, please try again later.\",\"webShop_accountBanned_desc\":\"Account banned!\",\"webshop_confirm\":\"OK\",\"webshop_termsConditions_1\":\"Terms &amp; Conditions\",\"webshop_purchase_privacyPolicy\":\"Privacy Policy\",\"webshop_legal_1\":\"Legal\",\"webshop_support_1\":\"Support\",\"mbs_access_welcome_desc\":\"Welcome, {0}\",\"btn_login\":\"Login\",\"mbs_access_error_sessionExpired_desc\":\"Your session has expired. Please enter your account ID manually.\"}");


var $58a54afff3d24dfe$exports = {};
$58a54afff3d24dfe$exports = JSON.parse("{\"webshop_offer_voucher_correctCode\":\"Correct code entered\",\"webShop_howToFindId_desc\":\"You can find and copy your personal ID in your player profile.\",\"webShop_howToFindId_link\":\"Where do I find my personal ID?\",\"webshop_offer_voucher_codeIsIncorrect\":\"Code is incorrect\",\"webshop_offer_voucher_enterYourCode\":\"Enter your personal ID\",\"webShop_unexpectedError_desc\":\"An unexpected error occurred, please try again later.\",\"webShop_accountBanned_desc\":\"Account banned!\",\"webshop_confirm\":\"OK\",\"webshop_termsConditions_1\":\"Terms &amp; Conditions\",\"webshop_purchase_privacyPolicy\":\"Privacy Policy\",\"webshop_legal_1\":\"Legal\",\"webshop_support_1\":\"Support\",\"mbs_access_welcome_desc\":\"Welcome, {0}\",\"btn_login\":\"Login\",\"mbs_access_error_sessionExpired_desc\":\"Your session has expired. Please enter your account ID manually.\"}");


var $f1db60e624b8ff72$exports = {};
$f1db60e624b8ff72$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"C\xf3digo correcto","webShop_howToFindId_desc":"Puedes buscar y copiar tu ID personal en el perfil.","webShop_howToFindId_link":"\xbfD\xf3nde puedo ver mi ID personal?","webshop_offer_voucher_codeIsIncorrect":"C\xf3digo incorrecto","webshop_offer_voucher_enterYourCode":"Escribe tu ID personal...","webShop_unexpectedError_desc":"Se ha producido un error inesperado. Int\xe9ntalo de nuevo m\xe1s tarde.","webShop_accountBanned_desc":"\xa1Cuenta bloqueada!","webshop_confirm":"OK","webshop_termsConditions_1":"Condiciones de uso","webshop_purchase_privacyPolicy":"Pol\xedtica de privacidad","webshop_legal_1":"Legal","webshop_support_1":"Asistencia","mbs_access_welcome_desc":"\xa1Hola, {0}!","btn_login":"Iniciar sesi\xf3n","mbs_access_error_sessionExpired_desc":"La sesi\xf3n ha caducado. Introduce tu ID de cuenta de forma manual."}');


var $1165680bd305d186$exports = {};
$1165680bd305d186$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Annettu koodi on oikea","webShop_howToFindId_desc":"Voit kopioida oman tunnuksesi pelaajaprofiilistasi.","webShop_howToFindId_link":"Mist\xe4 l\xf6yd\xe4n oman tunnukseni?","webshop_offer_voucher_codeIsIncorrect":"Koodi on virheellinen","webshop_offer_voucher_enterYourCode":"Sy\xf6t\xe4 henkil\xf6kohtainen tunnuksesi","webShop_unexpectedError_desc":"Tapahtui odottamaton virhe. Yrit\xe4 my\xf6hemmin uudelleen.","webShop_accountBanned_desc":"Tili on k\xe4ytt\xf6kiellossa!","webshop_confirm":"OK","webshop_termsConditions_1":"K\xe4ytt\xf6ehdot","webshop_purchase_privacyPolicy":"Tietosuojak\xe4yt\xe4nt\xf6","webshop_legal_1":"Juridiset tiedot","webshop_support_1":"Tuki","mbs_access_welcome_desc":"Tervetuloa, {0}","btn_login":"Kirjaudu","mbs_access_error_sessionExpired_desc":"Sessiosi on vanhentunut. Kirjoita tilitunnuksesi."}');


var $76eca52131c5fdbb$exports = {};
$76eca52131c5fdbb$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Code correct saisi","webShop_howToFindId_desc":"Vous pouvez retrouver et copier votre ID personnel \xe0 partir de votre profil.","webShop_howToFindId_link":"O\xf9 trouver mon ID personnel\xa0?","webshop_offer_voucher_codeIsIncorrect":"Le code est incorrect","webshop_offer_voucher_enterYourCode":"Saisissez votre ID personnel","webShop_unexpectedError_desc":"Une erreur inattendue s\'est produite. Veuillez r\xe9essayer ult\xe9rieurement.","webShop_accountBanned_desc":"Compte banni\xa0!","webshop_confirm":"OK","webshop_termsConditions_1":"Conditions g\xe9n\xe9rales d\'utilisation","webshop_purchase_privacyPolicy":"Protection des donn\xe9es","webshop_legal_1":"Mentions l\xe9gales","webshop_support_1":"Support","mbs_access_welcome_desc":"Bienvenue, {0}","btn_login":"Connexion","mbs_access_error_sessionExpired_desc":"Votre session a expir\xe9. Veuillez saisir manuellement l\'ID de votre compte."}');


var $860fb862e63a637f$exports = {};
$860fb862e63a637f$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"A megadott k\xf3d helyes","webShop_howToFindId_desc":"A szem\xe9lyi azonos\xedt\xf3dat a j\xe1t\xe9kosprofilodban tal\xe1lhatod meg \xe9s m\xe1solhatod ki.","webShop_howToFindId_link":"Hol tal\xe1lhat\xf3 a szem\xe9lyes azonos\xedt\xf3m?","webshop_offer_voucher_codeIsIncorrect":"Helytelen k\xf3d","webshop_offer_voucher_enterYourCode":"Add meg a szem\xe9lyes azonos\xedt\xf3dat","webShop_unexpectedError_desc":"V\xe1ratlan hiba t\xf6rt\xe9nt, pr\xf3b\xe1ld \xfajra k\xe9s\u0151bb.","webShop_accountBanned_desc":"Fi\xf3k kitiltva!","webshop_confirm":"OK","webshop_termsConditions_1":"Felhaszn\xe1l\xe1si felt\xe9telek","webshop_purchase_privacyPolicy":"Adatv\xe9delmi szab\xe1lyzat","webshop_legal_1":"Jogi","webshop_support_1":"\xdcgyf\xe9lszolg\xe1lat","mbs_access_welcome_desc":"\xdcdv, {0}!","btn_login":"Bejelentkez\xe9s","mbs_access_error_sessionExpired_desc":"A munkamenet lej\xe1rt. Add meg manu\xe1lisan a fi\xf3kazonos\xedt\xf3dat."}');


var $81b5d3fe09c339d1$exports = {};
$81b5d3fe09c339d1$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Codice immesso corretto","webShop_howToFindId_desc":"Puoi trovare e copiare il tuo ID personale nel tuo profilo giocatore.","webShop_howToFindId_link":"Dove trovo il mio ID personale?","webshop_offer_voucher_codeIsIncorrect":"Il codice \xe8 errato","webshop_offer_voucher_enterYourCode":"Immetti il tuo ID personale","webShop_unexpectedError_desc":"Si \xe8 verificato un errore imprevisto, riprova pi\xf9 tardi.","webShop_accountBanned_desc":"Account bannato!","webshop_confirm":"OK","webshop_termsConditions_1":"Termini e condizioni","webshop_purchase_privacyPolicy":"Privacy","webshop_legal_1":"Legale","webshop_support_1":"Assistenza","mbs_access_welcome_desc":"Ciao, {0}","btn_login":"Accedi","mbs_access_error_sessionExpired_desc":"La tua sessione \xe8 scaduta. Immetti manualmente il tuo ID account."}');


var $b60c5c71d6430161$exports = {};
$b60c5c71d6430161$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u6B63\u3057\u3044\u30B3\u30FC\u30C9\u304C\u5165\u529B\u3055\u308C\u307E\u3057\u305F","webShop_howToFindId_desc":"\u500B\u4EBAID\u306F\u3001\u30D7\u30EC\u30FC\u30E4\u30FC\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u304B\u3089\u30B3\u30D4\u30FC\u3067\u304D\u307E\u3059\u3002","webShop_howToFindId_link":"\u500B\u4EBAID\u306F\u3069\u3053\u306B\u3042\u308A\u307E\u3059\u304B\uFF1F","webshop_offer_voucher_codeIsIncorrect":"\u30B3\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059","webshop_offer_voucher_enterYourCode":"\u500B\u4EBAID\u3092\u5165\u529B\u3059\u308B","webShop_unexpectedError_desc":"\u4E88\u671F\u3057\u306A\u3044\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","webShop_accountBanned_desc":"\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u505C\u6B62\u3055\u308C\u307E\u3057\u305F\uFF01","webshop_confirm":"OK","webshop_termsConditions_1":"\u5229\u7528\u898F\u7D04","webshop_purchase_privacyPolicy":"\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC","webshop_legal_1":"\u6CD5\u7684\u4E8B\u9805","webshop_support_1":"\u30B5\u30DD\u30FC\u30C8","mbs_access_welcome_desc":"{0}\u3055\u3093\u3001\u3088\u3046\u3053\u305D\u3002","btn_login":"\u30ED\u30B0\u30A4\u30F3","mbs_access_error_sessionExpired_desc":"\u30BB\u30C3\u30B7\u30E7\u30F3\u304C\u5931\u52B9\u3057\u307E\u3057\u305F\u3002\u30A2\u30AB\u30A6\u30F3\u30C8ID\u3092\u624B\u52D5\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}');


var $992f2b467276c334$exports = {};
$992f2b467276c334$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\uC62C\uBC14\uB978 \uCF54\uB4DC\uAC00 \uC785\uB825\uB428","webShop_howToFindId_desc":"\uD50C\uB808\uC774\uC5B4 \uD504\uB85C\uD544\uC5D0\uC11C \uAC1C\uC778 ID\uB97C \uD655\uC778\uD558\uACE0 \uBCF5\uC0AC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","webShop_howToFindId_link":"\uAC1C\uC778 ID\uB97C \uC5B4\uB514\uC11C \uCC3E\uC744 \uC218 \uC788\uB098\uC694?","webshop_offer_voucher_codeIsIncorrect":"\uCF54\uB4DC\uAC00 \uC798\uBABB\uB428","webshop_offer_voucher_enterYourCode":"\uAC1C\uC778 ID \uC785\uB825","webShop_unexpectedError_desc":"\uC608\uAE30\uCE58 \uBABB\uD55C \uC624\uB958 \uBC1C\uC0DD, \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.","webShop_accountBanned_desc":"\uACC4\uC815\uC774 \uC815\uC9C0\uB428!","webshop_confirm":"\uD655\uC778","webshop_termsConditions_1":"\uC57D\uAD00","webshop_purchase_privacyPolicy":"\uAC1C\uC778\uC815\uBCF4\uCDE8\uAE09\uBC29\uCE68","webshop_legal_1":"\uBC95\uB960","webshop_support_1":"\uC9C0\uC6D0","mbs_access_welcome_desc":"\uD658\uC601\uD569\uB2C8\uB2E4, {0} \uB2D8","btn_login":"\uB85C\uADF8\uC778","mbs_access_error_sessionExpired_desc":"\uC138\uC158\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uACC4\uC815 ID\uB97C \uC9C1\uC811 \uC785\uB825\uD574 \uC8FC\uC2ED\uC2DC\uC624."}');


var $2a48123b997ada5e$exports = {};
$2a48123b997ada5e$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Juiste code ingevuld","webShop_howToFindId_desc":"Je persoonlijke ID vind je en kun je kopi\xebren in je spelersprofiel.","webShop_howToFindId_link":"Waar vind ik mijn persoonlijke ID?","webshop_offer_voucher_codeIsIncorrect":"Code is onjuist","webshop_offer_voucher_enterYourCode":"Voer je persoonlijke ID in","webShop_unexpectedError_desc":"Er is een onverwachte fout opgetreden. Probeer het later opnieuw.","webShop_accountBanned_desc":"Account verbannen!","webshop_confirm":"OK","webshop_termsConditions_1":"Algemene voorwaarden","webshop_purchase_privacyPolicy":"Privacybeleid","webshop_legal_1":"Juridisch","webshop_support_1":"Ondersteuning","mbs_access_welcome_desc":"Welkom, {0}","btn_login":"Aanmelden","mbs_access_error_sessionExpired_desc":"Je sessie is verlopen. Voer je account-ID handmatig in."}');


var $29cf4b37873a953a$exports = {};
$29cf4b37873a953a$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Gyldig kode","webShop_howToFindId_desc":"I spillerprofilen din finner du ID-en din, og du kan kopiere den derfra.","webShop_howToFindId_link":"Hvor finner jeg min personlige ID?","webshop_offer_voucher_codeIsIncorrect":"Feil kode","webshop_offer_voucher_enterYourCode":"Skriv inn din personlige ID","webShop_unexpectedError_desc":"Det har oppst\xe5tt en uventet feil. Pr\xf8v igjen senere.","webShop_accountBanned_desc":"Kontoen er utestengt!","webshop_confirm":"OK","webshop_termsConditions_1":"Bruksvilk\xe5r","webshop_purchase_privacyPolicy":"Retningslinjer for personvern","webshop_legal_1":"Juridisk","webshop_support_1":"Kundest\xf8tte","mbs_access_welcome_desc":"Velkommen, {0}","btn_login":"Logg inn","mbs_access_error_sessionExpired_desc":"\xd8kten har utl\xf8pt. Skriv inn konto-ID manuelt."}');


var $ce671761a0a87f11$exports = {};
$ce671761a0a87f11$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Wprowadzono poprawny kod","webShop_howToFindId_desc":"Sw\xf3j identyfikator osobisty znajdziesz i skopiujesz na ekranie swojego profilu gracza.","webShop_howToFindId_link":"Gdzie znajd\u0119 moje osobiste ID?","webshop_offer_voucher_codeIsIncorrect":"Kod jest niew\u0142a\u015Bciwy","webshop_offer_voucher_enterYourCode":"Wprowad\u017A sw\xf3j identyfikator osobisty","webShop_unexpectedError_desc":"Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d. Prosimy spr\xf3bowa\u0107 ponownie p\xf3\u017Aniej.","webShop_accountBanned_desc":"Konto zablokowane!","webshop_confirm":"OK","webshop_termsConditions_1":"Warunki u\u017Cytkowania","webshop_purchase_privacyPolicy":"Ochrona danych osobowych","webshop_legal_1":"Informacje prawne","webshop_support_1":"Wsparcie","mbs_access_welcome_desc":"Witaj, {0}!","btn_login":"Logowanie","mbs_access_error_sessionExpired_desc":"Sesja wygas\u0142a. Prosimy o r\u0119czne wprowadzenie ID konta."}');


var $467777f96d8a6934$exports = {};
$467777f96d8a6934$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"C\xf3digo correto inserido","webShop_howToFindId_desc":"Voc\xea pode encontrar e copiar sua ID pessoal no seu perfil de jogador.","webShop_howToFindId_link":"Onde encontro minha ID pessoal?","webshop_offer_voucher_codeIsIncorrect":"C\xf3digo incorreto","webshop_offer_voucher_enterYourCode":"Insira sua ID pessoal","webShop_unexpectedError_desc":"Erro inesperado. Tente novamente mais tarde.","webShop_accountBanned_desc":"Conta banida!","webshop_confirm":"OK","webshop_termsConditions_1":"Termos e Condi\xe7\xf5es","webshop_purchase_privacyPolicy":"Pol\xedtica de Privacidade","webshop_legal_1":"Legal","webshop_support_1":"Suporte","mbs_access_welcome_desc":"Bem-vindo, {0}","btn_login":"Login","mbs_access_error_sessionExpired_desc":"Sua sess\xe3o expirou. Insira sua ID de conta manualmente."}');


var $3d53b803f5866eaa$exports = {};
$3d53b803f5866eaa$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"C\xf3digo correto inserido","webShop_howToFindId_desc":"Voc\xea pode encontrar e copiar sua ID pessoal no seu perfil de jogador.","webShop_howToFindId_link":"Onde encontro minha ID pessoal?","webshop_offer_voucher_codeIsIncorrect":"C\xf3digo incorreto","webshop_offer_voucher_enterYourCode":"Insira sua ID pessoal","webShop_unexpectedError_desc":"Erro inesperado. Tente novamente mais tarde.","webShop_accountBanned_desc":"Conta banida!","webshop_confirm":"OK","webshop_termsConditions_1":"Termos e Condi\xe7\xf5es","webshop_purchase_privacyPolicy":"Pol\xedtica de Privacidade","webshop_legal_1":"Legal","webshop_support_1":"Suporte","mbs_access_welcome_desc":"Bem-vindo, {0}","btn_login":"Login","mbs_access_error_sessionExpired_desc":"Sua sess\xe3o expirou. Insira sua ID de conta manualmente."}');


var $51e5426ba0aa35cf$exports = {};
$51e5426ba0aa35cf$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Cod corect introdus","webShop_howToFindId_desc":"Po\u021Bi g\u0103si \u0219i copia ID-ul personal din profilul t\u0103u de juc\u0103tor.","webShop_howToFindId_link":"Unde g\u0103sesc ID-ul meu personal?","webshop_offer_voucher_codeIsIncorrect":"Codul este incorect","webshop_offer_voucher_enterYourCode":"Introdu ID-ul personal","webShop_unexpectedError_desc":"A ap\u0103rut o eroare nea\u0219teptat\u0103, \xeencearc\u0103 din nou mai t\xe2rziu.","webShop_accountBanned_desc":"Cont blocat!","webshop_confirm":"OK","webshop_termsConditions_1":"Termeni \u0219i Condi\u021Bii","webshop_purchase_privacyPolicy":"Politica de confiden\u0163ialitate","webshop_legal_1":"Juridic","webshop_support_1":"Asisten\u0163\u0103","mbs_access_welcome_desc":"Bun venit, {0}","btn_login":"Conectare","mbs_access_error_sessionExpired_desc":"Sesiunea ta a expirat. Introdu manual ID-ul contului."}');


var $4a5180c99562fbcf$exports = {};
$4a5180c99562fbcf$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u0412\u0432\u0435\u0434\u0435\u043D \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434","webShop_howToFindId_desc":"\u0422\u044B \u043C\u043E\u0436\u0435\u0448\u044C \u043D\u0430\u0439\u0442\u0438 \u0438 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0432\u043E\u0439 \u043B\u0438\u0447\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0432 \u0441\u0432\u043E\u0435\u043C \u043F\u0440\u043E\u0444\u0438\u043B\u0435 \u0438\u0433\u0440\u043E\u043A\u0430.","webShop_howToFindId_link":"\u0413\u0434\u0435 \u044F \u043C\u043E\u0433\u0443 \u043D\u0430\u0439\u0442\u0438 \u0441\u0432\u043E\u0439 \u043B\u0438\u0447\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440?","webshop_offer_voucher_codeIsIncorrect":"\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434","webshop_offer_voucher_enterYourCode":"\u0412\u0432\u0435\u0434\u0438 \u0441\u0432\u043E\u0439 \u043B\u0438\u0447\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440","webShop_unexpectedError_desc":"\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0435\u043D\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430; \u043F\u043E\u0432\u0442\u043E\u0440\u0438 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u0447\u0443\u0442\u044C \u043F\u043E\u0437\u0436\u0435.","webShop_accountBanned_desc":"\u0423\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430!","webshop_confirm":"OK","webshop_termsConditions_1":"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435","webshop_purchase_privacyPolicy":"\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438","webshop_legal_1":"\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F","webshop_support_1":"\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430","mbs_access_welcome_desc":"\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C, {0}!","btn_login":"\u0412\u0445\u043E\u0434","mbs_access_error_sessionExpired_desc":"\u0412\u0440\u0435\u043C\u044F \u0441\u0435\u0430\u043D\u0441\u0430 \u0438\u0441\u0442\u0435\u043A\u043B\u043E. \u0412\u0432\u0435\u0434\u0438 \u0441\u0432\u043E\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0432\u0440\u0443\u0447\u043D\u0443\u044E."}');


var $07ee879a782c78bf$exports = {};
$07ee879a782c78bf$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Zadal si spr\xe1vny k\xf3d","webShop_howToFindId_desc":"Svoje osobn\xe9 ID n\xe1jde\u0161 v profile hr\xe1\u010Da, kde ho m\xf4\u017Ee\u0161 skop\xedrova\u0165.","webShop_howToFindId_link":"Kde n\xe1jdem svoje osobn\xe9 ID?","webshop_offer_voucher_codeIsIncorrect":"K\xf3d nie je spr\xe1vny","webshop_offer_voucher_enterYourCode":"Zadaj svoje osobn\xe9 ID","webShop_unexpectedError_desc":"Vyskytla sa neo\u010Dak\xe1van\xe1 chyba, sk\xfas to znova nesk\xf4r.","webShop_accountBanned_desc":"Konto je zablokovan\xe9!","webshop_confirm":"OK","webshop_termsConditions_1":"Zmluvn\xe9 podmienky","webshop_purchase_privacyPolicy":"Ochrana osobn\xfdch \xfadajov","webshop_legal_1":"Pr\xe1vne inform\xe1cie","webshop_support_1":"Podpora","mbs_access_welcome_desc":"Vitaj, {0}","btn_login":"Prihl\xe1senie","mbs_access_error_sessionExpired_desc":"\u010Cas tejto rel\xe1cie uplynul. Zadaj ID svojho konta ru\u010Dne."}');


var $8381fd879b458e22$exports = {};
$8381fd879b458e22$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Du angav en giltig kod","webShop_howToFindId_desc":"Du kan hitta och kopiera ditt personliga ID i din spelarprofil.","webShop_howToFindId_link":"Var hittar jag mitt personliga ID?","webshop_offer_voucher_codeIsIncorrect":"Koden \xe4r felaktig","webshop_offer_voucher_enterYourCode":"Ange ditt personliga ID","webShop_unexpectedError_desc":"Ett ov\xe4ntat fel har intr\xe4ffat. F\xf6rs\xf6k igen senare.","webShop_accountBanned_desc":"Konto avst\xe4ngt!","webshop_confirm":"OK","webshop_termsConditions_1":"Villkor och krav","webshop_purchase_privacyPolicy":"Integritetspolicy","webshop_legal_1":"Juridiskt","webshop_support_1":"Kontakta supporten","mbs_access_welcome_desc":"V\xe4lkommen, {0}","btn_login":"Logga in","mbs_access_error_sessionExpired_desc":"Din session har g\xe5tt ut. Ange ditt konto-ID manuellt."}');


var $fedac20605d462c7$exports = {};
$fedac20605d462c7$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"Girilen kod do\u011Fru","webShop_howToFindId_desc":"Oyuncu profilindeki ki\u015Fisel kimli\u011Fini bulabilir ve kopyalayabilirsin.","webShop_howToFindId_link":"Ki\u015Fisel kimli\u011Fimi nerede bulabilirim?","webshop_offer_voucher_codeIsIncorrect":"Kod yanl\u0131\u015F","webshop_offer_voucher_enterYourCode":"Ki\u015Fisel Kimli\u011Fini gir","webShop_unexpectedError_desc":"Beklenmedik bir hata ger\xe7ekle\u015Fti, l\xfctfen daha sonra tekrar dene.","webShop_accountBanned_desc":"Hesap engellendi!","webshop_confirm":"OK","webshop_termsConditions_1":"\u015Eart ve Ko\u015Fullar","webshop_purchase_privacyPolicy":"Gizlilik Politikas\u0131","webshop_legal_1":"Yasal","webshop_support_1":"Destek","mbs_access_welcome_desc":"Ho\u015F geldin {0}","btn_login":"Oturum a\xe7","mbs_access_error_sessionExpired_desc":"Oturumunun s\xfcresi doldu. L\xfctfen hesap kimli\u011Fini manuel olarak gir."}');


var $4f82400818ea9bf5$exports = {};
$4f82400818ea9bf5$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u8F93\u5165\u7684\u9A8C\u8BC1\u7801\u6B63\u786E","webShop_howToFindId_desc":"\u4F60\u53EF\u4EE5\u5728\u73A9\u5BB6\u8D44\u6599\u4E2D\u627E\u5230\u5E76\u590D\u5236\u4F60\u7684\u4E2A\u4EBA ID","webShop_howToFindId_link":"\u6211\u7684\u4E2A\u4EBA ID \u5728\u54EA\u91CC\u53EF\u4EE5\u627E\u5230\uFF1F","webshop_offer_voucher_codeIsIncorrect":"\u4EE3\u7801\u4E0D\u6B63\u786E","webshop_offer_voucher_enterYourCode":"\u8F93\u5165\u60A8\u7684\u4EE3\u7801","webShop_unexpectedError_desc":"An unexpected error occurred, please try again later.","webShop_accountBanned_desc":"Account banned!","webshop_confirm":"\u786E\u5B9A","mbs_access_welcome_desc":"Welcome, {0}","btn_login":"Login","mbs_access_error_sessionExpired_desc":"Your session has expired. Please enter your account ID manually."}');


var $f23ad6d493b69e97$exports = {};
$f23ad6d493b69e97$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u8F93\u5165\u7684\u9A8C\u8BC1\u7801\u6B63\u786E","webShop_howToFindId_desc":"\u60A8\u53EF\u4EE5\u5728\u73A9\u5BB6\u4E2A\u4EBA\u8D44\u6599\u4E2D\u627E\u5230\u5E76\u590D\u5236\u4E2A\u4EBA ID\u3002","webShop_howToFindId_link":"\u54EA\u91CC\u53EF\u4EE5\u627E\u5230\u6211\u7684\u4E2A\u4EBA ID\uFF1F","webshop_offer_voucher_codeIsIncorrect":"\u4EE3\u7801\u4E0D\u6B63\u786E","webshop_offer_voucher_enterYourCode":"\u8F93\u5165\u60A8\u7684\u4E2A\u4EBA ID","webShop_unexpectedError_desc":"\u53D1\u751F\u610F\u5916\u9519\u8BEF\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002","webShop_accountBanned_desc":"\u5E10\u6237\u88AB\u5C01\uFF01","webshop_confirm":"\u786E\u5B9A","webshop_termsConditions_1":"\u6761\u6B3E\u548C\u6761\u4EF6","webshop_purchase_privacyPolicy":"\u9690\u79C1\u653F\u7B56","webshop_legal_1":"\u6CD5\u5F8B","webshop_support_1":"\u652F\u6301","mbs_access_welcome_desc":"\u6B22\u8FCE\uFF0C{0}","btn_login":"\u767B\u5F55","mbs_access_error_sessionExpired_desc":"\u60A8\u672C\u6B21\u6E38\u620F\u5DF2\u8FC7\u671F\u3002\u8BF7\u624B\u52A8\u8F93\u5165\u60A8\u7684\u5E10\u6237 ID\u3002"}');


var $3a53ac01a37ef9e4$exports = {};
$3a53ac01a37ef9e4$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u8F38\u5165\u7684\u4EE3\u78BC\u6B63\u78BA","webShop_howToFindId_desc":"\u4F60\u53EF\u4EE5\u5728\u4F60\u7684\u73A9\u5BB6\u500B\u4EBA\u8CC7\u6599\u4E2D\u627E\u5230\u4E26\u8907\u88FD\u4F60\u7684\u500B\u4EBA ID\u3002","webShop_howToFindId_link":"\u5728\u54EA\u88E1\u627E\u5230\u6211\u7684\u500B\u4EBA ID\uFF1F","webshop_offer_voucher_codeIsIncorrect":"\u4EE3\u78BC\u4E0D\u6B63\u78BA","webshop_offer_voucher_enterYourCode":"\u8F38\u5165\u4F60\u7684\u500B\u4EBA ID","webShop_unexpectedError_desc":"\u767C\u751F\u672A\u9810\u671F\u7684\u932F\u8AA4\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002","webShop_accountBanned_desc":"\u5E33\u865F\u5DF2\u88AB\u7981\u7528\uFF01","webshop_confirm":"\u597D","webshop_termsConditions_1":"\u670D\u52D9\u689D\u6B3E","webshop_purchase_privacyPolicy":"\u96B1\u79C1\u653F\u7B56","webshop_legal_1":"\u5408\u6CD5","webshop_support_1":"\u6280\u8853\u652F\u63F4","mbs_access_welcome_desc":"\u6B61\u8FCE\uFF0C{0}","btn_login":"\u767B\u5165","mbs_access_error_sessionExpired_desc":"\u4F60\u7684\u8F38\u5165\u968E\u6BB5\u5DF2\u7D93\u903E\u6642\u3002\u8ACB\u624B\u52D5\u8F38\u5165\u4F60\u7684\u5E33\u865F ID\u3002"}');


var $2b89d534ebe87992$exports = {};
$2b89d534ebe87992$exports = JSON.parse('{"webshop_offer_voucher_correctCode":"\u8F38\u5165\u7684\u4EE3\u78BC\u6B63\u78BA","webShop_howToFindId_desc":"You can find and copy your personal ID in your player profile.","webShop_howToFindId_link":"Where do I find my personal ID?","webshop_offer_voucher_codeIsIncorrect":"\u4EE3\u78BC\u4E0D\u6B63\u78BA","webshop_offer_voucher_enterYourCode":"\u8F38\u5165\u4F60\u7684\u4EE3\u78BC","webShop_unexpectedError_desc":"An unexpected error occurred, please try again later.","webShop_accountBanned_desc":"Account banned!","webshop_confirm":"\u597D","webshop_offer_voucher_welcome_title":"Welcome, {{playername}}","webshop_continue":"Continue"}');


const $8109b97ec2c1d7ff$var$availableLanguages = {
    cs: (/*@__PURE__*/$parcel$interopDefault($98afe526f3d8cd1d$exports)),
    da: (/*@__PURE__*/$parcel$interopDefault($2c8bdf24769236f8$exports)),
    de: (/*@__PURE__*/$parcel$interopDefault($9f1152623e5714c5$exports)),
    el: (/*@__PURE__*/$parcel$interopDefault($35f3f576787e6916$exports)),
    en: (/*@__PURE__*/$parcel$interopDefault($817438c799bd82af$exports)),
    es: (/*@__PURE__*/$parcel$interopDefault($f1db60e624b8ff72$exports)),
    fi: (/*@__PURE__*/$parcel$interopDefault($1165680bd305d186$exports)),
    fr: (/*@__PURE__*/$parcel$interopDefault($76eca52131c5fdbb$exports)),
    hu: (/*@__PURE__*/$parcel$interopDefault($860fb862e63a637f$exports)),
    it: (/*@__PURE__*/$parcel$interopDefault($81b5d3fe09c339d1$exports)),
    ja: (/*@__PURE__*/$parcel$interopDefault($b60c5c71d6430161$exports)),
    ko: (/*@__PURE__*/$parcel$interopDefault($992f2b467276c334$exports)),
    nl: (/*@__PURE__*/$parcel$interopDefault($2a48123b997ada5e$exports)),
    no: (/*@__PURE__*/$parcel$interopDefault($29cf4b37873a953a$exports)),
    pl: (/*@__PURE__*/$parcel$interopDefault($ce671761a0a87f11$exports)),
    pt: (/*@__PURE__*/$parcel$interopDefault($467777f96d8a6934$exports)),
    ro: (/*@__PURE__*/$parcel$interopDefault($51e5426ba0aa35cf$exports)),
    ru: (/*@__PURE__*/$parcel$interopDefault($4a5180c99562fbcf$exports)),
    sk: (/*@__PURE__*/$parcel$interopDefault($07ee879a782c78bf$exports)),
    sv: (/*@__PURE__*/$parcel$interopDefault($8381fd879b458e22$exports)),
    tr: (/*@__PURE__*/$parcel$interopDefault($fedac20605d462c7$exports)),
    zh: (0, (/*@__PURE__*/$parcel$interopDefault($f23ad6d493b69e97$exports))),
    'en-us': (0, (/*@__PURE__*/$parcel$interopDefault($58a54afff3d24dfe$exports))),
    'pt-br': (0, (/*@__PURE__*/$parcel$interopDefault($3d53b803f5866eaa$exports))),
    'zh-cn': (0, (/*@__PURE__*/$parcel$interopDefault($4f82400818ea9bf5$exports))),
    'zh-hans': (0, (/*@__PURE__*/$parcel$interopDefault($f23ad6d493b69e97$exports))),
    'zh-hant': (0, (/*@__PURE__*/$parcel$interopDefault($3a53ac01a37ef9e4$exports))),
    'zh-tw': (0, (/*@__PURE__*/$parcel$interopDefault($2b89d534ebe87992$exports)))
};
const $8109b97ec2c1d7ff$export$c2d6918ee454df48 = Object.keys($8109b97ec2c1d7ff$var$availableLanguages);
const $8109b97ec2c1d7ff$export$e715429495646215 = {
    webshop_offer_voucher_correctCode: '',
    webShop_howToFindId_desc: '',
    webShop_howToFindId_link: '',
    webshop_offer_voucher_codeIsIncorrect: '',
    webshop_offer_voucher_enterYourCode: '',
    webShop_unexpectedError_desc: '',
    webShop_accountBanned_desc: '',
    webshop_confirm: '',
    webshop_termsConditions_1: '',
    webshop_purchase_privacyPolicy: '',
    webshop_legal_1: '',
    webshop_support_1: '',
    mbs_access_welcome_desc: '',
    btn_login: '',
    mbs_access_error_sessionExpired_desc: ''
};
var $8109b97ec2c1d7ff$export$2e2bcd8739ae039 = $8109b97ec2c1d7ff$var$availableLanguages;


const $1b2b1750878f51e2$export$a984e488de492859 = {
    defaultLanguage: 'en',
    get language () {
        const userLocale = (0, $f148185795ca145e$export$180605366c04f0cd)();
        const formattedUserLocale = userLocale.toLowerCase().replace('_', '-');
        if ((0, $8109b97ec2c1d7ff$export$c2d6918ee454df48).includes(formattedUserLocale)) return formattedUserLocale;
        const userLocaleWithoutRegion = formattedUserLocale.slice(0, 2);
        if ((0, $8109b97ec2c1d7ff$export$c2d6918ee454df48).includes(userLocaleWithoutRegion)) return userLocaleWithoutRegion;
        return this.defaultLanguage;
    },
    get languageWithoutRegion () {
        return this.language.slice(0, 2);
    },
    get texts () {
        const isLanguageAvailable = this.language in (0, $8109b97ec2c1d7ff$export$2e2bcd8739ae039);
        // There's already a validation to handle unsupported languages
        // This one is just one more fallback to english
        if (isLanguageAvailable) return (0, $8109b97ec2c1d7ff$export$2e2bcd8739ae039)[this.language];
        return (0, $8109b97ec2c1d7ff$export$2e2bcd8739ae039)[this.defaultLanguage];
    },
    init () {
        (0, $f148185795ca145e$export$3447b803a5f9c7a0)(this.texts);
        this.translateLegalLinks();
    },
    getTranslatedText (label) {
        return this.texts[label];
    },
    translateLegalLinks () {
        $1b2b1750878f51e2$export$7a5d735b2ab6389d.termsLink.href = (0, $38f51f2d8fd307c2$export$7a948dda2e5abcb7).getTermsLink(this.languageWithoutRegion);
        $1b2b1750878f51e2$export$7a5d735b2ab6389d.legalLink.href = (0, $38f51f2d8fd307c2$export$7a948dda2e5abcb7).getLegalLink(this.languageWithoutRegion);
        $1b2b1750878f51e2$export$7a5d735b2ab6389d.supportLink.href = (0, $38f51f2d8fd307c2$export$7a948dda2e5abcb7).getSupportLink(this.languageWithoutRegion, (0, $38f51f2d8fd307c2$export$1b00a204b1f1aa92));
    }
};
const $1b2b1750878f51e2$var$getSessionId = ()=>{
    const queryParameters = new URLSearchParams(window.location.search);
    const sid = queryParameters.get('sid');
    return sid !== null && sid !== void 0 ? sid : (0, $aa0bbc811b0c1b57$export$2e2bcd8739ae039)();
};
/*
    Session ID priority order:
    1. mbsSession cookie
    2. sid query parameter
    3. uuid
*/ let $1b2b1750878f51e2$var$SESSION_ID = $1b2b1750878f51e2$var$getSessionId();
let $1b2b1750878f51e2$var$sharedTrackingData = {
    zoneId: -1,
    networkId: -1,
    instanceId: -1,
    playerId: -1
};
const $1b2b1750878f51e2$export$593fa4e2a48c3c25 = async (trackingData)=>{
    const formattedTrackingData = (0, $9fceebefc81b9e0c$export$71511d61b312f219)((0, $cd54608a2366dcc8$export$71511d61b312f219)((0, $9fceebefc81b9e0c$export$71511d61b312f219)((0, $cd54608a2366dcc8$export$71511d61b312f219)({
        gameId: (0, $38f51f2d8fd307c2$export$1b00a204b1f1aa92)
    }, $1b2b1750878f51e2$var$sharedTrackingData), {
        isAutoLoggedIn: 0
    }), trackingData), {
        eventId: (0, $38f51f2d8fd307c2$export$8b0894f4c14eda03),
        date: new Date().toUTCString(),
        microtime: Date.now(),
        sessionId: $1b2b1750878f51e2$var$SESSION_ID
    });
    return (0, $f148185795ca145e$export$74584b47fd40751e)(formattedTrackingData);
};
const $1b2b1750878f51e2$export$e4771ae2bc0f2ca2 = async ()=>{
    const formattedTrackingData = (0, $9fceebefc81b9e0c$export$71511d61b312f219)((0, $cd54608a2366dcc8$export$71511d61b312f219)({
        gameId: (0, $38f51f2d8fd307c2$export$1b00a204b1f1aa92)
    }, $1b2b1750878f51e2$var$sharedTrackingData), {
        sessionId: $1b2b1750878f51e2$var$SESSION_ID,
        eventId: (0, $38f51f2d8fd307c2$export$d37404c264af2f19),
        date: new Date().toUTCString(),
        microtime: Date.now(),
        unixtimeMS: Date.now(),
        sourceId: 'MBS'
    });
    return (0, $f148185795ca145e$export$74584b47fd40751e)(formattedTrackingData);
};
const $1b2b1750878f51e2$export$4adfdf36e0b63527 = ()=>{
    sessionStorage.setItem('autologin', 'false');
    const mbsSessionCookie = (0, (/*@__PURE__*/$parcel$interopDefault($36139e949b21be0d$exports))).get('mbsSession');
    if (!mbsSessionCookie) return false;
    const mbsSessionData = JSON.parse(decodeURIComponent(mbsSessionCookie));
    const { playerName: playerName, zoneId: zoneId, criteria: criteria, sid: sid, playerId: playerId, networkId: networkId, instanceId: instanceId, isTempserver: isTempserver } = mbsSessionData;
    $1b2b1750878f51e2$var$sharedTrackingData = {
        zoneId: Number(zoneId),
        playerId: playerId,
        networkId: networkId,
        instanceId: instanceId
    };
    $1b2b1750878f51e2$var$SESSION_ID = sid;
    $1b2b1750878f51e2$export$23acd045a5f13e20(playerName, zoneId, criteria, isTempserver);
    sessionStorage.setItem('autologin', 'true');
    return true;
};
const $1b2b1750878f51e2$export$34a12a01a131b126 = ()=>{
    const sessionCode = sessionStorage.getItem('code');
    if (sessionCode) $1b2b1750878f51e2$export$7a5d735b2ab6389d.input.value = sessionCode;
};
const $1b2b1750878f51e2$export$e6e61eb911209324 = ()=>{
    const queryParameters = new URLSearchParams(window.location.search);
    const hasError = queryParameters.has('errorStatusCode');
    if (!hasError) return false;
    let errorMessage;
    var _queryParameters_get;
    const errorStatusCode = (_queryParameters_get = queryParameters.get('errorStatusCode')) !== null && _queryParameters_get !== void 0 ? _queryParameters_get : '';
    switch(errorStatusCode){
        case '404':
            errorMessage = $1b2b1750878f51e2$export$a984e488de492859.getTranslatedText('webshop_offer_voucher_codeIsIncorrect');
            break;
        case '423':
            errorMessage = $1b2b1750878f51e2$export$a984e488de492859.getTranslatedText('webShop_accountBanned_desc');
            break;
        case '498':
            errorMessage = $1b2b1750878f51e2$export$a984e488de492859.getTranslatedText('mbs_access_error_sessionExpired_desc');
            break;
        default:
            (0, $f148185795ca145e$export$275a2173e9d84865)(`Error returned from validate API: ${errorStatusCode}`);
            errorMessage = $1b2b1750878f51e2$export$a984e488de492859.getTranslatedText('webShop_unexpectedError_desc');
            break;
    }
    $1b2b1750878f51e2$export$ef8e8b39ab9323e1(true, errorMessage, true);
    return true;
};
const $1b2b1750878f51e2$export$7a5d735b2ab6389d = {
    feedbackMessage: document.querySelector('#feedback-message'),
    feedbackMessageBox: document.querySelector('#feedback-message-box'),
    input: document.querySelector('#shoppingCode'),
    btnOk: document.querySelector('#btn-ok'),
    btnContinue: document.querySelector('#btn-continue'),
    codeForm: document.querySelector('#code-form'),
    autoLoginForm: document.querySelector('#autologin-form'),
    btnFindCode: document.querySelector('#btn-find-code'),
    findCodeModal: document.querySelector('#find-code-modal'),
    termsLink: document.querySelector('#terms-link'),
    legalLink: document.querySelector('#legal-link'),
    supportLink: document.querySelector('#support-link'),
    welcomeTitle: document.querySelector('#welcome-title')
};
const $1b2b1750878f51e2$export$23acd045a5f13e20 = (playerName, zoneId, criteria, isTempserver)=>{
    $1b2b1750878f51e2$export$7a5d735b2ab6389d.welcomeTitle.textContent = $1b2b1750878f51e2$export$a984e488de492859.getTranslatedText('mbs_access_welcome_desc').replace('{0}', playerName);
    $1b2b1750878f51e2$export$7a5d735b2ab6389d.autoLoginForm.classList.toggle('d-none', false);
    window.addEventListener('load', function() {
        var _window_CanvasAgent;
        if (typeof ((_window_CanvasAgent = window.CanvasAgent) === null || _window_CanvasAgent === void 0 ? void 0 : _window_CanvasAgent.create) === 'function') {
            const tokenCookie = (0, (/*@__PURE__*/$parcel$interopDefault($36139e949b21be0d$exports))).get('token');
            if (!tokenCookie) return false;
            window.CanvasAgent.create({
                authClientId: 'lemonstand',
                canvasAppId: "SET_CORRECT_ID",
                token: tokenCookie,
                debug: "false",
                locale: $1b2b1750878f51e2$var$getSupportedIgsLocale($1b2b1750878f51e2$export$a984e488de492859.language)
            }).then((res)=>{
                $1b2b1750878f51e2$export$bef1f36f5486a6a3('Canvas agent initiated');
                window.CanvasAgent.instance = res;
                $1b2b1750878f51e2$export$7a5d735b2ab6389d.btnContinue.addEventListener('click', (event)=>{
                    event.preventDefault();
                    event.stopPropagation();
                    res.show();
                    return false;
                });
            }).catch((error)=>{
                console.error('Cannot create instance of Canvas', error);
            });
        } else {
            // Store the success URL for navigation after tracking
            const successUrl = $1b2b1750878f51e2$export$ce5a0e3c9b89f8c9({
                zoneId: zoneId,
                criteria: criteria,
                isTempserver: isTempserver
            });
            $1b2b1750878f51e2$export$7a5d735b2ab6389d.autoLoginForm.dataset.successUrl = successUrl;
        }
    });
};
const $1b2b1750878f51e2$export$f5bae168354f5b42 = ()=>{
    $1b2b1750878f51e2$export$7a5d735b2ab6389d.codeForm.classList.toggle('d-none', false);
};
const $1b2b1750878f51e2$export$ef8e8b39ab9323e1 = (doDisplay, message = '', isError = false)=>{
    $1b2b1750878f51e2$export$7a5d735b2ab6389d.input.style.color = isError ? '#FF5666' : '#9FFFCB';
    $1b2b1750878f51e2$export$7a5d735b2ab6389d.feedbackMessage.textContent = message;
    $1b2b1750878f51e2$export$7a5d735b2ab6389d.feedbackMessageBox.classList.toggle('d-none', !doDisplay);
};
const $1b2b1750878f51e2$export$d675b3969e4857cb = {
    enable () {
        $1b2b1750878f51e2$export$7a5d735b2ab6389d.btnOk.removeAttribute('disabled');
        $1b2b1750878f51e2$export$7a5d735b2ab6389d.btnOk.classList.remove('disabled');
    },
    disable () {
        $1b2b1750878f51e2$export$7a5d735b2ab6389d.btnOk.setAttribute('disabled', 'true');
        $1b2b1750878f51e2$export$7a5d735b2ab6389d.btnOk.classList.add('disabled');
    },
    toggle () {
        $1b2b1750878f51e2$export$7a5d735b2ab6389d.btnOk.toggleAttribute('disabled');
        $1b2b1750878f51e2$export$7a5d735b2ab6389d.btnOk.classList.toggle('disabled');
    }
};
const $1b2b1750878f51e2$var$getSupportedIgsLocale = (language)=>{
    // Supported chinese variations
    // 'zh-CN', 'zh-Hans', 'zh-Hant', 'zh-TW'
    // TODO: after PMT-2369 is done, we dont need to worry about formatting the locale before sending to IGS
    const igsSpecificLocaleMapper = new Map([
        [
            'zh',
            'zh-Hans'
        ],
        [
            'zh-cn',
            'zh-Hans'
        ],
        [
            'zh-hans',
            'zh-Hans'
        ],
        [
            'zh-tw',
            'zh-Hant'
        ],
        [
            'zh-hant',
            'zh-Hant'
        ]
    ]);
    if (igsSpecificLocaleMapper.has(language)) return igsSpecificLocaleMapper.get(language);
    return $1b2b1750878f51e2$export$a984e488de492859.languageWithoutRegion;
};
const $1b2b1750878f51e2$export$ce5a0e3c9b89f8c9 = ({ zoneId: zoneId = '', criteria: criteria = '', isTempserver: isTempserver = false } = {})=>{
    const supportedIgsLocale = $1b2b1750878f51e2$var$getSupportedIgsLocale($1b2b1750878f51e2$export$a984e488de492859.language);
    const queryParameters = (0, $cd54608a2366dcc8$export$71511d61b312f219)({
        locale: supportedIgsLocale,
        sid: $1b2b1750878f51e2$var$SESSION_ID,
        standalone: '1',
        callOrigin: window.location.href,
        'lemonstand.customization.url': isTempserver ? "https://cdn.jsdelivr.net/npm/@lemonstand.org/config-goodgamestudios@ef/dist/goodgamestudios-mbs-temp.json" : "https://cdn.jsdelivr.net/npm/@lemonstand.org/config-goodgamestudios@ef/dist/goodgamestudios-mbs.json"
    }, zoneId ? {
        zoneId: zoneId
    } : {}, criteria ? {
        criteria: criteria
    } : {});
    const formattedParameters = new URLSearchParams(queryParameters).toString();
    // Choose webshop link based on current domain
    // goodgamestudios.com uses _GGS URLs, ggs-ep.com uses _EP URLs
    const isGoodGameDomain = window.location.origin.includes('goodgamestudios.com');
    const baseUrl = isGoodGameDomain ? "https://ef-canvas.public.ggs-ep.com" : "https://ef-canvas.public.ggs-ep.com";
    const webshopLink = `${baseUrl}?${formattedParameters}`;
    return webshopLink;
};
const $1b2b1750878f51e2$export$50b7a8a7b6f81872 = ()=>{
    const queryParameters = {
        lang: $1b2b1750878f51e2$export$a984e488de492859.language,
        sid: $1b2b1750878f51e2$var$SESSION_ID
    };
    const formattedParameters = new URLSearchParams(queryParameters).toString();
    const webshopLink = `${window.location.origin}${window.location.pathname}?${formattedParameters}`;
    return webshopLink;
};
const $1b2b1750878f51e2$export$d097bb02eb6577bb = ()=>{
    // Choose accounts service based on current domain to maintain domain consistency
    // goodgamestudios.com uses _GGS URLs, ggs-ep.com uses _EP URLs
    const isGoodGameDomain = window.location.origin.includes('goodgamestudios.com');
    const accountsServiceUrl = isGoodGameDomain ? "https://accounts.public.ggs-ep.com/login/lemonstand" : "https://accounts.public.ggs-ep.com/login/lemonstand";
    $1b2b1750878f51e2$export$7a5d735b2ab6389d.codeForm.setAttribute('action', accountsServiceUrl);
    (0, $f148185795ca145e$export$dfe04b9b30f4004a)('errorUrl', $1b2b1750878f51e2$export$50b7a8a7b6f81872(), $1b2b1750878f51e2$export$7a5d735b2ab6389d.codeForm);
};
const $1b2b1750878f51e2$export$6a874b7a74007875 = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($36139e949b21be0d$exports))).remove('mbsSession', {
        path: '/',
        domain: '.ggs-ep.com'
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($36139e949b21be0d$exports))).remove('mbsSession', {
        path: '/',
        domain: '.goodgamestudios.com'
    });
};
const $1b2b1750878f51e2$export$bef1f36f5486a6a3 = (...args)=>{
    console.debug('%c CANVAS ->', 'background: pink; color: #bada55, font-size:20px', ...args);
};
const $1b2b1750878f51e2$export$2241d74381e8e4f2 = (src)=>{
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.type = 'module';
    script.async = false;
    script.blocking = true;
    script.src = src;
    const head = document.head;
    head.insertBefore(script, head.firstElementChild);
    $1b2b1750878f51e2$export$bef1f36f5486a6a3('loadScript done');
};


// TODO: delete `if` during a permanent switch from Lemonstand to Canvas
// Check localstore for special flags (temporary until total Lemonstand replacement)
if (localStorage.getItem('cxf_canvas') === 'enabled') (0, $1b2b1750878f51e2$export$2241d74381e8e4f2)("https://app.canvas.stillfront.com/agent.js");
document.addEventListener('DOMContentLoaded', async ()=>{
    var _elements_input_value;
    (0, $1b2b1750878f51e2$export$a984e488de492859).init();
    const wasErrorHandled = (0, $1b2b1750878f51e2$export$e6e61eb911209324)();
    const isAutoLoggedIn = (0, $1b2b1750878f51e2$export$4adfdf36e0b63527)();
    // With this we are able to identify the loading from the user and ignore those from the error url
    const isFirstLoad = !wasErrorHandled;
    if (!isAutoLoggedIn || !isFirstLoad) (0, $1b2b1750878f51e2$export$f5bae168354f5b42)();
    if (isFirstLoad) await (0, $1b2b1750878f51e2$export$593fa4e2a48c3c25)({
        actionType: (0, $38f51f2d8fd307c2$export$7b541698c79bb80a).PAGE_LOADED,
        isAutoLoggedIn: isAutoLoggedIn ? 1 : 0
    });
    if (!isAutoLoggedIn) (0, $1b2b1750878f51e2$export$34a12a01a131b126)();
    if ((_elements_input_value = (0, $1b2b1750878f51e2$export$7a5d735b2ab6389d).input.value) === null || _elements_input_value === void 0 ? void 0 : _elements_input_value.trim()) (0, $1b2b1750878f51e2$export$d675b3969e4857cb).enable();
});
(0, $1b2b1750878f51e2$export$7a5d735b2ab6389d).input.addEventListener('input', ()=>{
    (0, $1b2b1750878f51e2$export$ef8e8b39ab9323e1)(false);
    const code = (0, $1b2b1750878f51e2$export$7a5d735b2ab6389d).input.value;
    if (code.trim()) (0, $1b2b1750878f51e2$export$d675b3969e4857cb).enable();
    else (0, $1b2b1750878f51e2$export$d675b3969e4857cb).disable();
});
(0, $1b2b1750878f51e2$export$7a5d735b2ab6389d).codeForm.addEventListener('submit', (event)=>{
    const code = (0, $1b2b1750878f51e2$export$7a5d735b2ab6389d).input.value;
    if (!code) {
        event.preventDefault();
        (0, $1b2b1750878f51e2$export$d675b3969e4857cb).disable();
        return;
    }
    sessionStorage.setItem('code', code);
    (0, $1b2b1750878f51e2$export$d097bb02eb6577bb)();
});
(0, $1b2b1750878f51e2$export$7a5d735b2ab6389d).autoLoginForm.addEventListener('submit', async (event)=>{
    // Prevent default form submission to preserve query parameters
    event.preventDefault();
    sessionStorage.removeItem('autologin');
    (0, $1b2b1750878f51e2$export$6a874b7a74007875)();
    await Promise.all([
        (0, $1b2b1750878f51e2$export$593fa4e2a48c3c25)({
            actionType: (0, $38f51f2d8fd307c2$export$7b541698c79bb80a).CORRECT_CODE_ENTRY,
            isAutoLoggedIn: 1
        }),
        (0, $1b2b1750878f51e2$export$e4771ae2bc0f2ca2)()
    ]);
    // Get the success URL stored in the form's dataset
    const successUrl = (0, $1b2b1750878f51e2$export$7a5d735b2ab6389d).autoLoginForm.dataset.successUrl;
    // Navigate to the success URL with all query parameters preserved
    if (successUrl) window.location.href = successUrl;
});
(0, $1b2b1750878f51e2$export$7a5d735b2ab6389d).btnFindCode.addEventListener('click', ()=>{
    const findCodeModal = new $bc78252b337306e3$export$2b77a92f1a5ad772((0, $1b2b1750878f51e2$export$7a5d735b2ab6389d).findCodeModal);
    findCodeModal.show();
});


//# sourceMappingURL=index.7c4c8cfc.js.map
